module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "022e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseTextarea_vue_vue_type_style_index_0_id_addd61d2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d811");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseTextarea_vue_vue_type_style_index_0_id_addd61d2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseTextarea_vue_vue_type_style_index_0_id_addd61d2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "04e9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "0bec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseSmartScroller_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d178");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseSmartScroller_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseSmartScroller_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0e75":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var stickyHelpers = __webpack_require__("9f7f");

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? S.slice(q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, UNSUPPORTED_Y);


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1f4a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseHeader_vue_vue_type_style_index_0_id_7517c275_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2ab7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseHeader_vue_vue_type_style_index_0_id_7517c275_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseHeader_vue_vue_type_style_index_0_id_7517c275_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2ab7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "3757":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "390a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3b15":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "43a3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseToggleSwitcher_vue_vue_type_style_index_0_id_5bdbcfe0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0e75");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseToggleSwitcher_vue_vue_type_style_index_0_id_5bdbcfe0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseToggleSwitcher_vue_vue_type_style_index_0_id_5bdbcfe0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "49b2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4d49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseUnitSelect_vue_vue_type_style_index_0_id_68f230e8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cdf3");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseUnitSelect_vue_vue_type_style_index_0_id_68f230e8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseUnitSelect_vue_vue_type_style_index_0_id_68f230e8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4e53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseTextDivider_vue_vue_type_style_index_0_id_22b9d50b_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f405");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseTextDivider_vue_vue_type_style_index_0_id_22b9d50b_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseTextDivider_vue_vue_type_style_index_0_id_22b9d50b_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5056":
/***/ (function(module) {

module.exports = JSON.parse("{\"arkit\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"ARKit\\\">\\n<g id=\\\"Group 15\\\">\\n<path id=\\\"Vector 8 (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.9751 0.262268L22.0984 6.14573V17.9148L11.9752 23.7369L1.9118 17.9143V6.14615L11.9751 0.262268ZM11.7387 0.953614L2.62159 6.28425L11.7387 11.6149V0.953614ZM11.5025 12.0299L2.38539 6.69925V17.3605L11.5025 12.0299ZM2.62345 17.7744L11.7387 23.0485V12.4449L2.62345 17.7744ZM12.2123 12.4436V23.0497L21.3846 17.7744L12.2123 12.4436ZM21.6248 17.3618L12.4506 12.0299L21.6248 6.69801V17.3618ZM21.3865 6.28425L12.2123 11.6161V0.952371L21.3865 6.28425Z\\\" />\\n<path id=\\\"Vector 1 (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.7071 0.073376C11.873 -0.0244587 12.0781 -0.0244587 12.244 0.073376L15.0855 1.74919C15.3397 1.89908 15.4255 2.22891 15.2772 2.48588C15.129 2.74284 14.8027 2.82964 14.5486 2.67974L12.5083 1.47647V4.18953C12.5083 4.48702 12.2698 4.72818 11.9755 4.72818C11.6813 4.72818 11.4427 4.48702 11.4427 4.18953V1.47647L9.40246 2.67974C9.14829 2.82964 8.82206 2.74284 8.6738 2.48588C8.52554 2.22891 8.61139 1.89908 8.86555 1.74919L11.7071 0.073376Z\\\" />\\n<path id=\\\"Vector 7 (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8.91207 10.1999C9.06176 9.94374 9.38848 9.85881 9.6418 10.0101L11.9755 11.4043L14.3092 10.0101C14.5625 9.85881 14.8892 9.94374 15.0389 10.1999C15.1886 10.456 15.1046 10.7863 14.8512 10.9376L12.5083 12.3374V15.0824C12.5083 15.3799 12.2697 15.621 11.9755 15.621C11.6812 15.621 11.4427 15.3799 11.4427 15.0824V12.3374L9.09972 10.9376C8.84639 10.7863 8.76238 10.456 8.91207 10.1999Z\\\" />\\n<path id=\\\"Vector 6 (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.7071 23.9266C11.873 24.0245 12.0781 24.0245 12.244 23.9266L15.0855 22.2508C15.3397 22.1009 15.4255 21.7711 15.2772 21.5141C15.129 21.2572 14.8027 21.1704 14.5486 21.3203L12.5083 22.5235V19.8105C12.5083 19.513 12.2698 19.2718 11.9755 19.2718C11.6813 19.2718 11.4427 19.513 11.4427 19.8105V22.5235L9.40246 21.3203C9.14829 21.1704 8.82206 21.2572 8.6738 21.5141C8.52554 21.7711 8.61139 22.1009 8.86555 22.2508L11.7071 23.9266Z\\\" />\\n<path id=\\\"Vector 2 (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1.61582 6.26087C1.61496 6.06671 1.71752 5.8871 1.88427 5.79078L4.74051 4.14075C4.99599 3.99316 5.32145 4.0829 5.46743 4.3412C5.61341 4.5995 5.52464 4.92853 5.26916 5.07612L3.21831 6.26088L5.54229 7.61741C5.79711 7.76616 5.88442 8.09559 5.7373 8.35323C5.59018 8.61086 5.26433 8.69913 5.0095 8.55039L2.68553 7.19386L2.6961 9.58189C2.69742 9.87938 2.45995 10.1216 2.16571 10.123C1.87146 10.1243 1.63186 9.8842 1.63054 9.58671L1.61582 6.26087Z\\\" />\\n<path id=\\\"Vector 5 (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1.61582 17.7773C1.61496 17.9715 1.71752 18.1511 1.88427 18.2474L4.74051 19.8974C4.99599 20.045 5.32145 19.9553 5.46743 19.697C5.61341 19.4387 5.52464 19.1096 5.26916 18.9621L3.21831 17.7773L5.54229 16.4208C5.79711 16.272 5.88442 15.9426 5.7373 15.685C5.59018 15.4273 5.26433 15.339 5.0095 15.4878L2.68553 16.8443L2.6961 14.4563C2.69742 14.1588 2.45995 13.9166 2.16571 13.9152C1.87146 13.9139 1.63186 14.154 1.63054 14.4515L1.61582 17.7773Z\\\" />\\n<path id=\\\"Vector 3 (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M22.3842 6.26087C22.385 6.06671 22.2825 5.8871 22.1157 5.79078L19.2595 4.14075C19.004 3.99316 18.6786 4.0829 18.5326 4.3412C18.3866 4.5995 18.4754 4.92853 18.7308 5.07612L20.7817 6.26088L18.4577 7.61741C18.2029 7.76616 18.1156 8.09559 18.2627 8.35323C18.4098 8.61086 18.7357 8.69913 18.9905 8.55039L21.3145 7.19386L21.3039 9.58189C21.3026 9.87938 21.54 10.1216 21.8343 10.123C22.1285 10.1243 22.3681 9.8842 22.3695 9.58671L22.3842 6.26087Z\\\" />\\n<path id=\\\"Vector 4 (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M22.3842 17.7773C22.385 17.9715 22.2825 18.1511 22.1157 18.2474L19.2595 19.8974C19.004 20.045 18.6786 19.9553 18.5326 19.697C18.3866 19.4387 18.4754 19.1096 18.7308 18.9621L20.7817 17.7773L18.4577 16.4208C18.2029 16.272 18.1156 15.9426 18.2627 15.685C18.4098 15.4273 18.7357 15.339 18.9905 15.4878L21.3145 16.8443L21.3039 14.4563C21.3026 14.1588 21.54 13.9166 21.8343 13.9152C22.1285 13.9139 22.3681 14.154 22.3695 14.4515L22.3842 17.7773Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"activity\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Activity\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M9 2C9.43043 2 9.81257 2.27543 9.94868 2.68377L15 17.8377L17.0513 11.6838C17.1874 11.2754 17.5696 11 18 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H18.7208L15.9487 21.3162C15.8126 21.7246 15.4304 22 15 22C14.5696 22 14.1874 21.7246 14.0513 21.3162L9 6.16228L6.94868 12.3162C6.81257 12.7246 6.43043 13 6 13H2C1.44772 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11H5.27924L8.05132 2.68377C8.18743 2.27543 8.56957 2 9 2Z\\\" />\\n</g>\\n</svg>\\n\",\"alert-circle\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Alert-circle\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 7C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V8C11 7.44772 11.4477 7 12 7ZM11 16C11 15.4477 11.4477 15 12 15H12.01C12.5623 15 13.01 15.4477 13.01 16C13.01 16.5523 12.5623 17 12.01 17H12C11.4477 17 11 16.5523 11 16Z\\\" />\\n</g>\\n</svg>\\n\",\"allert-filled\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Allert - Filled\\\">\\n<path id=\\\"Vector\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M10.4572 1.74279C10.9282 1.47435 11.4595 1.33333 12 1.33333C12.5405 1.33333 13.0718 1.47435 13.5428 1.74279C14.0137 2.01122 14.4084 2.39802 14.6887 2.86584L14.6917 2.87088L23.5701 17.8764L23.5786 17.8911C23.8532 18.3725 23.9985 18.9183 24 19.4742C24.0015 20.0301 23.8593 20.5767 23.5874 21.0596C23.3154 21.5426 22.9234 21.945 22.4501 22.227C21.9769 22.5089 21.439 22.6604 20.8899 22.6665L20.8784 22.6667L3.11009 22.6666C2.56103 22.6605 2.02312 22.5089 1.54988 22.227C1.07664 21.945 0.68456 21.5426 0.412649 21.0596C0.140738 20.5767 -0.00152508 20.0301 1.23298e-05 19.4742C0.0015498 18.9183 0.146835 18.3725 0.421413 17.8911L0.429928 17.8764L9.30832 2.87089C9.58862 2.40306 9.98629 2.01122 10.4572 1.74279ZM13.0482 8.87084C13.0482 8.28475 12.5789 7.80963 12 7.80963C11.4211 7.80963 10.9518 8.28475 10.9518 8.87084V13.1157C10.9518 13.7018 11.4211 14.1769 12 14.1769C12.5789 14.1769 13.0482 13.7018 13.0482 13.1157V8.87084ZM10.9518 17.3605C10.9518 16.7744 11.4211 16.2993 12 16.2993H12.0105C12.5894 16.2993 13.0587 16.7744 13.0587 17.3605C13.0587 17.9466 12.5894 18.4217 12.0105 18.4217H12C11.4211 18.4217 10.9518 17.9466 10.9518 17.3605Z\\\" />\\n</g>\\n</svg>\\n\",\"allert-outlined\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Allert - Outlined\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M10.4572 1.74279C10.9282 1.47435 11.4595 1.33333 12 1.33333C12.5405 1.33333 13.0718 1.47435 13.5428 1.74279C14.0137 2.01122 14.4084 2.39802 14.6887 2.86584L14.6917 2.87088L23.5701 17.8764L23.5786 17.8911C23.8532 18.3725 23.9985 18.9183 24 19.4742C24.0015 20.0301 23.8593 20.5767 23.5874 21.0596C23.3154 21.5426 22.9234 21.945 22.4501 22.227C21.9769 22.5089 21.439 22.6604 20.8899 22.6665L20.8784 22.6667L3.11009 22.6666C2.56103 22.6605 2.02312 22.5089 1.54988 22.227C1.07664 21.945 0.68456 21.5426 0.412649 21.0596C0.140738 20.5767 -0.00152508 20.0301 1.23298e-05 19.4742C0.0015498 18.9183 0.146835 18.3725 0.421413 17.8911L0.429928 17.8764L9.30832 2.87089L10.2075 3.4162L9.31133 2.86584C9.59163 2.39802 9.98629 2.01122 10.4572 1.74279ZM11.105 3.96448L2.23344 18.9585C2.14416 19.1175 2.09694 19.2972 2.09644 19.4801C2.09592 19.6654 2.14335 19.8476 2.23398 20.0086C2.32462 20.1696 2.45531 20.3037 2.61306 20.3977C2.76943 20.4909 2.94697 20.5413 3.12831 20.5442H20.8717C21.053 20.5413 21.2306 20.4909 21.3869 20.3977C21.5447 20.3037 21.6754 20.1696 21.766 20.0086C21.8567 19.8476 21.9041 19.6654 21.9036 19.4801C21.9031 19.2972 21.8559 19.1175 21.7666 18.9586L12.8962 3.96659L12.895 3.96448C12.8016 3.80948 12.6705 3.68131 12.5143 3.59224C12.3573 3.50276 12.1802 3.45575 12 3.45575C11.8198 3.45575 11.6427 3.50276 11.4857 3.59224C11.3295 3.68131 11.1984 3.80948 11.105 3.96448Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 7.80963C12.5789 7.80963 13.0482 8.28475 13.0482 8.87084V13.1157C13.0482 13.7018 12.5789 14.1769 12 14.1769C11.4211 14.1769 10.9518 13.7018 10.9518 13.1157V8.87084C10.9518 8.28475 11.4211 7.80963 12 7.80963Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M10.9518 17.3605C10.9518 16.7744 11.4211 16.2993 12 16.2993H12.0105C12.5894 16.2993 13.0587 16.7744 13.0587 17.3605C13.0587 17.9466 12.5894 18.4217 12.0105 18.4217H12C11.4211 18.4217 10.9518 17.9466 10.9518 17.3605Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"android\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Android\\\">\\n<g id=\\\"Vector\\\">\\n<path d=\\\"M3.0001 9.0002C2.17211 9.0002 1.50012 9.67219 1.50012 10.5002V16.5001C1.50012 17.3281 2.17211 18.0001 3.0001 18.0001C3.82809 18.0001 4.50008 17.3281 4.50008 16.5001V10.5002C4.50008 9.67219 3.82809 9.0002 3.0001 9.0002Z\\\" />\\n<path d=\\\"M20.9999 9.0002C20.1719 9.0002 19.4999 9.67219 19.4999 10.5002V16.5001C19.4999 17.3281 20.1719 18.0001 20.9999 18.0001C21.8278 18.0001 22.4998 17.3281 22.4998 16.5001V10.5002C22.4998 9.67219 21.8278 9.0002 20.9999 9.0002Z\\\" />\\n<path d=\\\"M6.00006 9.0872V18.0871C6.00006 18.9151 6.67205 19.5871 7.50004 19.5871V22.5C7.50004 23.328 8.17203 24 9.00002 24C9.828 24 10.5 23.328 10.5 22.5V19.5871H13.5V22.5C13.5 23.328 14.1719 24 14.9999 24C15.8279 24 16.4999 23.328 16.4999 22.5V19.5871C17.3279 19.5871 17.9999 18.9151 17.9999 18.0871V9.0872H6.00006Z\\\" />\\n<path d=\\\"M6.00006 7.50022H17.9999C17.9999 5.61025 17.1089 3.94527 15.7439 2.84579L17.0789 1.22731C17.3429 0.907813 17.2979 0.43532 16.9784 0.171323C16.6574 -0.0911732 16.1864 -0.0476739 15.9224 0.271822L14.4629 2.0403C13.71 1.6998 12.8805 1.5003 12 1.5003C11.1075 1.5003 10.2675 1.7073 9.50701 2.0583L8.08653 0.282322C7.82703 -0.040174 7.35604 -0.0941732 7.03204 0.165323C6.70955 0.42482 6.65705 0.895813 6.91504 1.21981L8.23203 2.86679C6.88054 3.96627 6.00006 5.62225 6.00006 7.50022ZM13.5 3.75027C13.9139 3.75027 14.2499 4.08627 14.2499 4.50026C14.2499 4.91426 13.9139 5.25025 13.5 5.25025C13.086 5.25025 12.75 4.91426 12.75 4.50026C12.75 4.08627 13.086 3.75027 13.5 3.75027ZM10.5 3.75027C10.914 3.75027 11.25 4.08627 11.25 4.50026C11.25 4.91426 10.914 5.25025 10.5 5.25025C10.086 5.25025 9.75001 4.91426 9.75001 4.50026C9.75001 4.08627 10.086 3.75027 10.5 3.75027Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"apple\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Apple\\\">\\n<g id=\\\"Vector\\\">\\n<path d=\\\"M16.124 0C14.9512 0.0811244 13.5803 0.831869 12.7814 1.80949C12.0527 2.69636 11.4532 4.0136 11.6869 5.29371C12.9684 5.33359 14.2925 4.56497 15.0598 3.57085C15.7775 2.64548 16.3206 1.33649 16.124 0Z\\\" />\\n<path d=\\\"M20.7591 7.38095C19.633 5.96883 18.0504 5.14934 16.5558 5.14934C14.5826 5.14934 13.748 6.09396 12.3772 6.09396C10.9637 6.09396 9.8898 5.15209 8.18344 5.15209C6.50733 5.15209 4.72259 6.17645 3.59098 7.92819C2.00011 10.3949 2.27236 15.0328 4.85047 18.9831C5.77308 20.3966 7.00507 21.9861 8.61656 21.9998C10.0507 22.0136 10.4549 21.08 12.3978 21.0704C14.3406 21.0594 14.7091 22.0122 16.1405 21.9971C17.7534 21.9847 19.0527 20.2234 19.9754 18.8099C20.6367 17.7965 20.8828 17.2864 21.3957 16.1424C17.6654 14.722 17.0673 9.41731 20.7591 7.38095Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"arrow-down\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Arrow - Down\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.2929 16.7071C11.6834 17.0976 12.3166 17.0976 12.7071 16.7071L19.7071 9.70711C20.0976 9.31658 20.0976 8.68342 19.7071 8.29289C19.3166 7.90237 18.6834 7.90237 18.2929 8.29289L12 14.5858L5.70711 8.29289C5.31658 7.90237 4.68342 7.90237 4.29289 8.29289C3.90237 8.68342 3.90237 9.31658 4.29289 9.70711L11.2929 16.7071Z\\\" />\\n</g>\\n</svg>\\n\",\"arrow-left\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Arrow - Left\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M15.7071 4.29289C15.3166 3.90237 14.6834 3.90237 14.2929 4.29289L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071L14.2929 19.7071C14.6834 20.0976 15.3166 20.0976 15.7071 19.7071C16.0976 19.3166 16.0976 18.6834 15.7071 18.2929L9.41421 12L15.7071 5.70711C16.0976 5.31658 16.0976 4.68342 15.7071 4.29289Z\\\" />\\n</g>\\n</svg>\\n\",\"arrow-right\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Arrow - Right\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071C7.90237 19.3166 7.90237 18.6834 8.29289 18.2929L14.5858 12L8.29289 5.70711C7.90237 5.31658 7.90237 4.68342 8.29289 4.29289Z\\\" />\\n</g>\\n</svg>\\n\",\"arrow-up\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Arrow - Up\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L19.7071 14.2929C20.0976 14.6834 20.0976 15.3166 19.7071 15.7071C19.3166 16.0976 18.6834 16.0976 18.2929 15.7071L12 9.41421L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L11.2929 7.29289Z\\\" />\\n</g>\\n</svg>\\n\",\"arrow-tailed-down\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Arrow - tailed - down\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 4C12.5523 4 13 4.44772 13 5V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V5C11 4.44772 11.4477 4 12 4Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4.29289 11.2929C4.68342 10.9024 5.31658 10.9024 5.70711 11.2929L12 17.5858L18.2929 11.2929C18.6834 10.9024 19.3166 10.9024 19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071L12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"arrow-tailed-left\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Arrow - tailed - left\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12.7071 4.29289C13.0976 4.68342 13.0976 5.31658 12.7071 5.70711L6.41421 12L12.7071 18.2929C13.0976 18.6834 13.0976 19.3166 12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929L11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"arrow-tailed-right\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Arrow - tailed - right\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071L12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071C10.9024 19.3166 10.9024 18.6834 11.2929 18.2929L17.5858 12L11.2929 5.70711C10.9024 5.31658 10.9024 4.68342 11.2929 4.29289Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"arrow-tailed-up\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Arrow - tailed - up\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 4C12.5523 4 13 4.44772 13 5V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V5C11 4.44772 11.4477 4 12 4Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071C19.3166 13.0976 18.6834 13.0976 18.2929 12.7071L12 6.41421L5.70711 12.7071C5.31658 13.0976 4.68342 13.0976 4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929L11.2929 4.29289Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"bell-filled\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Bell - Filled\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M7.05024 3.05025C8.36299 1.7375 10.1435 1 12 1C13.8565 1 15.637 1.7375 16.9497 3.05025C18.2625 4.36301 19 6.14349 19 8C19 11.3527 19.7171 13.4346 20.3779 14.6461C20.7097 15.2544 21.0328 15.6535 21.2572 15.8904C21.3697 16.0091 21.458 16.0878 21.5113 16.1322C21.5379 16.1544 21.5557 16.168 21.5634 16.1737L21.5663 16.1758C21.9248 16.4221 22.0834 16.8725 21.9571 17.2898C21.8294 17.7115 21.4407 18 21 18H2.99999C2.55932 18 2.17059 17.7115 2.04289 17.2898C1.91655 16.8725 2.07519 16.4221 2.43368 16.1758L2.43653 16.1737C2.44423 16.168 2.46209 16.1544 2.48871 16.1322C2.54192 16.0878 2.63031 16.0091 2.74278 15.8904C2.96721 15.6535 3.2903 15.2544 3.62209 14.6461C4.28292 13.4346 4.99999 11.3527 4.99999 8C4.99999 6.14348 5.73748 4.36301 7.05024 3.05025Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M9.76822 20.135C10.2459 19.8579 10.8579 20.0205 11.135 20.4982C11.2229 20.6498 11.3491 20.7756 11.5009 20.863C11.6527 20.9504 11.8248 20.9965 12 20.9965C12.1752 20.9965 12.3473 20.9504 12.4991 20.863C12.6509 20.7756 12.7771 20.6498 12.865 20.4982C13.1421 20.0205 13.754 19.8579 14.2318 20.135C14.7095 20.4121 14.8721 21.024 14.595 21.5018C14.3313 21.9564 13.9528 22.3337 13.4973 22.5961C13.0419 22.8584 12.5256 22.9965 12 22.9965C11.4744 22.9965 10.9581 22.8584 10.5026 22.5961C10.0472 22.3337 9.6687 21.9564 9.40499 21.5018C9.12787 21.024 9.29049 20.4121 9.76822 20.135Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"bell-outlined\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Bell - Outlined\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M7.05024 3.05025C8.36299 1.7375 10.1435 1 12 1C13.8565 1 15.637 1.7375 16.9497 3.05025C18.2625 4.36301 19 6.14349 19 8C19 11.3527 19.7171 13.4346 20.3779 14.6461C20.7097 15.2544 21.0328 15.6535 21.2572 15.8904C21.3697 16.0091 21.458 16.0878 21.5113 16.1322C21.5379 16.1544 21.5557 16.168 21.5634 16.1737C21.5646 16.1746 21.5656 16.1753 21.5663 16.1758C21.9248 16.4221 22.0834 16.8725 21.9571 17.2898C21.8294 17.7115 21.4407 18 21 18H2.99999C2.55932 18 2.17059 17.7115 2.04289 17.2898C1.91655 16.8725 2.07519 16.4221 2.43368 16.1758C2.43438 16.1753 2.43533 16.1746 2.43653 16.1737C2.44423 16.168 2.46209 16.1544 2.48871 16.1322C2.54192 16.0878 2.63031 16.0091 2.74278 15.8904C2.96721 15.6535 3.2903 15.2544 3.62209 14.6461C4.28292 13.4346 4.99999 11.3527 4.99999 8C4.99999 6.14348 5.73748 4.36301 7.05024 3.05025ZM5.37788 15.6039C5.28192 15.7798 5.40631 16 5.60671 16H18.3933C18.5937 16 18.7181 15.7798 18.6221 15.6039C17.7829 14.0654 17 11.6473 17 8C17 6.67392 16.4732 5.40215 15.5355 4.46447C14.5978 3.52678 13.3261 3 12 3C10.6739 3 9.40213 3.52678 8.46445 4.46447C7.52677 5.40215 6.99999 6.67392 6.99999 8C6.99999 11.6473 6.21705 14.0654 5.37788 15.6039Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M9.76822 20.135C10.2459 19.8579 10.8579 20.0205 11.135 20.4982C11.2229 20.6498 11.3491 20.7756 11.5009 20.863C11.6527 20.9504 11.8248 20.9965 12 20.9965C12.1752 20.9965 12.3473 20.9504 12.4991 20.863C12.6509 20.7756 12.7771 20.6498 12.865 20.4982C13.1421 20.0205 13.754 19.8579 14.2318 20.135C14.7095 20.4121 14.8721 21.024 14.595 21.5018C14.3313 21.9564 13.9528 22.3337 13.4973 22.5961C13.0419 22.8584 12.5256 22.9965 12 22.9965C11.4744 22.9965 10.9581 22.8584 10.5026 22.5961C10.0472 22.3337 9.6687 21.9564 9.40499 21.5018C9.12787 21.024 9.29049 20.4121 9.76822 20.135Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"bulletlist\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Bullet list\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M7 6C7 5.44772 7.44772 5 8 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H8C7.44772 7 7 6.55228 7 6Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M7 12C7 11.4477 7.44772 11 8 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H8C7.44772 13 7 12.5523 7 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M7 18C7 17.4477 7.44772 17 8 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H8C7.44772 19 7 18.5523 7 18Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2 6C2 5.44772 2.44772 5 3 5H3.01C3.56228 5 4.01 5.44772 4.01 6C4.01 6.55228 3.56228 7 3.01 7H3C2.44772 7 2 6.55228 2 6Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2 12C2 11.4477 2.44772 11 3 11H3.01C3.56228 11 4.01 11.4477 4.01 12C4.01 12.5523 3.56228 13 3.01 13H3C2.44772 13 2 12.5523 2 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2 18C2 17.4477 2.44772 17 3 17H3.01C3.56228 17 4.01 17.4477 4.01 18C4.01 18.5523 3.56228 19 3.01 19H3C2.44772 19 2 18.5523 2 18Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"calendar-filled\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M5 5C4.44772 5 4 5.44772 4 6V9V11V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V11V9V6C20 5.44772 19.5523 5 19 5H5ZM2 6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V6Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M16 1C16.5523 1 17 1.44772 17 2V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V2C15 1.44772 15.4477 1 16 1Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8 1C8.55228 1 9 1.44772 9 2V6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6V2C7 1.44772 7.44772 1 8 1Z\\\" />\\n<path d=\\\"M4 11V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V11H4Z\\\" />\\n<path d=\\\"M20 9H4V11H20V9Z\\\" />\\n</svg>\\n\",\"calendar\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Calendar\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M5 5C4.44772 5 4 5.44772 4 6V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V6C20 5.44772 19.5523 5 19 5H5ZM2 6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V6Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M16 1C16.5523 1 17 1.44772 17 2V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V2C15 1.44772 15.4477 1 16 1Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8 1C8.55228 1 9 1.44772 9 2V6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6V2C7 1.44772 7.44772 1 8 1Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2 10C2 9.44771 2.44772 9 3 9H21C21.5523 9 22 9.44771 22 10C22 10.5523 21.5523 11 21 11H3C2.44772 11 2 10.5523 2 10Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"camera-filled\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Camera - Filled\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8.16795 2.4453C8.35342 2.1671 8.66565 2 9 2H15C15.3344 2 15.6466 2.1671 15.8321 2.4453L17.5352 5H21C21.7957 5 22.5587 5.31607 23.1213 5.87868C23.6839 6.44129 24 7.20435 24 8V19C24 19.7957 23.6839 20.5587 23.1213 21.1213C22.5587 21.6839 21.7957 22 21 22H3C2.20435 22 1.44129 21.6839 0.87868 21.1213C0.316071 20.5587 0 19.7957 0 19V8C0 7.20435 0.316071 6.44129 0.87868 5.87868C1.44129 5.31607 2.20435 5 3 5H6.46482L8.16795 2.4453ZM9.53518 4L7.83205 6.5547C7.64658 6.8329 7.33435 7 7 7H3C2.73478 7 2.48043 7.10536 2.29289 7.29289C2.10536 7.48043 2 7.73478 2 8V19C2 19.2652 2.10536 19.5196 2.29289 19.7071C2.48043 19.8946 2.73478 20 3 20H21C21.2652 20 21.5196 19.8946 21.7071 19.7071C21.8946 19.5196 22 19.2652 22 19V8C22 7.73478 21.8946 7.48043 21.7071 7.29289C21.5196 7.10536 21.2652 7 21 7H17C16.6656 7 16.3534 6.8329 16.1679 6.5547L14.4648 4H9.53518Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M7.83205 6.5547L9.53518 4H14.4648L16.1679 6.5547C16.3534 6.8329 16.6656 7 17 7H21C21.2652 7 21.5196 7.10536 21.7071 7.29289C21.8946 7.48043 22 7.73478 22 8V19C22 19.2652 21.8946 19.5196 21.7071 19.7071C21.5196 19.8946 21.2652 20 21 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V8C2 7.73478 2.10536 7.48043 2.29289 7.29289C2.48043 7.10536 2.73478 7 3 7H7C7.33435 7 7.64658 6.8329 7.83205 6.5547ZM7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13C17 15.7614 14.7614 18 12 18C9.23858 18 7 15.7614 7 13Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 8C9.23858 8 7 10.2386 7 13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13C17 10.2386 14.7614 8 12 8ZM12 9C10 9 8 11 8 13C8 15 10 17 12 17C14 17 16 15 16 13C16 11 14 9 12 9Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"camera-outlined\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Camera - Outlined\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8.16795 2.4453C8.35342 2.1671 8.66565 2 9 2H15C15.3344 2 15.6466 2.1671 15.8321 2.4453L17.5352 5H21C21.7957 5 22.5587 5.31607 23.1213 5.87868C23.6839 6.44129 24 7.20435 24 8V19C24 19.7957 23.6839 20.5587 23.1213 21.1213C22.5587 21.6839 21.7957 22 21 22H3C2.20435 22 1.44129 21.6839 0.87868 21.1213C0.316071 20.5587 0 19.7957 0 19V8C0 7.20435 0.316071 6.44129 0.87868 5.87868C1.44129 5.31607 2.20435 5 3 5H6.46482L8.16795 2.4453ZM9.53518 4L7.83205 6.5547C7.64658 6.8329 7.33435 7 7 7H3C2.73478 7 2.48043 7.10536 2.29289 7.29289C2.10536 7.48043 2 7.73478 2 8V19C2 19.2652 2.10536 19.5196 2.29289 19.7071C2.48043 19.8946 2.73478 20 3 20H21C21.2652 20 21.5196 19.8946 21.7071 19.7071C21.8946 19.5196 22 19.2652 22 19V8C22 7.73478 21.8946 7.48043 21.7071 7.29289C21.5196 7.10536 21.2652 7 21 7H17C16.6656 7 16.3534 6.8329 16.1679 6.5547L14.4648 4H9.53518Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10ZM7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13C17 15.7614 14.7614 18 12 18C9.23858 18 7 15.7614 7 13Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"car\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Car\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M5.2227 9.45509C7.05704 9.1013 9.53839 8.92857 11.9982 8.92857C14.4581 8.92857 16.9405 9.10132 18.7767 9.4551C18.6742 8.71683 18.3861 7.78644 17.9571 6.97738C17.6868 6.46773 17.3736 6.03137 17.0398 5.72835C16.7051 5.42443 16.386 5.28571 16.0909 5.28571H7.90909C7.61396 5.28571 7.29471 5.42446 6.95976 5.72843C6.62582 6.03147 6.31236 6.46785 6.04197 6.97746C5.61262 7.78666 5.32455 8.71704 5.2227 9.45509ZM6.32933 5.11086C6.76181 4.7184 7.29513 4.42857 7.90909 4.42857H16.0909C16.7049 4.42857 17.2381 4.71843 17.6704 5.11093C18.1037 5.50434 18.4723 6.03227 18.7702 6.59405C19.3628 7.71156 19.7273 9.06278 19.7273 10C19.7273 10.132 19.6628 10.2566 19.5525 10.3378C19.4422 10.419 19.2983 10.4478 19.1625 10.4158C17.3956 9.99957 14.7102 9.78571 11.9982 9.78571C9.28611 9.78571 6.60203 9.99958 4.83758 10.4158C4.70188 10.4478 4.55811 10.4191 4.4478 10.338C4.33748 10.2569 4.27291 10.1325 4.27272 10.0006C4.2714 9.06292 4.63602 7.71145 5.22894 6.59397C5.52703 6.03215 5.89585 5.50425 6.32933 5.11086Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4.72727 16C5.18182 16 5.18182 16 5.18182 16.4286V17.2857C5.18182 17.9958 4.5713 18.5714 3.81818 18.5714C3.06507 18.5714 2.45455 17.9958 2.45455 17.2857V16C2.90909 16 3.97416 16 4.72727 16ZM19.2727 16C20.0258 16 21.0909 16 21.5455 16V17.2857C21.5455 17.9958 20.9349 18.5714 20.1818 18.5714C19.4287 18.5714 18.8182 17.9958 18.8182 17.2857V16.4286C18.8182 16 18.8182 16 19.2727 16Z\\\" />\\n<path d=\\\"M4.93171 10.3828C5.1554 10.2766 5.2459 10.0197 5.13383 9.80834C5.02156 9.59663 4.74781 9.51116 4.52327 9.61701L4.52239 9.61744L4.52011 9.61852L4.51358 9.62167L4.49295 9.63189C4.47594 9.64045 4.45253 9.6525 4.42363 9.66807C4.36589 9.69918 4.2859 9.7445 4.19105 9.80412C4.00211 9.92288 3.75005 10.101 3.49677 10.3398C2.99268 10.8151 2.45455 11.5605 2.45455 12.5714V16C2.45455 16.2367 2.65805 16.4286 2.90909 16.4286H21.0909C21.3419 16.4286 21.5455 16.2367 21.5455 16V12.5714C21.5455 11.5605 21.0073 10.8151 20.5032 10.3398C20.25 10.101 19.9979 9.92288 19.809 9.80412C19.7141 9.7445 19.6341 9.69918 19.5764 9.66807C19.5475 9.6525 19.5241 9.64045 19.5071 9.63189L19.4864 9.62167L19.4799 9.61852L19.4776 9.61744L19.476 9.61667C19.2515 9.51082 18.9784 9.59663 18.8662 9.80834C18.754 10.0199 18.8451 10.2774 19.0695 10.3833L19.0792 10.3882C19.0889 10.393 19.1045 10.4011 19.1253 10.4123C19.167 10.4347 19.2291 10.4698 19.3047 10.5173C19.4567 10.6128 19.6591 10.7561 19.8604 10.9459C20.2654 11.3278 20.6364 11.868 20.6364 12.5714V14.7143C20.6364 15.1877 20.2294 15.5714 19.7273 15.5714H4.27273C3.77065 15.5714 3.36364 15.1877 3.36364 14.7143V12.5714C3.36364 11.868 3.73459 11.3278 4.13959 10.9459C4.34086 10.7561 4.54334 10.6128 4.69532 10.5173C4.77092 10.4698 4.83297 10.4347 4.87467 10.4123C4.89548 10.4011 4.91113 10.393 4.92076 10.3882L4.93055 10.3833L4.93171 10.3828Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.9982 10.2143C14.6354 10.2143 17.2209 10.4184 18.9373 10.8051C18.9683 10.8226 19.0074 10.8455 19.0525 10.8739C19.186 10.9578 19.3637 11.0837 19.539 11.2489C19.8941 11.5838 20.1818 12.0215 20.1818 12.5714V14.7143C20.1818 14.951 19.9783 15.1429 19.7273 15.1429H4.27273C4.02169 15.1429 3.81818 14.951 3.81818 14.7143V12.5714C3.81818 12.0215 4.10585 11.5838 4.46101 11.2489C4.63627 11.0837 4.81396 10.9578 4.94745 10.8739C4.99267 10.8455 5.03182 10.8225 5.06282 10.805C6.77668 10.4184 9.36094 10.2143 11.9982 10.2143ZM5.63636 13.4286C6.13844 13.4286 6.54545 13.0448 6.54545 12.5714C6.54545 12.098 6.13844 11.7143 5.63636 11.7143C5.13429 11.7143 4.72727 12.098 4.72727 12.5714C4.72727 13.0448 5.13429 13.4286 5.63636 13.4286ZM18.3636 13.4286C18.8657 13.4286 19.2727 13.0448 19.2727 12.5714C19.2727 12.098 18.8657 11.7143 18.3636 11.7143C17.8616 11.7143 17.4545 12.098 17.4545 12.5714C17.4545 13.0448 17.8616 13.4286 18.3636 13.4286ZM9.72728 11.7143H14.2727C15.2518 11.7143 15.2518 13 14.2727 13H9.72727C8.74827 13 8.74825 11.7143 9.72728 11.7143Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M7.90909 4C7.13542 4 6.49506 4.36564 6.01412 4.80208C5.53087 5.24063 5.13437 5.8143 4.82243 6.40222C4.29946 7.38786 3.94083 8.55557 3.84427 9.50852C3.65096 9.63618 3.41405 9.81172 3.17536 10.0368C2.62195 10.5586 2 11.4066 2 12.5714V17.7143C2 19 2 19 3.81818 19C4.81416 19 5.26458 19 5.46824 18.7886C5.63636 18.6142 5.63636 18.2957 5.63636 17.7143V16.8571H18.3636V17.7143C18.3636 18.2957 18.3636 18.6142 18.5318 18.7886C18.7354 19 19.1858 19 20.1818 19C21.1778 19 21.6282 19 21.8319 18.7886C22 18.6142 22 18.2957 22 17.7143V12.5714C22 11.4066 21.3781 10.5586 20.8246 10.0368C20.5857 9.81152 20.3486 9.63587 20.1552 9.50818C20.0579 8.55578 19.6995 7.38822 19.1768 6.40239C18.865 5.81452 18.4688 5.24082 17.9857 4.80223C17.5049 4.36571 16.8647 4 16.0909 4H7.90909ZM11.9982 10.2143C14.6354 10.2143 17.2209 10.4184 18.9373 10.8051C18.9683 10.8226 19.0074 10.8455 19.0525 10.8739C19.186 10.9578 19.3637 11.0837 19.539 11.2489C19.8941 11.5838 20.1818 12.0215 20.1818 12.5714V14.7143C20.1818 14.951 19.9783 15.1429 19.7273 15.1429H4.27273C4.02169 15.1429 3.81818 14.951 3.81818 14.7143V12.5714C3.81818 12.0215 4.10585 11.5838 4.46101 11.2489C4.63627 11.0837 4.81396 10.9578 4.94745 10.8739C4.99267 10.8455 5.03182 10.8225 5.06282 10.805C6.77668 10.4184 9.36094 10.2143 11.9982 10.2143ZM2.90909 17.2857V16.8571H4.72727V17.2857C4.72727 17.7591 4.32026 18.1429 3.81818 18.1429C3.3161 18.1429 2.90909 17.7591 2.90909 17.2857ZM2.90909 14.7143C2.90909 15.0436 3.04039 15.344 3.25632 15.5714L2.90909 15.5714V14.7143ZM21.0909 14.7143C21.0909 15.0436 20.9596 15.344 20.7437 15.5714H21.0909V14.7143ZM19.2727 17.2857V16.8571H21.0909V17.2857C21.0909 17.7591 20.6839 18.1429 20.1818 18.1429C19.6797 18.1429 19.2727 17.7591 19.2727 17.2857ZM5.2227 9.45509C7.05704 9.1013 9.53839 8.92857 11.9982 8.92857C14.4581 8.92857 16.9405 9.10132 18.7767 9.4551C18.6742 8.71683 18.3861 7.78644 17.9571 6.97738C17.6868 6.46773 17.3736 6.03137 17.0398 5.72835C16.7051 5.42443 16.386 5.28571 16.0909 5.28571H7.90909C7.61396 5.28571 7.29471 5.42446 6.95976 5.72843C6.62582 6.03147 6.31236 6.46785 6.04197 6.97746C5.61262 7.78666 5.32455 8.71704 5.2227 9.45509Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"cards-outlined\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8.22198 4C8.09925 4 7.99976 4.09949 7.99976 4.22222V15.7778C7.99976 15.9005 8.09925 16 8.22198 16H19.7775C19.9003 16 19.9998 15.9005 19.9998 15.7778V4.22222C19.9998 4.09949 19.9003 4 19.7775 4H8.22198ZM8.22198 2C6.99468 2 5.99976 2.99492 5.99976 4.22222V15.7778C5.99976 17.0051 6.99468 18 8.22198 18H19.7775C21.0048 18 21.9998 17.0051 21.9998 15.7778V4.22222C21.9998 2.99492 21.0048 2 19.7775 2H8.22198Z\\\" />\\n<path d=\\\"M4.22222 8C4.09949 8 4 8.09949 4 8.22222V19.7778C4 19.9005 4.09949 20 4.22222 20H15.7778C15.9005 20 16 19.9005 16 19.7778V19.1111H18V20C18 21.1046 17.1046 22 16 22H4C2.89543 22 2 21.1046 2 20V8C2 6.89543 2.89543 6 4 6H4.889V8H4.22222Z\\\" />\\n</svg>\\n\",\"cards-1\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Cards\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M10.9991 10.0005C10.4468 10.0005 9.99906 10.4482 9.99906 11.0005V20.0005C9.99906 20.5528 10.4468 21.0005 10.9991 21.0005H19.9991C20.5513 21.0005 20.9991 20.5528 20.9991 20.0005V11.0005C20.9991 10.4482 20.5513 10.0005 19.9991 10.0005H10.9991ZM7.99906 11.0005C7.99906 9.34362 9.34221 8.00047 10.9991 8.00047H19.9991C21.6559 8.00047 22.9991 9.34362 22.9991 11.0005V20.0005C22.9991 21.6573 21.6559 23.0005 19.9991 23.0005H10.9991C9.34221 23.0005 7.99906 21.6573 7.99906 20.0005V11.0005Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4.00092 2.99954C3.7357 2.99954 3.48135 3.1049 3.29381 3.29244C3.10627 3.47997 3.00092 3.73433 3.00092 3.99954V12.9995C3.00092 13.2648 3.10627 13.5191 3.29381 13.7067C3.48135 13.8942 3.7357 13.9995 4.00092 13.9995H5.00092C5.5532 13.9995 6.00092 14.4473 6.00092 14.9995C6.00092 15.5518 5.5532 15.9995 5.00092 15.9995H4.00092C3.20527 15.9995 2.4422 15.6835 1.8796 15.1209C1.31699 14.5583 1.00092 13.7952 1.00092 12.9995V3.99954C1.00092 3.20389 1.31699 2.44083 1.8796 1.87822C2.4422 1.31561 3.20527 0.999542 4.00092 0.999542H13.0009C13.7966 0.999542 14.5596 1.31561 15.1222 1.87822C15.6848 2.44083 16.0009 3.20389 16.0009 3.99954V4.99954C16.0009 5.55183 15.5532 5.99954 15.0009 5.99954C14.4486 5.99954 14.0009 5.55183 14.0009 4.99954V3.99954C14.0009 3.73433 13.8956 3.47997 13.708 3.29244C13.5205 3.1049 13.2661 2.99954 13.0009 2.99954H4.00092Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"checkmark\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Checkmark\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M21.6746 5.33795C22.1085 5.78856 22.1085 6.51913 21.6746 6.96974L9.45234 19.662C9.01843 20.1127 8.31491 20.1127 7.88099 19.662L2.32544 13.8928C1.89152 13.4422 1.89152 12.7116 2.32544 12.261C2.75935 11.8104 3.46287 11.8104 3.89679 12.261L8.66667 17.2144L20.1032 5.33795C20.5371 4.88735 21.2406 4.88735 21.6746 5.33795Z\\\" />\\n</g>\\n</svg>\\n\",\"clipboard-filled\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path d=\\\"M6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V6C19 5.73478 18.8946 5.48043 18.7071 5.29289C18.5196 5.10536 18.2652 5 18 5H17C17 6.10457 16.1046 7 15 7H9C7.89543 7 7 6.10457 7 5H6Z\\\" />\\n<path d=\\\"M5.29289 5.29289C5.48043 5.10536 5.73478 5 6 5H7V3H6C5.20435 3 4.44129 3.31607 3.87868 3.87868C3.31607 4.44129 3 5.20435 3 6V20C3 20.7957 3.31607 21.5587 3.87868 22.1213C4.44129 22.6839 5.20435 23 6 23H18C18.7957 23 19.5587 22.6839 20.1213 22.1213C20.6839 21.5587 21 20.7957 21 20V6C21 5.20435 20.6839 4.44129 20.1213 3.87868C19.5587 3.31607 18.7956 3 18 3H17V5H18C18.2652 5 18.5196 5.10536 18.7071 5.29289C18.8946 5.48043 19 5.73478 19 6V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H6C5.73478 21 5.48043 20.8946 5.29289 20.7071C5.10536 20.5196 5 20.2652 5 20V6C5 5.73478 5.10536 5.48043 5.29289 5.29289Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M9 1C7.89543 1 7 1.89543 7 3V5C7 6.10457 7.89543 7 9 7H15C16.1046 7 17 6.10457 17 5V3C17 1.89543 16.1046 1 15 1H9ZM9 3.5C9 3.22386 9.22386 3 9.5 3H14.5C14.7761 3 15 3.22386 15 3.5V4V4.5C15 4.77614 14.7761 5 14.5 5H9.5C9.22386 5 9 4.77614 9 4.5V4V3.5Z\\\" />\\n</svg>\\n\",\"clipboard-outlined\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M18 3C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H7C7 1.89543 7.89543 1 9 1H15C16.1046 1 17 1.89543 17 3H18ZM5.29289 5.29289C5.48043 5.10536 5.73478 5 6 5H7C7 6.10457 7.89543 7 9 7H15C16.1046 7 17 6.10457 17 5H18C18.2652 5 18.5196 5.10536 18.7071 5.29289C18.8946 5.48043 19 5.73478 19 6V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H6C5.73478 21 5.48043 20.8946 5.29289 20.7071C5.10536 20.5196 5 20.2652 5 20V6C5 5.73478 5.10536 5.48043 5.29289 5.29289ZM9 3.5C9 3.22386 9.22386 3 9.5 3H14.5C14.7761 3 15 3.22386 15 3.5V4.5C15 4.77614 14.7761 5 14.5 5H9.5C9.22386 5 9 4.77614 9 4.5V3.5Z\\\" />\\n</svg>\\n\",\"clipboard\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Clipboard\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V6C19 5.73478 18.8946 5.48043 18.7071 5.29289C18.5196 5.10536 18.2652 5 18 5H16C15.4477 5 15 4.55228 15 4C15 3.44772 15.4477 3 16 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H6Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M7 3C7 1.89543 7.89543 1 9 1H15C16.1046 1 17 1.89543 17 3V5C17 6.10457 16.1046 7 15 7H9C7.89543 7 7 6.10457 7 5V3ZM15 3H9V5H15V3Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"clock\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Clock\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 5C12.5523 5 13 5.44772 13 6V11.382L16.4472 13.1056C16.9412 13.3526 17.1414 13.9532 16.8944 14.4472C16.6474 14.9412 16.0468 15.1414 15.5528 14.8944L11.5528 12.8944C11.214 12.725 11 12.3788 11 12V6C11 5.44772 11.4477 5 12 5Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"connect\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Connect\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20C19.1046 20 20 19.1046 20 18C20 16.8954 19.1046 16 18 16ZM14 18C14 15.7909 15.7909 14 18 14C20.2091 14 22 15.7909 22 18C22 20.2091 20.2091 22 18 22C15.7909 22 14 20.2091 14 18Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4ZM2 6C2 3.79086 3.79086 2 6 2C8.20914 2 10 3.79086 10 6C10 8.20914 8.20914 10 6 10C3.79086 10 2 8.20914 2 6Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M6 8C6.55228 8 7 8.44772 7 9C7 11.1217 7.84285 13.1566 9.34315 14.6569C10.8434 16.1571 12.8783 17 15 17C15.5523 17 16 17.4477 16 18C16 18.5523 15.5523 19 15 19C12.3478 19 9.8043 17.9464 7.92893 16.0711C7.59237 15.7345 7.28228 15.3764 7 15.0001V21C7 21.5523 6.55228 22 6 22C5.44772 22 5 21.5523 5 21V9C5 8.44772 5.44772 8 6 8Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"cooking\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Cooking\\\">\\n<g id=\\\"Vector\\\">\\n<path d=\\\"M18.0701 3.42854C17.5865 3.4273 17.1068 3.51629 16.6558 3.69095C17.0422 4.23155 17.3305 4.8359 17.5075 5.47639C17.5207 5.52182 17.5248 5.56942 17.5195 5.61644C17.5141 5.66345 17.4995 5.70893 17.4764 5.75024C17.4534 5.79155 17.4223 5.82786 17.3851 5.85707C17.3479 5.88628 17.3052 5.90781 17.2596 5.92039C17.214 5.93298 17.1664 5.93638 17.1194 5.93039C17.0725 5.92441 17.0272 5.90915 16.9863 5.88552C16.9453 5.86189 16.9094 5.83035 16.8807 5.79273C16.852 5.75511 16.8311 5.71217 16.8191 5.66639C16.5857 4.82341 16.1354 4.0564 15.5129 3.44191C14.8905 2.82742 14.1178 2.38695 13.2719 2.16447C12.4261 1.94199 11.5367 1.94528 10.6925 2.17401C9.84829 2.40275 9.07886 2.84893 8.46099 3.46801C9.10847 3.8895 9.64052 4.46592 10.0089 5.14504C10.3773 5.82415 10.5704 6.58448 10.5707 7.35709C10.5707 7.45181 10.5331 7.54265 10.4661 7.60963C10.3992 7.67661 10.3083 7.71423 10.2136 7.71423C10.1189 7.71423 10.0281 7.67661 9.9611 7.60963C9.89413 7.54265 9.8565 7.45181 9.8565 7.35709C9.85634 6.61412 9.64552 5.88643 9.24849 5.25845C8.85146 4.63048 8.28451 4.12797 7.61342 3.80925C6.94234 3.49052 6.19464 3.36864 5.45709 3.45776C4.71954 3.54687 4.02237 3.84332 3.4465 4.31271C2.87062 4.7821 2.43965 5.40518 2.20359 6.10964C1.96752 6.81411 1.93605 7.57108 2.11282 8.29271C2.28959 9.01434 2.66736 9.67105 3.20228 10.1866C3.73721 10.7022 4.40736 11.0555 5.13497 11.2056C5.20551 11.22 5.27003 11.2555 5.32006 11.3072C5.3701 11.359 5.40331 11.4247 5.41535 11.4957L6.58717 18.4285H8.75874L8.42899 13.8111C8.42836 13.8026 8.42805 13.7942 8.42805 13.7857C8.42924 13.694 8.46566 13.6062 8.52977 13.5406C8.59388 13.4751 8.68076 13.4366 8.77242 13.4334C8.86407 13.4301 8.95347 13.4622 9.02208 13.5231C9.0907 13.584 9.13327 13.6689 9.14098 13.7603L9.47479 18.4285H11.6421V14.4999C11.6421 14.4052 11.6797 14.3143 11.7467 14.2474C11.8136 14.1804 11.9045 14.1428 11.9992 14.1428C12.0939 14.1428 12.1847 14.1804 12.2517 14.2474C12.3187 14.3143 12.3563 14.4052 12.3563 14.4999V18.4285H14.5236L14.857 13.7602C14.8647 13.6688 14.9077 13.5839 14.9763 13.523C15.0449 13.4621 15.1343 13.43 15.226 13.4333C15.3176 13.4366 15.4045 13.475 15.4686 13.5406C15.5327 13.6062 15.5691 13.6939 15.5703 13.7856C15.5703 13.7942 15.5697 13.8026 15.569 13.811L15.2396 18.4285H17.4112L18.583 11.4959C18.5951 11.4249 18.6283 11.3592 18.6783 11.3074C18.7283 11.2556 18.7929 11.2201 18.8634 11.2057C19.8164 11.0093 20.6626 10.4662 21.2381 9.68168C21.8137 8.89711 22.0777 7.92686 21.9789 6.95881C21.8802 5.99077 21.4258 5.0938 20.7036 4.44162C19.9815 3.78944 19.0431 3.42845 18.0701 3.42854Z\\\" />\\n<path d=\\\"M17.3566 19.1429H6.64319V22H17.3566V19.1429Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"creditcard\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Credit card \\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M3 5C2.44772 5 2 5.44772 2 6V18C2 18.5523 2.44772 19 3 19H21C21.5523 19 22 18.5523 22 18V6C22 5.44772 21.5523 5 21 5H3ZM0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34315 21 0 19.6569 0 18V6Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M0 10C0 9.17157 0.171573 9 1 9H23C23.8284 9 24 9.17157 24 10C24 10.8284 23.8284 11 23 11H1C0.171573 11 0 10.8284 0 10Z\\\" />\\n<path d=\\\"M9.5 17.3333H4.6875C4.308 17.3333 4 17.0353 4 16.6667C4 16.298 4.308 16 4.6875 16H9.5C9.8795 16 10.1875 16.298 10.1875 16.6667C10.1875 17.0353 9.8795 17.3333 9.5 17.3333Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"dish\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Dish\\\">\\n<path id=\\\"Subtract\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M15.0957 7.80546C19.0348 9.08725 21.7481 12.646 21.9314 16.7728C22.56 16.9864 23 17.5804 23 18.2526C23 19.1123 22.2929 19.8157 21.4286 19.8157H2.57143C1.70714 19.8157 1 19.1123 1 18.2526C1 17.5804 1.44 16.9864 2.06857 16.7728C2.24667 12.6513 4.96524 9.08725 8.90429 7.80546C8.87286 7.6283 8.85714 7.46678 8.85714 7.31046C8.85714 5.58577 10.2662 4.18414 12 4.18414C13.7338 4.18414 15.1429 5.58577 15.1429 7.31046C15.1429 7.46678 15.1271 7.6283 15.0957 7.80546ZM12 5.22625C13.1576 5.22625 14.0952 6.15893 14.0952 7.31046C14.0952 7.38341 14.09 7.45635 14.0795 7.53972C13.3776 7.38862 12.6757 7.31046 12 7.31046C11.3243 7.31046 10.6224 7.38862 9.92048 7.53972C9.91 7.45635 9.90476 7.38341 9.90476 7.31046C9.90476 6.15893 10.8424 5.22625 12 5.22625ZM21.9524 18.2526C21.9524 18.5391 21.7167 18.7736 21.4286 18.7736H2.57143C2.28333 18.7736 2.04762 18.5391 2.04762 18.2526C2.04762 17.966 2.28333 17.7315 2.57143 17.7315H21.4286C21.7167 17.7315 21.9524 17.966 21.9524 18.2526ZM17.3134 12.3392C17.1418 12.1289 16.9015 11.8546 16.6232 11.5924C16.3761 11.3596 16.1056 11.1562 15.8936 11.0096C15.7884 10.9368 15.6994 10.8791 15.6373 10.8401C15.6063 10.8206 15.5821 10.8058 15.5661 10.7961L15.5484 10.7855L15.5445 10.7832L15.5441 10.7829C15.3371 10.662 15.2672 10.3961 15.3881 10.189C15.509 9.98193 15.7749 9.91207 15.982 10.033L15.9831 10.0336L15.9851 10.0348L15.9919 10.0388L16.0155 10.053C16.0355 10.0651 16.064 10.0826 16.0997 10.105C16.1708 10.1497 16.2706 10.2144 16.3878 10.2954C16.6206 10.4566 16.929 10.6874 17.2187 10.9603C17.5329 11.2564 17.7992 11.561 17.9862 11.7901C18.0801 11.9051 18.1548 12.0022 18.2066 12.0712C18.2325 12.1057 18.2527 12.1333 18.2667 12.1526L18.283 12.1753L18.2876 12.1817L18.2889 12.1837L18.2896 12.1845C18.4273 12.3808 18.3801 12.6518 18.1838 12.7896C17.9876 12.9273 17.7169 12.88 17.579 12.6839L17.3134 12.3392Z\\\" />\\n</g>\\n</svg>\\n\",\"dollarsign\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Dollar sign\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 0C12.526 0 12.9524 0.447715 12.9524 1V23C12.9524 23.5523 12.526 24 12 24C11.474 24 11.0476 23.5523 11.0476 23V1C11.0476 0.447715 11.474 0 12 0Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M6.58857 5.31802C7.3923 4.47411 8.48239 4 9.61903 4H16.7619C17.2879 4 17.7143 4.44772 17.7143 5C17.7143 5.55228 17.2879 6 16.7619 6H9.61903C8.98756 6 8.38196 6.26339 7.93544 6.73223C7.48892 7.20107 7.23808 7.83696 7.23808 8.5C7.23808 9.16304 7.48892 9.79893 7.93544 10.2678C8.38196 10.7366 8.98756 11 9.61903 11H14.3809C15.5176 11 16.6077 11.4741 17.4114 12.318C18.2151 13.1619 18.6666 14.3065 18.6666 15.5C18.6666 16.6935 18.2151 17.8381 17.4114 18.682C16.6077 19.5259 15.5176 20 14.3809 20H6.28569C5.75971 20 5.33331 19.5523 5.33331 19C5.33331 18.4477 5.75971 18 6.28569 18H14.3809C15.0124 18 15.618 17.7366 16.0645 17.2678C16.511 16.7989 16.7619 16.163 16.7619 15.5C16.7619 14.837 16.511 14.2011 16.0645 13.7322C15.618 13.2634 15.0124 13 14.3809 13H9.61903C8.48239 13 7.3923 12.5259 6.58857 11.682C5.78484 10.8381 5.33331 9.69347 5.33331 8.5C5.33331 7.30653 5.78484 6.16193 6.58857 5.31802Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"download\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Download\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M3 15C3.55228 15 4 15.4477 4 16V19.3333C4 19.4452 4.05193 19.5986 4.22597 19.7436C4.40533 19.8931 4.6818 20 5 20H19C19.3182 20 19.5947 19.8931 19.774 19.7436C19.9481 19.5986 20 19.4452 20 19.3333V16C20 15.4477 20.4477 15 21 15C21.5523 15 22 15.4477 22 16V19.3333C22 20.1055 21.6305 20.8 21.0544 21.2801C20.4836 21.7557 19.7427 22 19 22H5C4.25734 22 3.51639 21.7557 2.9456 21.2801C2.3695 20.8 2 20.1055 2 19.3333V16C2 15.4477 2.44772 15 3 15Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L12 13.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 2C12.5523 2 13 2.44772 13 3V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V3C11 2.44772 11.4477 2 12 2Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"fire\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Fire\\\">\\n<path id=\\\"Vector\\\" d=\\\"M9.09249 22.9733C9.14008 22.9775 9.18795 22.9703 9.23267 22.9522C9.27739 22.934 9.31786 22.9054 9.35118 22.8684C9.3845 22.8313 9.40985 22.7867 9.42541 22.7378C9.44097 22.6889 9.44637 22.6369 9.4412 22.5855C9.32203 21.4028 9.4607 20.2063 9.84606 19.0922C10.2314 17.9781 10.8527 16.9775 11.66 16.1708C11.7548 16.0754 11.8794 16.0224 12.0087 16.0224C12.1381 16.0224 12.2627 16.0754 12.3574 16.1708C13.1676 16.9808 13.7903 17.9859 14.1752 19.105C14.5601 20.224 14.6965 21.4255 14.5732 22.6122C14.5685 22.66 14.5729 22.7082 14.5861 22.754C14.5993 22.7998 14.621 22.8422 14.65 22.8785C14.6789 22.9148 14.7144 22.9444 14.7542 22.9653C14.7941 22.9862 14.8375 22.998 14.8818 23C22.7633 21.6629 21.1926 14.4493 20.0662 11.2302C20.0178 11.0855 19.9292 10.9606 19.8126 10.8726C19.696 10.7846 19.5571 10.7379 19.4151 10.7388C19.3018 10.7388 19.1902 10.7693 19.0905 10.8277C18.9909 10.886 18.9062 10.9704 18.8442 11.0731C18.1105 12.2107 17.119 13.1247 15.9649 13.7272C16.7827 5.70464 12.2031 2.40201 9.99976 1.095C9.89036 1.02865 9.7663 0.995943 9.64099 1.0004C9.51568 1.00486 9.39387 1.04632 9.28873 1.1203C9.18358 1.19428 9.09909 1.29797 9.04438 1.42017C8.98967 1.54237 8.96683 1.67844 8.97831 1.81369C9.17581 5.15643 6.29968 9.54211 4.62092 11.8118C3.43341 13.3723 2.86131 15.3767 3.02856 17.3909C3.48528 22.064 7.68837 22.8429 9.09249 22.9733Z\\\" />\\n</g>\\n</svg>\\n\",\"grid-filled\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M3.8 13C2.80589 13 2 13.8059 2 14.8V20.2C2 21.1941 2.80589 22 3.8 22H9.2C10.1941 22 11 21.1941 11 20.2V14.8C11 13.8059 10.1941 13 9.2 13H3.8Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M3.8 2C2.80589 2 2 2.80589 2 3.8V9.2C2 10.1941 2.80589 11 3.8 11H9.2C10.1941 11 11 10.1941 11 9.2V3.8C11 2.80589 10.1941 2 9.2 2H3.8Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M14.8 2C13.8059 2 13 2.80589 13 3.8V9.2C13 10.1941 13.8059 11 14.8 11H20.2C21.1941 11 22 10.1941 22 9.2V3.8C22 2.80589 21.1941 2 20.2 2H14.8Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M14.8 13C13.8059 13 13 13.8059 13 14.8V20.2C13 21.1941 13.8059 22 14.8 22H20.2C21.1941 22 22 21.1941 22 20.2V14.8C22 13.8059 21.1941 13 20.2 13H14.8Z\\\" />\\n</svg>\\n\",\"grid-outlined\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Grid - Outlined\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M9.2 14.35H3.8C3.55147 14.35 3.35 14.5515 3.35 14.8V20.2C3.35 20.4485 3.55147 20.65 3.8 20.65H9.2C9.44853 20.65 9.65 20.4485 9.65 20.2V14.8C9.65 14.5515 9.44853 14.35 9.2 14.35ZM3.8 13C2.80589 13 2 13.8059 2 14.8V20.2C2 21.1941 2.80589 22 3.8 22H9.2C10.1941 22 11 21.1941 11 20.2V14.8C11 13.8059 10.1941 13 9.2 13H3.8Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M9.2 3.35H3.8C3.55147 3.35 3.35 3.55147 3.35 3.8V9.2C3.35 9.44853 3.55147 9.65 3.8 9.65H9.2C9.44853 9.65 9.65 9.44853 9.65 9.2V3.8C9.65 3.55147 9.44853 3.35 9.2 3.35ZM3.8 2C2.80589 2 2 2.80589 2 3.8V9.2C2 10.1941 2.80589 11 3.8 11H9.2C10.1941 11 11 10.1941 11 9.2V3.8C11 2.80589 10.1941 2 9.2 2H3.8Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M20.2 3.35H14.8C14.5515 3.35 14.35 3.55147 14.35 3.8V9.2C14.35 9.44853 14.5515 9.65 14.8 9.65H20.2C20.4485 9.65 20.65 9.44853 20.65 9.2V3.8C20.65 3.55147 20.4485 3.35 20.2 3.35ZM14.8 2C13.8059 2 13 2.80589 13 3.8V9.2C13 10.1941 13.8059 11 14.8 11H20.2C21.1941 11 22 10.1941 22 9.2V3.8C22 2.80589 21.1941 2 20.2 2H14.8Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M20.2 14.35H14.8C14.5515 14.35 14.35 14.5515 14.35 14.8V20.2C14.35 20.4485 14.5515 20.65 14.8 20.65H20.2C20.4485 20.65 20.65 20.4485 20.65 20.2V14.8C20.65 14.5515 20.4485 14.35 20.2 14.35ZM14.8 13C13.8059 13 13 13.8059 13 14.8V20.2C13 21.1941 13.8059 22 14.8 22H20.2C21.1941 22 22 21.1941 22 20.2V14.8C22 13.8059 21.1941 13 20.2 13H14.8Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"hourglass\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Hourglass\\\">\\n<g id=\\\"Vector\\\">\\n<path d=\\\"M11.064 11.5438C11.064 11.7953 11.2594 11.9979 11.4998 11.9979C11.7402 11.9979 11.9356 11.7941 11.9356 11.5438C11.936 11.012 12.1172 10.495 12.4461 10.0882C13.1778 9.18352 13.7263 8.20271 14.0735 7.17297C14.1205 7.03383 14.1001 6.87979 14.0184 6.75937C13.9364 6.63895 13.8042 6.56747 13.6626 6.56747H9.33659C9.19499 6.56747 9.06236 6.63895 8.98034 6.75937C8.89873 6.87979 8.87832 7.03383 8.92525 7.17297C9.27334 8.20271 9.82098 9.18352 10.5527 10.0882C10.882 10.495 11.0636 11.0124 11.064 11.5438Z\\\" />\\n<path d=\\\"M11.9356 13.3655C11.9356 13.1144 11.7402 12.9115 11.4998 12.9115C11.2594 12.9115 11.064 13.1153 11.064 13.3655C11.0636 14.0216 10.6877 14.6705 10.0058 15.1969C8.54737 16.3198 7.45577 17.5398 6.76123 18.8223C6.68492 18.9635 6.68614 19.1354 6.7649 19.2742C6.84244 19.4142 6.98608 19.4997 7.14115 19.4997H15.8593C16.0139 19.4997 16.1572 19.4142 16.2355 19.2742C16.3134 19.1354 16.3147 18.9635 16.2388 18.8223C15.5446 17.5398 14.4526 16.3198 12.9946 15.1969C12.3119 14.6705 11.936 14.0216 11.9356 13.3655Z\\\" />\\n<path d=\\\"M19.1275 20.1818H18.8668C18.5672 16.6445 16.5807 13.9289 15.0366 12C16.5811 10.0716 18.5668 7.35552 18.8676 3.81822H19.1284C19.6099 3.81822 20 3.411 20 2.9089C20 2.40679 19.6099 2 19.1284 2H3.87165C3.39012 2 3 2.40722 3 2.9089C3 3.411 3.39012 3.81822 3.87165 3.81822H4.13241C4.43234 7.35594 6.41804 10.072 7.9626 12C6.41844 13.9284 4.43234 16.6441 4.132 20.1818H3.87165C3.39012 20.1818 3 20.5881 3 21.0903C3 21.5928 3.39012 22 3.87165 22H19.1284C19.6099 22 20 21.5928 20 21.0903C20 20.5881 19.6095 20.1818 19.1275 20.1818ZM5.87979 20.1818C6.20747 16.9857 8.2001 14.5246 9.68917 12.6855L9.76874 12.5872C10.043 12.2489 10.043 11.7536 9.76874 11.4149L9.68957 11.317C8.20092 9.47755 6.20747 7.01638 5.87979 3.81992H17.1198C16.7921 7.01638 14.7987 9.47755 13.31 11.317L13.2313 11.4149C12.957 11.7532 12.957 12.2485 13.2313 12.5872L13.3108 12.6855C14.7995 14.5246 16.7921 16.9857 17.1198 20.1818H5.87979Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"lifebuoy\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Lifebuoy\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M19.5196 4.12279C19.9101 4.51331 19.9101 5.14648 19.5196 5.537L15.2796 9.777C14.889 10.1675 14.2559 10.1675 13.8653 9.777C13.4748 9.38648 13.4748 8.75331 13.8653 8.36279L18.1053 4.12279C18.4959 3.73226 19.129 3.73226 19.5196 4.12279Z\\\" />\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.7424 2.8999C6.77187 2.8999 2.74243 6.92934 2.74243 11.8999C2.74243 16.8705 6.77187 20.8999 11.7424 20.8999C16.713 20.8999 20.7424 16.8705 20.7424 11.8999C20.7424 6.92934 16.713 2.8999 11.7424 2.8999ZM0.742432 11.8999C0.742432 5.82477 5.6673 0.899902 11.7424 0.899902C17.8176 0.899902 22.7424 5.82477 22.7424 11.8999C22.7424 17.975 17.8176 22.8999 11.7424 22.8999C5.6673 22.8999 0.742432 17.975 0.742432 11.8999Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.7424 8.8999C10.0856 8.8999 8.74243 10.243 8.74243 11.8999C8.74243 13.5568 10.0856 14.8999 11.7424 14.8999C13.3993 14.8999 14.7424 13.5568 14.7424 11.8999C14.7424 10.243 13.3993 8.8999 11.7424 8.8999ZM6.74243 11.8999C6.74243 9.13848 8.98101 6.8999 11.7424 6.8999C14.5039 6.8999 16.7424 9.13848 16.7424 11.8999C16.7424 14.6613 14.5039 16.8999 11.7424 16.8999C8.98101 16.8999 6.74243 14.6613 6.74243 11.8999Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M3.96532 4.12279C4.35584 3.73226 4.98901 3.73226 5.37953 4.12279L9.61953 8.36279C10.0101 8.75331 10.0101 9.38648 9.61953 9.777C9.22901 10.1675 8.59584 10.1675 8.20532 9.777L3.96532 5.537C3.57479 5.14648 3.57479 4.51331 3.96532 4.12279Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M13.8653 14.0228C14.2559 13.6323 14.889 13.6323 15.2796 14.0228L19.5196 18.2628C19.9101 18.6533 19.9101 19.2865 19.5196 19.677C19.129 20.0675 18.4959 20.0675 18.1053 19.677L13.8653 15.437C13.4748 15.0465 13.4748 14.4133 13.8653 14.0228Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M18.8096 4.83281C19.2001 5.22333 19.2001 5.8565 18.8096 6.24702L15.2796 9.77702C14.889 10.1675 14.2559 10.1675 13.8653 9.77702C13.4748 9.3865 13.4748 8.75333 13.8653 8.36281L17.3953 4.83281C17.7859 4.44229 18.419 4.44229 18.8096 4.83281Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M9.61953 14.0228C10.0101 14.4133 10.0101 15.0465 9.61953 15.437L5.37953 19.677C4.98901 20.0675 4.35584 20.0675 3.96532 19.677C3.57479 19.2865 3.57479 18.6533 3.96532 18.2628L8.20532 14.0228C8.59584 13.6323 9.22901 13.6323 9.61953 14.0228Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"link\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Link\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12.7753 2.75071C13.9069 1.65776 15.4225 1.05299 16.9957 1.06666C18.5689 1.08033 20.0738 1.71135 21.1862 2.8238C22.2987 3.93624 22.9297 5.44112 22.9433 7.0143C22.957 8.58748 22.3523 10.1031 21.2593 11.2347L21.2471 11.2471L18.2473 14.247C17.639 14.8555 16.907 15.326 16.1009 15.6267C15.2948 15.9274 14.4334 16.0512 13.5752 15.9898C12.7171 15.9283 11.8821 15.683 11.1271 15.2705C10.3721 14.858 9.71459 14.2879 9.19925 13.599C8.86844 13.1567 8.95879 12.53 9.40104 12.1992C9.84329 11.8684 10.47 11.9588 10.8008 12.401C11.1443 12.8603 11.5827 13.2404 12.086 13.5154C12.5894 13.7904 13.146 13.9539 13.7181 13.9949C14.2902 14.0359 14.8645 13.9533 15.4019 13.7528C15.9393 13.5524 16.4273 13.2387 16.8328 12.833L19.8264 9.83937C20.5515 9.0856 20.9525 8.07773 20.9434 7.03168C20.9343 5.98289 20.5136 4.97964 19.772 4.23801C19.0304 3.49638 18.0271 3.0757 16.9783 3.06659C15.9318 3.05749 14.9235 3.4589 14.1697 4.18453L12.4551 5.88916C12.0634 6.27855 11.4302 6.2767 11.0409 5.88504C10.6515 5.49338 10.6533 4.86021 11.045 4.47083L12.765 2.76083L12.7753 2.75071Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M7.89917 8.37328C8.70528 8.07258 9.56663 7.94876 10.4248 8.01022C11.283 8.07168 12.1179 8.31698 12.8729 8.72949C13.628 9.142 14.2854 9.71206 14.8008 10.401C15.1316 10.8433 15.0412 11.47 14.599 11.8008C14.1567 12.1316 13.5301 12.0412 13.1993 11.599C12.8557 11.1397 12.4174 10.7596 11.914 10.4846C11.4107 10.2096 10.854 10.0461 10.2819 10.0051C9.70982 9.96413 9.13558 10.0467 8.59818 10.2471C8.06077 10.4476 7.57276 10.7613 7.16725 11.167L4.17361 14.1606C3.44857 14.9144 3.04752 15.9223 3.05661 16.9683C3.06572 18.0171 3.4864 19.0203 4.22803 19.762C4.96966 20.5036 5.97291 20.9243 7.0217 20.9334C8.06775 20.9425 9.07561 20.5414 9.82938 19.8164L11.5329 18.1129C11.9234 17.7224 12.5566 17.7224 12.9471 18.1129C13.3376 18.5034 13.3376 19.1366 12.9471 19.5271L11.2371 21.2371L11.2247 21.2493C10.0931 22.3422 8.5775 22.947 7.00432 22.9333C5.43114 22.9197 3.92627 22.2886 2.81382 21.1762C1.70137 20.0637 1.07035 18.5589 1.05668 16.9857C1.04301 15.4125 1.64778 13.8969 2.74073 12.7653L2.75291 12.7529L5.75278 9.75302C5.75274 9.75306 5.75282 9.75297 5.75278 9.75302C6.36102 9.1446 7.09311 8.67396 7.89917 8.37328Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"list\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"List\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2 18C2 17.4477 2.44772 17 3 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H3C2.44772 19 2 18.5523 2 18Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"location-filled\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Location - Filled\\\">\\n<g id=\\\"Vector (Stroke)\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M6.34315 4.34315C7.84344 2.84285 9.87827 2 12 2C14.1217 2 16.1566 2.84285 17.6569 4.34315C19.1571 5.84344 20 7.87827 20 10C20 13.0981 17.9843 16.1042 15.774 18.4373C14.6894 19.5822 13.6013 20.5195 12.7833 21.1708C12.4789 21.4133 12.213 21.6152 12 21.7726C11.787 21.6152 11.5211 21.4133 11.2167 21.1708C10.3987 20.5195 9.31061 19.5822 8.22595 18.4373C6.01574 16.1042 4 13.0981 4 10C4 7.87827 4.84285 5.84344 6.34315 4.34315ZM11.4448 23.8317C11.4448 23.8317 11.4453 23.8321 12 23L12.5547 23.8321C12.2188 24.056 11.7807 24.0556 11.4448 23.8317ZM11.4448 23.8317L12 23C12.5547 23.8321 12.556 23.8312 12.556 23.8312L12.5581 23.8298L12.5648 23.8253L12.5877 23.8098C12.6072 23.7966 12.6349 23.7776 12.6704 23.753C12.7415 23.7038 12.8435 23.6321 12.9722 23.5392C13.2295 23.3534 13.5936 23.0822 14.0292 22.7354C14.8987 22.043 16.0606 21.0428 17.226 19.8127C19.5157 17.3958 22 13.9019 22 10C22 7.34784 20.9464 4.8043 19.0711 2.92893C17.1957 1.05357 14.6522 0 12 0C9.34784 0 6.8043 1.05357 4.92893 2.92893C3.05357 4.8043 2 7.34784 2 10C2 13.9019 4.48426 17.3958 6.77405 19.8127C7.93939 21.0428 9.10133 22.043 9.97082 22.7354C10.4064 23.0822 10.7705 23.3534 11.0278 23.5392C11.1565 23.6321 11.2585 23.7038 11.3296 23.753C11.3651 23.7776 11.3928 23.7966 11.4123 23.8098L11.4352 23.8253L11.4419 23.8298L11.4448 23.8317Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M6.34315 4.34315C7.84344 2.84285 9.87827 2 12 2C14.1217 2 16.1566 2.84285 17.6569 4.34315C19.1571 5.84344 20 7.87827 20 10C20 13.0981 17.9843 16.1042 15.774 18.4373C14.6894 19.5822 13.6013 20.5195 12.7833 21.1708C12.4789 21.4133 12.213 21.6152 12 21.7726C11.787 21.6152 11.5211 21.4133 11.2167 21.1708C10.3987 20.5195 9.31061 19.5822 8.22595 18.4373C6.01574 16.1042 4 13.0981 4 10C4 7.87827 4.84285 5.84344 6.34315 4.34315ZM8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"location-outlined\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Location - Outlined\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 2C9.87827 2 7.84344 2.84285 6.34315 4.34315C4.84285 5.84344 4 7.87827 4 10C4 13.0981 6.01574 16.1042 8.22595 18.4373C9.31061 19.5822 10.3987 20.5195 11.2167 21.1708C11.5211 21.4133 11.787 21.6152 12 21.7726C12.213 21.6152 12.4789 21.4133 12.7833 21.1708C13.6013 20.5195 14.6894 19.5822 15.774 18.4373C17.9843 16.1042 20 13.0981 20 10C20 7.87827 19.1571 5.84344 17.6569 4.34315C16.1566 2.84285 14.1217 2 12 2ZM12 23C11.4453 23.8321 11.445 23.8319 11.4448 23.8317L11.4419 23.8298L11.4352 23.8253L11.4123 23.8098C11.3928 23.7966 11.3651 23.7776 11.3296 23.753C11.2585 23.7038 11.1565 23.6321 11.0278 23.5392C10.7705 23.3534 10.4064 23.0822 9.97082 22.7354C9.10133 22.043 7.93939 21.0428 6.77405 19.8127C4.48426 17.3958 2 13.9019 2 10C2 7.34784 3.05357 4.8043 4.92893 2.92893C6.8043 1.05357 9.34784 0 12 0C14.6522 0 17.1957 1.05357 19.0711 2.92893C20.9464 4.8043 22 7.34784 22 10C22 13.9019 19.5157 17.3958 17.226 19.8127C16.0606 21.0428 14.8987 22.043 14.0292 22.7354C13.5936 23.0822 13.2295 23.3534 12.9722 23.5392C12.8435 23.6321 12.7415 23.7038 12.6704 23.753C12.6349 23.7776 12.6072 23.7966 12.5877 23.8098L12.5648 23.8253L12.5581 23.8298L12.556 23.8312C12.5557 23.8314 12.5547 23.8321 12 23ZM12 23L12.5547 23.8321C12.2188 24.056 11.7807 24.0556 11.4448 23.8317L12 23Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8ZM8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"log-in\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Log-in\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M14 3C14 2.44772 14.4477 2 15 2H19C19.7957 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H15C14.4477 22 14 21.5523 14 21C14 20.4477 14.4477 20 15 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4H15C14.4477 4 14 3.55228 14 3Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M9.29289 6.29289C9.68342 5.90237 10.3166 5.90237 10.7071 6.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L10.7071 17.7071C10.3166 18.0976 9.68342 18.0976 9.29289 17.7071C8.90237 17.3166 8.90237 16.6834 9.29289 16.2929L13.5858 12L9.29289 7.70711C8.90237 7.31658 8.90237 6.68342 9.29289 6.29289Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2 12C2 11.4477 2.44772 11 3 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H3C2.44772 13 2 12.5523 2 12Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"log-out\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Log-out\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M14 3C14 2.44772 14.4477 2 15 2H19C19.7957 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H15C14.4477 22 14 21.5523 14 21C14 20.4477 14.4477 20 15 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4H15C14.4477 4 14 3.55228 14 3Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8.70711 6.29289C8.31658 5.90237 7.68342 5.90237 7.29289 6.29289L2.29289 11.2929C1.90237 11.6834 1.90237 12.3166 2.29289 12.7071L7.29289 17.7071C7.68342 18.0976 8.31658 18.0976 8.70711 17.7071C9.09763 17.3166 9.09763 16.6834 8.70711 16.2929L4.41421 12L8.70711 7.70711C9.09763 7.31658 9.09763 6.68342 8.70711 6.29289Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M16 12C16 11.4477 15.5523 11 15 11H3C2.44771 11 2 11.4477 2 12C2 12.5523 2.44771 13 3 13H15C15.5523 13 16 12.5523 16 12Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"logo\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path d=\\\"M3.36 0.00480898L0 0V20.64H3.36V19.2V0.00480898Z\\\" />\\n<path d=\\\"M20.64 0H0V3.37183H3.36L10.8059 3.36592H12.24H15.5968L19.2 3.36H20.64V0Z\\\" />\\n<path d=\\\"M15.5968 20.64H4.8H3.36V24L15.5968 24V20.64Z\\\" />\\n<path d=\\\"M15.5968 0H12.24V3.36592V24L15.5968 24V14.6304V0Z\\\" />\\n<path d=\\\"M24 3.36H20.64V4.8V14.6304V17.9965H24V3.36Z\\\" />\\n<path d=\\\"M24 14.6304H15.5968H12.24V17.9965H24V14.6304Z\\\" />\\n<path d=\\\"M20.64 0V3.36H24L20.64 0Z\\\" />\\n<path d=\\\"M20.64 4.8V3.36H19.2L20.64 4.8Z\\\" />\\n<path d=\\\"M15.5968 13.1968V14.6304H17.0304L15.5968 13.1968Z\\\" />\\n<path d=\\\"M24 24V21.6L20.4 17.9965H15.5968L18 20.3998L21.6 24H24Z\\\" />\\n<path d=\\\"M12.24 4.8V3.36592H10.8059L12.24 4.8Z\\\" />\\n<path d=\\\"M3.36 19.2V20.64H4.8L3.36 19.2Z\\\" />\\n<path d=\\\"M17.279 22.32H15.6L15.5968 24L17.279 24V22.32Z\\\" />\\n<path d=\\\"M15.5968 20.64V24L15.6 22.32H17.279L15.5968 20.64Z\\\" />\\n<path d=\\\"M3.36 20.64H0L3.36 24V20.64Z\\\" />\\n</svg>\\n\",\"menu\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Menu\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1 3.05C1 2.4701 1.44779 2 2.00018 2H8.00124C9.32756 2 10.5996 2.55312 11.5374 3.53769C12.4753 4.52226 13.0021 5.85761 13.0021 7.25V21.95C13.0021 22.5299 12.5543 23 12.002 23C11.4496 23 11.0018 22.5299 11.0018 21.95C11.0018 21.393 10.791 20.8589 10.4159 20.4651C10.0407 20.0712 9.53195 19.85 9.00142 19.85H2.00018C1.44779 19.85 1 19.3799 1 18.8V3.05ZM11.0018 18.3127V7.25C11.0018 6.41457 10.6857 5.61335 10.1229 5.02261C9.56023 4.43187 8.79703 4.1 8.00124 4.1H3.00036V17.75H9.00142C9.70978 17.75 10.3988 17.9472 11.0018 18.3127Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12.4626 3.53769C13.4004 2.55312 14.6724 2 15.9988 2H21.9998C22.5522 2 23 2.4701 23 3.05V18.8C23 19.3799 22.5522 19.85 21.9998 19.85H14.9986C14.4681 19.85 13.9593 20.0712 13.5841 20.4651C13.209 20.8589 12.9982 21.393 12.9982 21.95C12.9982 22.5299 12.5504 23 11.998 23C11.4457 23 10.9979 22.5299 10.9979 21.95V7.25C10.9979 5.85761 11.5247 4.52226 12.4626 3.53769ZM12.9982 18.3127C13.6012 17.9472 14.2902 17.75 14.9986 17.75H20.9996V4.1H15.9988C15.203 4.1 14.4398 4.43187 13.8771 5.02261C13.3144 5.61335 12.9982 6.41457 12.9982 7.25V18.3127Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"minus\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Minus\\\">\\n<path id=\\\"Vector\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z\\\" />\\n</g>\\n</svg>\\n\",\"movecards\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Move cards\\\">\\n<g id=\\\"Vector\\\">\\n<path d=\\\"M21.8377 12.6288H15.5229C14.3189 12.6288 13.3606 13.6769 13.3606 14.9345V21.6943C13.3606 22.9782 14.3435 24 15.5229 24H21.8377C23.0417 24 24 22.952 24 21.6943V14.9607C24 13.6769 23.0417 12.6288 21.8377 12.6288ZM21.7886 21.6419H15.572V14.9869H21.8132V21.6419H21.7886ZM0.23957 18.917C-0.0798567 18.5764 -0.0798567 18.0262 0.23957 17.7118L3.06527 14.6987C3.48298 14.2533 4.19555 14.3057 4.53954 14.8559C4.78526 15.2751 4.71154 15.8253 4.39212 16.1659L3.33555 17.2926H10.2401C10.7806 17.2926 11.1984 17.7642 11.1984 18.3144C11.1984 18.8908 10.7561 19.3362 10.2401 19.3362H3.36012L4.41669 20.4629C4.73611 20.8035 4.8344 21.3537 4.56412 21.7729C4.22012 22.3231 3.50755 22.3755 3.08984 21.9301L0.23957 18.917ZM2.1807 11.3712H8.49552C9.69951 11.3712 10.6578 10.3231 10.6578 9.0655V2.30568C10.6578 1.02183 9.67494 0 8.49552 0H2.1807C0.976708 0 0.0184285 1.04803 0.0184285 2.30568V9.0393C0.0184285 10.3231 0.976708 11.3712 2.1807 11.3712ZM2.22984 2.35808H8.47095V9.0131H2.22984V2.35808ZM20.9286 2.04367L23.7543 5.05677C24.0737 5.39738 24.0737 5.9476 23.7543 6.26201L20.9286 9.30131C20.5109 9.74672 19.7983 9.69432 19.4543 9.1441C19.2086 8.72489 19.2823 8.17467 19.6017 7.83406L20.6583 6.70742H13.7538C13.2132 6.70742 12.7955 6.23581 12.7955 5.68559C12.7955 5.10917 13.2378 4.66375 13.7538 4.66375H20.6583L19.6017 3.53712C19.2823 3.19651 19.184 2.64629 19.4543 2.22707C19.7983 1.65065 20.5109 1.59825 20.9286 2.04367Z\\\" />\\n<path d=\\\"M2.22984 2.35808H8.47095V9.0131H2.22984V2.35808Z\\\" />\\n<path d=\\\"M21.7886 21.6419H15.572V14.9869H21.8132V21.6419H21.7886Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"packet\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Packet\\\">\\n<path id=\\\"Vector\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M5.42524 2.07212C5.71012 1.7098 6.14631 1.49919 6.60706 1.5H17.3322C17.5 1.49999 18 1.49999 18.1244 2.15045L22.4771 21.4725C22.4886 21.5203 22.4958 21.5691 22.4986 21.6182C22.5005 21.6516 22.5005 21.6852 22.4985 21.7187L22.4982 21.7226C22.469 22.1566 22.1115 22.4923 21.6799 22.4999L21.671 22.5001L2.66858 22.5L2.66746 22.5C2.30503 22.4992 1.96273 22.3309 1.7415 22.0432C1.52014 21.7553 1.44551 21.3808 1.54026 21.03L5.55234 6.16667H5.28821C4.71356 6.16595 4.18754 5.83896 3.9356 5.32199C3.68348 4.80466 3.75045 4.18952 4.10735 3.7382L5.42524 2.07212ZM15.6441 5.65668C15.3593 5.98107 14.9468 6.16769 14.5127 6.16667H7.28195L3.3215 20.8333H11.9622L15.6441 5.65668ZM13.8531 20.1216L16.4745 9.31536V18.8176L13.8531 20.1216ZM20.4493 20.0693L18.1446 9.83895V18.834L20.4493 20.0693ZM4.98701 4.81234C4.92919 4.69776 4.94399 4.56014 5.02487 4.46034L6.34357 2.79367C6.40684 2.71323 6.5039 2.66636 6.60657 2.66667L16.5236 2.66667L14.7767 4.87267C14.7134 4.95329 14.6162 5.00028 14.5134 5H5.28821C5.1595 5.00167 5.0417 4.92827 4.98701 4.81234ZM16.1658 20.8333H18.3443L17.2954 20.2714L16.1658 20.8333Z\\\" />\\n</g>\\n</svg>\\n\",\"pencil\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Pencil\\\">\\n<path id=\\\"Vector\\\" d=\\\"M18.6625 3.40078C18.4058 3.14416 18.0577 3 17.6947 3C17.3318 3 16.9837 3.14416 16.727 3.40078L14.793 5.33636L18.6638 9.20887L20.5992 7.27193C20.8558 7.01523 21 6.66711 21 6.30414C21 5.94117 20.8558 5.59306 20.5992 5.33636L18.6638 3.40078H18.6625ZM17.4744 10.397L13.6035 6.52453L5.86046 14.2682C3.70055 16.4282 3.14758 19.1235 3.00522 20.3624C2.99343 20.4482 3.00166 20.5356 3.02927 20.6177C3.05688 20.6998 3.10312 20.7744 3.16437 20.8356C3.22562 20.8969 3.30021 20.9431 3.38231 20.9707C3.46441 20.9983 3.55178 21.0066 3.63759 20.9948C4.87632 20.8538 7.5714 20.2994 9.7313 18.1407L17.4757 10.397H17.4744Z\\\" />\\n</g>\\n</svg>\\n\",\"person-filled\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Person - Filled\\\">\\n<g id=\\\"Vector\\\">\\n<path d=\\\"M12.0292 12.975C14.901 12.975 17.2293 10.0705 17.2293 6.48754C17.2293 2.90453 16.4649 0 12.0292 0C7.59338 0 6.82881 2.90453 6.82881 6.48754C6.82881 10.0705 9.15714 12.975 12.0292 12.975Z\\\" />\\n<path d=\\\"M2.18278 22.564C2.18101 22.5031 2.1819 22.3478 2.18278 22.564V22.564Z\\\" />\\n<path d=\\\"M21.8166 22.7328C21.8176 22.3223 21.8194 22.6736 21.8166 22.7328V22.7328Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M21.7935 20.1761C21.7969 20.3829 21.8004 20.5975 21.8046 20.82C21.8107 21.1446 21.814 21.2008 21.8156 21.1718C21.8154 21.2476 21.8153 21.3547 21.8153 21.5034C21.8152 21.5444 21.8051 21.5833 21.7806 21.6159C21.5195 21.9623 19.6584 24 11.9989 24C4.33924 24 2.47827 21.9623 2.21726 21.6159C2.19274 21.5833 2.18258 21.5444 2.18257 21.5034C2.18251 21.2587 2.1821 21.1141 2.18176 21.033C2.18339 21.0799 2.18759 21.0587 2.19666 20.6552C2.2004 20.4882 2.2038 20.3258 2.2071 20.168C2.30054 15.6994 2.31838 14.8461 7.95637 13.9803C8.05148 13.9657 8.14785 14.0136 8.19085 14.1011C8.60233 14.9383 10.4003 15.8571 11.9999 15.8571C13.5744 15.8571 15.4152 14.9357 15.8301 14.1001C15.8733 14.0131 15.9695 13.9655 16.0643 13.98C21.7058 14.8465 21.72 15.7115 21.7935 20.1761Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"person-outlined\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Person - Outlined\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12.0292 10.975C13.4063 10.975 15.2294 9.40141 15.2294 6.48754C15.2294 4.73874 15.0202 3.62714 14.6044 2.97234C14.3203 2.52505 13.7599 2 12.0292 2C10.2984 2 9.73797 2.52505 9.45388 2.97237C9.03801 3.62718 8.82883 4.73878 8.82883 6.48754C8.82883 9.40137 10.6519 10.975 12.0292 10.975ZM19.8013 20.6712C18.997 21.144 16.8665 22 11.9989 22C7.13472 22 5.00375 21.1452 4.19819 20.6722L4.20668 20.2098L4.20674 20.2072C4.23101 19.0467 4.25006 18.2948 4.33201 17.72C4.4093 17.1777 4.51477 17.0332 4.54978 16.9904C4.58575 16.9465 4.73522 16.7827 5.33848 16.5769C5.79947 16.4196 6.42214 16.2715 7.28264 16.1182C7.76342 16.5493 8.31578 16.8726 8.78875 17.0982C9.70538 17.5355 10.8484 17.8571 12 17.8571C13.1416 17.8571 14.2872 17.5335 15.204 17.1004C15.6713 16.8797 16.1272 16.6082 16.5255 16.2905C16.5928 16.2368 16.662 16.1789 16.7318 16.1169C17.5955 16.2709 18.2196 16.4198 18.6808 16.5779C19.2828 16.7842 19.4305 16.948 19.4653 16.9908C19.4995 17.0328 19.6045 17.1772 19.6795 17.72C19.759 18.2956 19.7747 19.048 19.7938 20.209L19.8013 20.6712ZM2.20712 20.168C2.30056 15.6994 2.3184 14.8461 7.95639 13.9803C8.0515 13.9657 8.14787 14.0136 8.19087 14.1011C8.60235 14.9383 10.4004 15.8571 12 15.8571C13.5744 15.8571 15.4152 14.9357 15.8301 14.1001C15.8733 14.0131 15.9695 13.9655 16.0643 13.98C21.7058 14.8465 21.72 15.7115 21.7935 20.1761L21.8153 21.5034C21.8153 21.5444 21.8051 21.5833 21.7806 21.6159C21.5195 21.9623 19.6584 24 11.9989 24C4.33926 24 2.47829 21.9623 2.21728 21.6159C2.19276 21.5833 2.1826 21.5444 2.18259 21.5034L2.20712 20.168ZM17.2294 6.48754C17.2294 10.0705 14.901 12.975 12.0292 12.975C9.15716 12.975 6.82883 10.0705 6.82883 6.48754C6.82883 2.90453 7.5934 0 12.0292 0C16.4649 0 17.2294 2.90453 17.2294 6.48754Z\\\" />\\n</g>\\n</svg>\\n\",\"phone-filled\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Phone - Filled\\\">\\n<path id=\\\"Vector\\\" d=\\\"M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7294C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1469 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5342 11.19 18.85C8.77382 17.3147 6.72533 15.2662 5.18999 12.85C3.49997 10.2412 2.44824 7.271 2.11999 4.18001C2.095 3.90347 2.12787 3.62477 2.21649 3.36163C2.30512 3.09849 2.44756 2.85669 2.63476 2.65163C2.82196 2.44656 3.0498 2.28271 3.30379 2.17053C3.55777 2.05834 3.83233 2.00027 4.10999 2.00001H7.10999C7.5953 1.99523 8.06579 2.16708 8.43376 2.48354C8.80173 2.79999 9.04207 3.23945 9.10999 3.72001C9.23662 4.68007 9.47144 5.62273 9.80999 6.53001C9.94454 6.88793 9.97366 7.27692 9.8939 7.65089C9.81415 8.02485 9.62886 8.36812 9.35999 8.64001L8.08999 9.91001C9.51355 12.4136 11.5864 14.4865 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9751 14.1859 16.3491 14.1061C16.7231 14.0263 17.1121 14.0555 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z\\\" />\\n</g>\\n</svg>\\n\",\"placeholder\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<rect width=\\\"1em\\\" height=\\\"1em\\\" />\\n</svg>\\n\",\"plus\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Plus\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 4C12.5523 4 13 4.44772 13 5V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V5C11 4.44772 11.4477 4 12 4Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"productlist-filled\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path d=\\\"M3 3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V23C21 23.388 20.7755 23.741 20.4242 23.9056C20.0728 24.0702 19.6579 24.0166 19.3598 23.7682L16 20.9684L12.6402 23.7682C12.2693 24.0773 11.7307 24.0773 11.3598 23.7682L8 20.9684L4.64018 23.7682C4.3421 24.0166 3.92723 24.0702 3.57584 23.9056C3.22446 23.741 3 23.388 3 23V3Z\\\" />\\n</svg>\\n\",\"productlist-outlined\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M3 3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V23C21 23.388 20.7755 23.741 20.4242 23.9056C20.0728 24.0702 19.6579 24.0166 19.3598 23.7682L16 20.9684L12.6402 23.7682C12.2693 24.0773 11.7307 24.0773 11.3598 23.7682L8 20.9684L4.64018 23.7682C4.3421 24.0166 3.92723 24.0702 3.57584 23.9056C3.22446 23.741 3 23.388 3 23V3ZM5 4V20.865L7.35982 18.8984C7.73066 18.5894 8.26934 18.5894 8.64018 18.8984L12 21.6983L15.3598 18.8984C15.7307 18.5894 16.2693 18.5894 16.6402 18.8984L19 20.865V4H5Z\\\" />\\n</svg>\\n\",\"productlist\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Product list\\\">\\n<path id=\\\"Vector 2 (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M3 3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V23C21 23.388 20.7755 23.741 20.4242 23.9056C20.0728 24.0702 19.6579 24.0166 19.3598 23.7682L16 20.9684L12.6402 23.7682C12.2693 24.0773 11.7307 24.0773 11.3598 23.7682L8 20.9684L4.64018 23.7682C4.3421 24.0166 3.92723 24.0702 3.57584 23.9056C3.22446 23.741 3 23.388 3 23V3ZM5 4V20.865L7.35982 18.8984C7.73066 18.5894 8.26934 18.5894 8.64018 18.8984L12 21.6983L15.3598 18.8984C15.7307 18.5894 16.2693 18.5894 16.6402 18.8984L19 20.865V4H5Z\\\" />\\n</g>\\n</svg>\\n\",\"qr\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"QR\\\">\\n<g id=\\\"Vector\\\">\\n<path d=\\\"M2 3C2 2.44772 2.44772 2 3 2H9C9.55228 2 10 2.44772 10 3V9C10 9.55228 9.55228 10 9 10H3C2.44772 10 2 9.55228 2 9V3Z\\\" />\\n<path d=\\\"M2 15C2 14.4477 2.44772 14 3 14H9C9.55228 14 10 14.4477 10 15V21C10 21.5523 9.55228 22 9 22H3C2.44772 22 2 21.5523 2 21V15Z\\\" />\\n<path d=\\\"M14 3C14 2.44772 14.4477 2 15 2H21C21.5523 2 22 2.44772 22 3V9C22 9.55228 21.5523 10 21 10H15C14.4477 10 14 9.55228 14 9V3Z\\\" />\\n<path d=\\\"M14 14.6667C14 14.2985 14.2985 14 14.6667 14H17.3333C17.7015 14 18 14.2985 18 14.6667V17.3333C18 17.7015 17.7015 18 17.3333 18H14.6667C14.2985 18 14 17.7015 14 17.3333V14.6667Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"qrwaitercheckmark\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"QRWaiter Checkmark\\\">\\n<path id=\\\"Exclude\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M17.9048 3.73328H3.73334V17.9047L6.09524 20.2666H20.2667V6.09518L17.9048 3.73328ZM15.2104 9.06721C15.0544 9.05962 14.9078 9.12605 14.798 9.25101L14.7956 9.25381C13.486 10.7866 12.1764 12.3089 10.8567 13.8412C10.3024 13.2837 9.75438 12.7339 9.19737 12.1839C9.0815 12.0646 8.93286 12.0079 8.78062 12.0204C8.6356 12.0323 8.51226 12.1046 8.4263 12.1955C8.25719 12.3745 8.17205 12.7112 8.42896 12.9675L8.42944 12.968C8.7748 13.3109 9.12023 13.6567 9.46612 14.003L9.46658 14.0035L9.46707 14.0039L9.46722 14.0041L9.46754 14.0044C9.8122 14.3495 10.1573 14.695 10.5025 15.0377C10.6953 15.2355 11.0669 15.2769 11.2846 15.0245L11.2867 15.0221L11.2888 15.0196C11.3186 14.9832 11.3489 14.949 11.3828 14.9106L11.3841 14.9092L11.3841 14.9092C11.4162 14.8729 11.4517 14.8328 11.4876 14.7893C11.8195 14.4036 12.1516 14.0184 12.4836 13.6333L12.4844 13.6324L12.4852 13.6315L12.486 13.6305C13.5236 12.427 14.5606 11.2242 15.5909 10.0084C15.8211 9.74428 15.7427 9.4167 15.5702 9.23668C15.4831 9.14588 15.3577 9.07437 15.2104 9.06721Z\\\" />\\n</g>\\n</svg>\\n\",\"qrwaitercross\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"QRWaiter Cross\\\">\\n<path id=\\\"Exclude\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M17.9048 3.73328H3.73334V17.9047L6.09524 20.2666H20.2667V6.09518L17.9048 3.73328ZM8.4793 14.6513L10.9865 12.1511L8.44336 9.61496C8.20774 9.37998 8.20781 8.99862 8.44336 8.76361C8.67871 8.52877 9.05983 8.52896 9.29513 8.76361L11.8393 11.3007L14.4381 8.70913C14.6734 8.47448 15.0546 8.47473 15.2899 8.70913C15.5256 8.94419 15.5253 9.32556 15.2899 9.56063L12.692 12.1511L15.2538 14.7058C15.4895 14.9408 15.4895 15.3223 15.2538 15.5573C15.136 15.6748 14.9813 15.7332 14.828 15.7332C14.6743 15.7332 14.5196 15.6745 14.402 15.5572L11.8393 13.0015L9.33106 15.5027C9.2132 15.6202 9.0585 15.6787 8.90511 15.6787C8.7515 15.6787 8.59687 15.6199 8.4793 15.5027C8.24364 15.2677 8.24364 14.8863 8.4793 14.6513Z\\\" />\\n</g>\\n</svg>\\n\",\"rocket\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Rocket\\\">\\n<g id=\\\"Vector\\\">\\n<path d=\\\"M21.5896 2.00175C17.6855 1.93174 13.2331 3.97265 10.4149 7.13861C7.72158 7.18945 5.09914 8.29365 3.16834 10.2246C3.05585 10.3354 3.01585 10.5012 3.06501 10.6512C3.11501 10.8021 3.24501 10.9113 3.40167 10.9338L6.61327 11.3938L6.21661 11.838C6.06912 12.003 6.07662 12.2538 6.23328 12.4105L11.589 17.7665C11.6698 17.8474 11.7765 17.8882 11.884 17.8882C11.9832 17.8882 12.0823 17.8532 12.1615 17.7824L12.6056 17.3857L13.0656 20.5975C13.0881 20.7541 13.2115 20.8691 13.3606 20.9191C13.399 20.9316 13.439 20.9375 13.4798 20.9375C13.5981 20.9375 13.719 20.8858 13.8023 20.8033C15.7064 18.8991 16.8106 16.2765 16.8614 13.583C20.0305 10.7587 22.0879 6.30774 21.9971 2.40843C21.9913 2.18675 21.8121 2.00758 21.5896 2.00175ZM17.7497 9.19536C17.3439 9.6012 16.8106 9.80455 16.2764 9.80455C15.7422 9.80455 15.2089 9.6012 14.8031 9.19536C13.9914 8.38282 13.9914 7.06111 14.8031 6.24858C15.6156 5.43604 16.9372 5.43604 17.7497 6.24858C18.5622 7.06111 18.5622 8.38366 17.7497 9.19536Z\\\" />\\n<path d=\\\"M4.27 16.0873C3.37835 16.979 2.15421 21.0075 2.01755 21.4633C1.97338 21.61 2.01421 21.7692 2.12171 21.8775C2.20171 21.9575 2.30754 22 2.41671 22C2.4567 22 2.4967 21.9942 2.5367 21.9825C2.99253 21.8458 7.02077 20.6216 7.91242 19.7299C8.91657 18.7257 8.91657 17.0915 7.91242 16.0873C6.90744 15.0831 5.27415 15.0839 4.27 16.0873Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"rotate-left\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Rotate - Left\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1 2.99763C1.55229 2.99763 2 3.44535 2 3.99763V8.99763H7C7.55229 8.99763 8 9.44535 8 9.99763C8 10.5499 7.55229 10.9976 7 10.9976H1C0.447718 10.9976 3.02242e-06 10.5499 3.02242e-06 9.99763V3.99763C3.02242e-06 3.44535 0.447718 2.99763 1 2.99763Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M16 13.9976C16 13.4453 16.4477 12.9976 17 12.9976H23C23.5523 12.9976 24 13.4453 24 13.9976V19.9976C24 20.5499 23.5523 20.9976 23 20.9976C22.4477 20.9976 22 20.5499 22 19.9976V14.9976H17C16.4477 14.9976 16 14.5499 16 13.9976Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M9.22695 2.39379C10.8497 1.92442 12.5648 1.87376 14.2124 2.24655C15.86 2.61933 17.3863 3.40341 18.6489 4.52561C19.9115 5.64782 20.8692 7.07158 21.4327 8.66404C21.617 9.18469 21.3442 9.75611 20.8236 9.94035C20.303 10.1246 19.7315 9.85188 19.5473 9.33123C19.0965 8.05726 18.3303 6.91825 17.3202 6.02049C16.3101 5.12273 15.0891 4.49547 13.771 4.19724C12.453 3.89901 11.0808 3.93953 9.78267 4.31503C8.48451 4.69053 7.30262 5.38875 6.34729 6.34456C6.3399 6.35196 6.3324 6.35923 6.32478 6.36639L1.68478 10.7264C1.2823 11.1046 0.649442 11.0849 0.27125 10.6824C-0.106942 10.2799 -0.0872528 9.64707 0.315226 9.26888L4.9441 4.91933C6.13627 3.7304 7.6094 2.86167 9.22695 2.39379ZM23.7288 13.3129C24.1069 13.7153 24.0873 14.3482 23.6848 14.7264L19.0559 19.076C17.8637 20.2649 16.3906 21.1336 14.7731 21.6015C13.1503 22.0709 11.4352 22.1215 9.78761 21.7487C8.14003 21.3759 6.61373 20.5919 5.35114 19.4697C4.08855 18.3474 3.13081 16.9237 2.56729 15.3312C2.38305 14.8106 2.65576 14.2392 3.17641 14.0549C3.69705 13.8707 4.26848 14.1434 4.45272 14.664C4.90353 15.938 5.66973 17.077 6.6798 17.9748C7.68988 18.8725 8.91091 19.4998 10.229 19.798C11.547 20.0963 12.9192 20.0557 14.2173 19.6802C15.5155 19.3047 16.6974 18.6065 17.6527 17.6507C17.6572 17.6463 17.6616 17.6419 17.6662 17.6375C17.6692 17.6346 17.6722 17.6317 17.6752 17.6289L22.3152 13.2689C22.7177 12.8907 23.3506 12.9104 23.7288 13.3129Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"rotate-right\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Rotate - Right\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M23 2.99763C23.5523 2.99763 24 3.44535 24 3.99763V9.99763C24 10.5499 23.5523 10.9976 23 10.9976H17C16.4477 10.9976 16 10.5499 16 9.99763C16 9.44535 16.4477 8.99763 17 8.99763H22V3.99763C22 3.44535 22.4477 2.99763 23 2.99763Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2.9977e-06 13.9976C2.9977e-06 13.4453 0.447718 12.9976 1 12.9976H7C7.55229 12.9976 8 13.4453 8 13.9976C8 14.5499 7.55229 14.9976 7 14.9976H2V19.9976C2 20.5499 1.55229 20.9976 1 20.9976C0.447718 20.9976 2.9977e-06 20.5499 2.9977e-06 19.9976V13.9976Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M14.2173 4.31503C12.9192 3.93953 11.547 3.89901 10.229 4.19724C8.91091 4.49547 7.68987 5.12273 6.6798 6.02049C5.66973 6.91825 4.90353 8.05726 4.45272 9.33123C4.26848 9.85188 3.69705 10.1246 3.17641 9.94035C2.65576 9.75611 2.38305 9.18469 2.56729 8.66404C3.13081 7.07158 4.08855 5.64782 5.35114 4.52561C6.61373 3.40341 8.14003 2.61933 9.78761 2.24655C11.4352 1.87376 13.1503 1.92442 14.7731 2.39379C16.3906 2.86166 17.8637 3.7304 19.0559 4.91932L23.6848 9.26888C24.0873 9.64707 24.1069 10.2799 23.7288 10.6824C23.3506 11.0849 22.7177 11.1046 22.3152 10.7264L17.6752 6.36639C17.6676 6.35923 17.6601 6.35196 17.6527 6.34456C16.6974 5.38875 15.5155 4.69053 14.2173 4.31503ZM0.27125 13.3129C0.649442 12.9104 1.2823 12.8907 1.68478 13.2689L6.32478 17.6289C6.3324 17.636 6.3399 17.6433 6.34729 17.6507C7.30262 18.6065 8.48451 19.3047 9.78267 19.6802C11.0808 20.0557 12.453 20.0963 13.771 19.798C15.0891 19.4998 16.3101 18.8725 17.3202 17.9748C18.3303 17.077 19.0965 15.938 19.5473 14.664C19.7315 14.1434 20.303 13.8707 20.8236 14.0549C21.3442 14.2392 21.617 14.8106 21.4327 15.3312C20.8692 16.9237 19.9115 18.3474 18.6489 19.4697C17.3863 20.5919 15.86 21.3759 14.2124 21.7487C12.5648 22.1215 10.8497 22.0709 9.22695 21.6015C7.6094 21.1336 6.13627 20.2649 4.94411 19.0759L0.315226 14.7264C-0.0872528 14.3482 -0.106942 13.7153 0.27125 13.3129Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"scale\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Scale\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M14 3C14 2.44772 14.4477 2 15 2H21C21.5523 2 22 2.44772 22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V4H15C14.4477 4 14 3.55228 14 3Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M3 14C3.55228 14 4 14.4477 4 15V20H9C9.55228 20 10 20.4477 10 21C10 21.5523 9.55228 22 9 22H3C2.44772 22 2 21.5523 2 21V15C2 14.4477 2.44772 14 3 14Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L14.7071 10.7071C14.3166 11.0976 13.6834 11.0976 13.2929 10.7071C12.9024 10.3166 12.9024 9.68342 13.2929 9.29289L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M10.7071 13.2929C11.0976 13.6834 11.0976 14.3166 10.7071 14.7071L3.70711 21.7071C3.31658 22.0976 2.68342 22.0976 2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L9.29289 13.2929C9.68342 12.9024 10.3166 12.9024 10.7071 13.2929Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"scooter\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path d=\\\"M11.5 8.25001C11.5 7.69772 11.0523 7.25001 10.5 7.25001H6.7875C6.35258 7.25001 6 7.60258 6 8.03751C6 8.47243 6.35258 8.82501 6.7875 8.82501H8H11.5V8.25001Z\\\" />\\n<path d=\\\"M1 19.325C1 21.425 2.5 23 4.5 23C6.5 23 8 21.425 8 19.325H6.5C6.5 20.9 5.5 21.425 4.5 21.425C3.5 21.425 2.5 20.9 2.5 19.325H1Z\\\" />\\n<path d=\\\"M16 19.325C16 21.425 17.5 23 19.5 23C21.5 23 23 21.425 23 19.325H21.5C21.5 20.375 21 21.425 19.5 21.425C18 21.425 17.5 20.375 17.5 19.325H16Z\\\" />\\n<path d=\\\"M19 5.675C19.5523 5.675 20 5.22728 20 4.675V3C20 2.44772 19.5512 1.99373 19.0002 2.03258C16.9896 2.17438 15.5165 2.81407 15.62 4.62501L17.0455 4.62499C16.6586 3.50789 17.8038 3.18311 18.5024 3.08868C18.776 3.05169 19 3.27383 19 3.54998V4.12498C19 4.40112 18.7761 4.62498 18.5 4.62498L17.0455 4.62499L17.3182 5.675H19Z\\\" />\\n<path d=\\\"M15.7 5.675H17.3182L17.0455 4.62499L15.62 4.62501L15.7 5.675Z\\\" />\\n<path d=\\\"M15.025 4.62501C14.735 4.62501 14.5 4.86006 14.5 5.15C14.5 5.43995 14.735 5.675 15.025 5.675H15.7L15.62 4.62501L15.025 4.62501Z\\\" />\\n<path d=\\\"M19 3.54998C19 3.27383 18.776 3.05169 18.5024 3.08868C17.8038 3.18311 16.6586 3.50789 17.0455 4.62499L18.5 4.62498C18.7761 4.62498 19 4.40112 19 4.12498V3.54998Z\\\" />\\n<path d=\\\"M24 18.3791C24 15.65 21.5 14.075 19.5 14.075L17.3182 5.675H15.7L16.418 15.099C16.4623 15.6796 16.0031 16.175 15.4209 16.175L10 16.175C9.44771 16.175 8.99736 15.7253 9.01167 15.1732C9.0789 12.5803 9.45126 11.7609 10.5047 11.5308C11.0443 11.413 11.5 11.0023 11.5 10.45V8.82501H8C4 8.825 0 13.025 0 18.3791C0 18.9015 0.423514 19.325 0.945945 19.325H1H2.5H4V19.35C4 19.6261 4.22386 19.85 4.5 19.85C4.77614 19.85 5 19.6261 5 19.35V19.325H6.5H8H16H17.5H19V19.35C19 19.6261 19.2239 19.85 19.5 19.85C19.7761 19.85 20 19.6261 20 19.35V19.325H21.5H23H23.0541C23.5765 19.325 24 18.9015 24 18.3791Z\\\" />\\n</svg>\\n\",\"search\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Search\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M15.9429 15.9429C16.3334 15.5524 16.9666 15.5524 17.3571 15.9429L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L15.9429 17.3571C15.5524 16.9666 15.5524 16.3334 15.9429 15.9429Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"settings-filled\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Settings - Filled\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 2C11.7348 2 11.4804 2.10536 11.2929 2.29289C11.1054 2.48043 11 2.73478 11 3V3.17399C10.9979 3.6908 10.8448 4.19572 10.5594 4.62661C10.2741 5.0575 9.86895 5.39555 9.39393 5.59914C9.30938 5.63538 9.22042 5.65969 9.12961 5.67157C8.69798 5.82272 8.23333 5.85998 7.781 5.77796C7.26 5.68349 6.77925 5.43512 6.40073 5.06486L6.39285 5.05715L6.33289 4.99711C6.24002 4.90413 6.12934 4.82998 6.00794 4.77965C5.88654 4.72933 5.75642 4.70343 5.625 4.70343C5.49358 4.70343 5.36346 4.72933 5.24206 4.77965C5.12066 4.82998 5.01037 4.90374 4.9175 4.99671L4.91671 4.9975C4.82374 5.09037 4.74998 5.20066 4.69965 5.32206C4.64933 5.44346 4.62343 5.57358 4.62343 5.705C4.62343 5.83642 4.64933 5.96654 4.69965 6.08794C4.74998 6.20934 4.82374 6.31963 4.91671 6.4125L4.98491 6.48069C5.35516 6.85921 5.60349 7.34 5.69796 7.861C5.79055 8.37163 5.73113 8.89797 5.52745 9.37478C5.34189 9.86133 5.01698 10.2827 4.59305 10.5859C4.16054 10.8952 3.64498 11.0673 3.11338 11.0797L3.09 11.08H3C2.73478 11.08 2.48043 11.1854 2.29289 11.3729C2.10536 11.5604 2 11.8148 2 12.08C2 12.3452 2.10536 12.5996 2.29289 12.7871C2.48043 12.9746 2.73478 13.08 3 13.08H3.17399C3.6908 13.0821 4.19572 13.2352 4.62661 13.5206C5.05601 13.8049 5.3932 14.2082 5.59701 14.6811C5.80908 15.1643 5.87211 15.6998 5.77796 16.219C5.68349 16.74 5.43512 17.2207 5.06486 17.5993L5.05715 17.6072L4.9971 17.6671C4.90413 17.76 4.82998 17.8707 4.77965 17.9921C4.72933 18.1135 4.70343 18.2436 4.70343 18.375C4.70343 18.5064 4.72933 18.6365 4.77965 18.7579C4.82998 18.8793 4.90374 18.9896 4.99671 19.0825L4.9975 19.0833C5.09037 19.1763 5.20066 19.25 5.32206 19.3003C5.44346 19.3507 5.57359 19.3766 5.705 19.3766C5.83641 19.3766 5.96654 19.3507 6.08794 19.3003C6.20934 19.25 6.31963 19.1763 6.4125 19.0833L6.48069 19.0151C6.85921 18.6448 7.34 18.3965 7.861 18.302C8.37163 18.2095 8.89796 18.2689 9.37477 18.4725C9.86132 18.6581 10.2827 18.983 10.5859 19.407C10.8952 19.8395 11.0673 20.355 11.0797 20.8866L11.08 20.91V21C11.08 21.2652 11.1854 21.5196 11.3729 21.7071C11.5604 21.8946 11.8148 22 12.08 22C12.3452 22 12.5996 21.8946 12.7871 21.7071C12.9746 21.5196 13.08 21.2652 13.08 21V20.83L13.08 20.826C13.0821 20.3092 13.2352 19.8043 13.5206 19.3734C13.805 18.944 14.2083 18.6067 14.6812 18.4029C15.1643 18.1909 15.6998 18.1279 16.219 18.222C16.74 18.3165 17.2207 18.5649 17.5993 18.9351L17.6071 18.9429L17.6671 19.0029C17.76 19.0959 17.8707 19.17 17.9921 19.2203C18.1135 19.2707 18.2436 19.2966 18.375 19.2966C18.5064 19.2966 18.6365 19.2707 18.7579 19.2203C18.8793 19.17 18.9896 19.0963 19.0825 19.0033L19.0833 19.0025C19.1763 18.9096 19.25 18.7993 19.3003 18.6779C19.3507 18.5565 19.3766 18.4264 19.3766 18.295C19.3766 18.1636 19.3507 18.0335 19.3003 17.9121C19.25 17.7907 19.1763 17.6804 19.0833 17.5875L19.0151 17.5193C18.6448 17.1408 18.3965 16.66 18.302 16.139C18.2079 15.6198 18.2709 15.0843 18.4829 14.6012C18.6867 14.1283 19.024 13.725 19.4534 13.4406C19.8843 13.1552 20.3892 13.0021 20.906 13L20.91 13L21 13C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5196 22 12.2652 22 12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1054 21.2652 11 21 11H20.83L20.826 11C20.3092 10.9979 19.8043 10.8448 19.3734 10.5594C18.9425 10.2741 18.6045 9.86896 18.4009 9.39393C18.3646 9.30938 18.3403 9.22042 18.3284 9.12961C18.1773 8.69798 18.14 8.23332 18.222 7.781C18.3165 7.26 18.5649 6.77925 18.9351 6.40073L18.9428 6.39285L19.0029 6.3329C19.0959 6.24002 19.17 6.12934 19.2203 6.00794C19.2707 5.88654 19.2966 5.75641 19.2966 5.625C19.2966 5.49359 19.2707 5.36346 19.2203 5.24206C19.17 5.12066 19.0963 5.01037 19.0033 4.9175L19.0025 4.91671C18.9096 4.82374 18.7993 4.74998 18.6779 4.69965C18.5565 4.64933 18.4264 4.62343 18.295 4.62343C18.1636 4.62343 18.0335 4.64933 17.9121 4.69965C17.7907 4.74998 17.6804 4.82374 17.5875 4.91671L17.5193 4.98491C17.1408 5.35516 16.66 5.60349 16.139 5.69796C15.6198 5.79211 15.0843 5.72908 14.6011 5.51701C14.1282 5.3132 13.7249 4.97601 13.4406 4.54661C13.1552 4.11572 13.0021 3.6108 13 3.09399L13 3.09V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2ZM19.4 15L20.3149 15.4038C20.2624 15.5226 20.2468 15.6544 20.27 15.7822C20.2929 15.9086 20.3527 16.0253 20.4419 16.1177L20.4967 16.1725C20.7755 16.451 20.997 16.7822 21.1479 17.1462C21.2989 17.5104 21.3766 17.9008 21.3766 18.295C21.3766 18.6892 21.2989 19.0796 21.1479 19.4438C20.9969 19.808 20.7756 20.1389 20.4967 20.4175L19.79 19.71L20.4975 20.4167C20.2189 20.6956 19.888 20.9169 19.5238 21.0679C19.1596 21.2189 18.7692 21.2966 18.375 21.2966C17.9808 21.2966 17.5904 21.2189 17.2262 21.0679C16.8622 20.917 16.5314 20.6959 16.2529 20.4171L16.1977 20.3619C16.1053 20.2727 15.9886 20.2129 15.8622 20.19C15.7344 20.1668 15.6026 20.1824 15.4838 20.2349L15.474 20.2392C15.3574 20.2891 15.258 20.372 15.1881 20.4777C15.1183 20.583 15.0808 20.7063 15.08 20.8325V21C15.08 21.7957 14.7639 22.5587 14.2013 23.1213C13.6387 23.6839 12.8757 24 12.08 24C11.2843 24 10.5213 23.6839 9.95868 23.1213C9.39607 22.5587 9.08 21.7957 9.08 21V20.9244C9.07526 20.7972 9.03327 20.6741 8.95914 20.5704C8.88326 20.4644 8.77723 20.3836 8.65482 20.3385C8.63505 20.3313 8.61551 20.3234 8.59624 20.3149C8.47742 20.2624 8.34561 20.2468 8.21782 20.27C8.09142 20.2929 7.97467 20.3527 7.8823 20.4419L7.8275 20.4967C7.54896 20.7755 7.21784 20.997 6.85382 21.1479C6.48963 21.2989 6.09925 21.3766 5.705 21.3766C5.31075 21.3766 4.92037 21.2989 4.55618 21.1479C4.19233 20.9971 3.86174 20.7761 3.58329 20.4975C3.30436 20.2189 3.08308 19.888 2.93211 19.5238C2.78113 19.1596 2.70343 18.7692 2.70343 18.375C2.70343 17.9808 2.78113 17.5904 2.93211 17.2262C3.08308 16.862 3.30436 16.5311 3.58329 16.2525L3.63811 16.1977C3.72728 16.1053 3.78713 15.9886 3.81005 15.8622C3.83322 15.7344 3.81758 15.6026 3.76514 15.4838L3.76081 15.474C3.71087 15.3574 3.62801 15.258 3.52232 15.1881C3.41704 15.1183 3.29374 15.0808 3.1675 15.08H3C2.20435 15.08 1.44129 14.7639 0.87868 14.2013C0.316071 13.6387 0 12.8756 0 12.08C0 11.2844 0.316071 10.5213 0.87868 9.95868C1.44129 9.39607 2.20435 9.08 3 9.08H3.07564C3.20283 9.07526 3.32591 9.03327 3.42955 8.95914C3.53564 8.88326 3.61644 8.77723 3.66146 8.65482C3.66874 8.63505 3.67663 8.61551 3.68514 8.59624C3.73758 8.47742 3.75322 8.34561 3.73005 8.21782C3.70713 8.09142 3.64728 7.97468 3.5581 7.88231L3.50329 7.8275C3.22436 7.54888 3.00308 7.21802 2.85211 6.85382C2.70113 6.48963 2.62343 6.09925 2.62343 5.705C2.62343 5.31075 2.70113 4.92037 2.85211 4.55618C3.00301 4.19216 3.22415 3.86143 3.50289 3.58289C3.78143 3.30415 4.11216 3.08301 4.47618 2.93211C4.84037 2.78113 5.23075 2.70343 5.625 2.70343C6.01925 2.70343 6.40963 2.78113 6.77382 2.93211C7.13802 3.08308 7.46888 3.30436 7.7475 3.58329L7.80231 3.6381C7.89468 3.72728 8.01142 3.78713 8.13782 3.81005C8.26561 3.83322 8.39742 3.81758 8.51624 3.76514C8.58027 3.73687 8.64693 3.71549 8.71507 3.70122C8.78479 3.6539 8.84498 3.59323 8.89195 3.52232C8.96167 3.41704 8.99921 3.29374 9 3.1675V3C9 2.20435 9.31607 1.44129 9.87868 0.87868C10.4413 0.316071 11.2044 0 12 0C12.7956 0 13.5587 0.316071 14.1213 0.87868C14.6839 1.44129 15 2.20435 15 3V3.0875C15.0008 3.21374 15.0383 3.33704 15.1081 3.44232C15.178 3.54801 15.2774 3.63092 15.3939 3.68086L15.4038 3.68508C15.5226 3.73752 15.6544 3.75322 15.7822 3.73005C15.9086 3.70713 16.0253 3.64728 16.1177 3.55811L16.1725 3.50329C16.4511 3.22436 16.782 3.00308 17.1462 2.85211C17.5104 2.70113 17.9008 2.62343 18.295 2.62343C18.6892 2.62343 19.0796 2.70113 19.4438 2.85211C19.808 3.00308 20.1389 3.22436 20.4175 3.50329C20.6961 3.78174 20.9171 4.11233 21.0679 4.47618C21.2189 4.84037 21.2966 5.23075 21.2966 5.625C21.2966 6.01925 21.2189 6.40963 21.0679 6.77382C20.917 7.13784 20.6959 7.46857 20.4171 7.7471L20.3619 7.80231C20.2727 7.89468 20.2129 8.01142 20.19 8.13782C20.1668 8.26561 20.1824 8.39742 20.2349 8.51624C20.2631 8.58027 20.2845 8.64692 20.2988 8.71507C20.3461 8.78479 20.4068 8.84498 20.4777 8.89195C20.583 8.96167 20.7063 8.99921 20.8325 9H21C21.7957 9 22.5587 9.31607 23.1213 9.87868C23.6839 10.4413 24 11.2043 24 12C24 12.7957 23.6839 13.5587 23.1213 14.1213C22.5587 14.6839 21.7957 15 21 15H20.9125C20.7863 15.0008 20.663 15.0383 20.5577 15.1081C20.452 15.178 20.3691 15.2774 20.3191 15.3939L19.4 15Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.2929 2.29289C11.4804 2.10536 11.7348 2 12 2C12.2652 2 12.5196 2.10536 12.7071 2.29289C12.8946 2.48043 13 2.73478 13 3V3.09L13 3.09399C13.0021 3.6108 13.1552 4.11572 13.4406 4.54661C13.7249 4.97601 14.1282 5.3132 14.6011 5.51701C15.0843 5.72908 15.6198 5.79211 16.139 5.69796C16.66 5.60349 17.1408 5.35516 17.5193 4.98491L17.5875 4.91671C17.6804 4.82374 17.7907 4.74998 17.9121 4.69965C18.0335 4.64933 18.1636 4.62343 18.295 4.62343C18.4264 4.62343 18.5565 4.64933 18.6779 4.69965C18.7993 4.74998 18.9096 4.82374 19.0025 4.91671L19.0033 4.9175C19.0963 5.01037 19.17 5.12066 19.2203 5.24206C19.2707 5.36346 19.2966 5.49359 19.2966 5.625C19.2966 5.75641 19.2707 5.88654 19.2203 6.00794C19.17 6.12934 19.0959 6.24002 19.0029 6.3329L18.9428 6.39285L18.9351 6.40073C18.5649 6.77925 18.3165 7.26 18.222 7.781C18.14 8.23332 18.1773 8.69798 18.3284 9.12961C18.3403 9.22042 18.3646 9.30938 18.4009 9.39393C18.6045 9.86896 18.9425 10.2741 19.3734 10.5594C19.8043 10.8448 20.3092 10.9979 20.826 11L20.83 11H21C21.2652 11 21.5196 11.1054 21.7071 11.2929C21.8946 11.4804 22 11.7348 22 12C22 12.2652 21.8946 12.5196 21.7071 12.7071C21.5196 12.8946 21.2652 13 21 13L20.91 13L20.906 13C20.3892 13.0021 19.8843 13.1552 19.4534 13.4406C19.024 13.725 18.6867 14.1283 18.4829 14.6012C18.2709 15.0843 18.2079 15.6198 18.302 16.139C18.3965 16.66 18.6448 17.1408 19.0151 17.5193L19.0833 17.5875C19.1763 17.6804 19.25 17.7907 19.3003 17.9121C19.3507 18.0335 19.3766 18.1636 19.3766 18.295C19.3766 18.4264 19.3507 18.5565 19.3003 18.6779C19.25 18.7993 19.1763 18.9096 19.0833 19.0025L19.0825 19.0033C18.9896 19.0963 18.8793 19.17 18.7579 19.2203C18.6365 19.2707 18.5064 19.2966 18.375 19.2966C18.2436 19.2966 18.1135 19.2707 17.9921 19.2203C17.8707 19.17 17.76 19.0959 17.6671 19.0029L17.6071 18.9429L17.5993 18.9351C17.2207 18.5649 16.74 18.3165 16.219 18.222C15.6998 18.1279 15.1643 18.1909 14.6812 18.4029C14.2083 18.6067 13.805 18.944 13.5206 19.3734C13.2352 19.8043 13.0821 20.3092 13.08 20.826L13.08 20.83V21C13.08 21.2652 12.9746 21.5196 12.7871 21.7071C12.5996 21.8946 12.3452 22 12.08 22C11.8148 22 11.5604 21.8946 11.3729 21.7071C11.1854 21.5196 11.08 21.2652 11.08 21V20.91L11.0797 20.8866C11.0673 20.355 10.8952 19.8395 10.5859 19.407C10.2827 18.983 9.86132 18.6581 9.37477 18.4725C8.89796 18.2689 8.37163 18.2095 7.861 18.302C7.34 18.3965 6.85921 18.6448 6.48069 19.0151L6.4125 19.0833C6.31963 19.1763 6.20934 19.25 6.08794 19.3003C5.96654 19.3507 5.83641 19.3766 5.705 19.3766C5.57359 19.3766 5.44346 19.3507 5.32206 19.3003C5.20066 19.25 5.09037 19.1763 4.9975 19.0833L4.99671 19.0825C4.90374 18.9896 4.82998 18.8793 4.77965 18.7579C4.72933 18.6365 4.70343 18.5064 4.70343 18.375C4.70343 18.2436 4.72933 18.1135 4.77965 17.9921C4.82998 17.8707 4.90413 17.76 4.9971 17.6671L5.05715 17.6072L5.06486 17.5993C5.43512 17.2207 5.68349 16.74 5.77796 16.219C5.87211 15.6998 5.80908 15.1643 5.59701 14.6811C5.3932 14.2082 5.05601 13.8049 4.62661 13.5206C4.19572 13.2352 3.6908 13.0821 3.17399 13.08H3C2.73478 13.08 2.48043 12.9746 2.29289 12.7871C2.10536 12.5996 2 12.3452 2 12.08C2 11.8148 2.10536 11.5604 2.29289 11.3729C2.48043 11.1854 2.73478 11.08 3 11.08H3.09L3.11338 11.0797C3.64498 11.0673 4.16054 10.8952 4.59305 10.5859C5.01698 10.2827 5.34189 9.86133 5.52745 9.37478C5.73113 8.89797 5.79055 8.37163 5.69796 7.861C5.60349 7.34 5.35516 6.85921 4.98491 6.48069L4.91671 6.4125C4.82374 6.31963 4.74998 6.20934 4.69965 6.08794C4.64933 5.96654 4.62343 5.83642 4.62343 5.705C4.62343 5.57358 4.64933 5.44346 4.69965 5.32206C4.74998 5.20066 4.82374 5.09037 4.91671 4.9975L4.9175 4.99671C5.01037 4.90374 5.12066 4.82998 5.24206 4.77965C5.36346 4.72933 5.49358 4.70343 5.625 4.70343C5.75642 4.70343 5.88654 4.72933 6.00794 4.77965C6.12934 4.82998 6.24002 4.90413 6.33289 4.99711L6.39285 5.05715L6.40073 5.06486C6.77925 5.43512 7.26 5.68349 7.781 5.77796C8.23333 5.85998 8.69798 5.82272 9.12961 5.67157C9.22042 5.65969 9.30938 5.63538 9.39393 5.59914C9.86895 5.39555 10.2741 5.0575 10.5594 4.62661C10.8448 4.19572 10.9979 3.6908 11 3.17399V3C11 2.73478 11.1054 2.48043 11.2929 2.29289ZM8.00057 12.0005C8.00057 9.79141 9.79143 8.00054 12.0006 8.00054C14.2097 8.00054 16.0006 9.79141 16.0006 12.0005C16.0006 14.2097 14.2097 16.0005 12.0006 16.0005C9.79143 16.0005 8.00057 14.2097 8.00057 12.0005Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"settings-outlined\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Settings - Outlined\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12.0006 10.0005C10.896 10.0005 10.0006 10.896 10.0006 12.0005C10.0006 13.1051 10.896 14.0005 12.0006 14.0005C13.1051 14.0005 14.0006 13.1051 14.0006 12.0005C14.0006 10.896 13.1051 10.0005 12.0006 10.0005ZM8.00057 12.0005C8.00057 9.79141 9.79143 8.00054 12.0006 8.00054C14.2097 8.00054 16.0006 9.79141 16.0006 12.0005C16.0006 14.2097 14.2097 16.0005 12.0006 16.0005C9.79143 16.0005 8.00057 14.2097 8.00057 12.0005Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 2C11.7348 2 11.4804 2.10536 11.2929 2.29289C11.1054 2.48043 11 2.73478 11 3V3.17399C10.9979 3.6908 10.8448 4.19572 10.5594 4.62661C10.2741 5.0575 9.86895 5.39555 9.39393 5.59914C9.30938 5.63538 9.22042 5.65969 9.12961 5.67157C8.69798 5.82272 8.23333 5.85998 7.781 5.77796C7.26 5.68349 6.77925 5.43512 6.40073 5.06486L6.39285 5.05715L6.33289 4.99711C6.24002 4.90413 6.12934 4.82998 6.00794 4.77965C5.88654 4.72933 5.75642 4.70343 5.625 4.70343C5.49358 4.70343 5.36346 4.72933 5.24206 4.77965C5.12066 4.82998 5.01037 4.90374 4.9175 4.99671L4.91671 4.9975C4.82374 5.09037 4.74998 5.20066 4.69965 5.32206C4.64933 5.44346 4.62343 5.57358 4.62343 5.705C4.62343 5.83642 4.64933 5.96654 4.69965 6.08794C4.74998 6.20934 4.82374 6.31963 4.91671 6.4125L4.98491 6.48069C5.35516 6.85921 5.60349 7.34 5.69796 7.861C5.79055 8.37163 5.73113 8.89797 5.52745 9.37478C5.34189 9.86133 5.01698 10.2827 4.59305 10.5859C4.16054 10.8952 3.64498 11.0673 3.11338 11.0797L3.09 11.08H3C2.73478 11.08 2.48043 11.1854 2.29289 11.3729C2.10536 11.5604 2 11.8148 2 12.08C2 12.3452 2.10536 12.5996 2.29289 12.7871C2.48043 12.9746 2.73478 13.08 3 13.08H3.17399C3.6908 13.0821 4.19572 13.2352 4.62661 13.5206C5.05601 13.8049 5.3932 14.2082 5.59701 14.6811C5.80908 15.1643 5.87211 15.6998 5.77796 16.219C5.68349 16.74 5.43512 17.2207 5.06486 17.5993L5.05715 17.6072L4.9971 17.6671C4.90413 17.76 4.82998 17.8707 4.77965 17.9921C4.72933 18.1135 4.70343 18.2436 4.70343 18.375C4.70343 18.5064 4.72933 18.6365 4.77965 18.7579C4.82998 18.8793 4.90374 18.9896 4.99671 19.0825L4.9975 19.0833C5.09037 19.1763 5.20066 19.25 5.32206 19.3003C5.44346 19.3507 5.57359 19.3766 5.705 19.3766C5.83641 19.3766 5.96654 19.3507 6.08794 19.3003C6.20934 19.25 6.31963 19.1763 6.4125 19.0833L6.48069 19.0151C6.85921 18.6448 7.34 18.3965 7.861 18.302C8.37163 18.2095 8.89796 18.2689 9.37477 18.4725C9.86132 18.6581 10.2827 18.983 10.5859 19.407C10.8952 19.8395 11.0673 20.355 11.0797 20.8866L11.08 20.91V21C11.08 21.2652 11.1854 21.5196 11.3729 21.7071C11.5604 21.8946 11.8148 22 12.08 22C12.3452 22 12.5996 21.8946 12.7871 21.7071C12.9746 21.5196 13.08 21.2652 13.08 21V20.83L13.08 20.826C13.0821 20.3092 13.2352 19.8043 13.5206 19.3734C13.805 18.944 14.2083 18.6067 14.6812 18.4029C15.1643 18.1909 15.6998 18.1279 16.219 18.222C16.74 18.3165 17.2207 18.5649 17.5993 18.9351L17.6071 18.9429L17.6671 19.0029C17.76 19.0959 17.8707 19.17 17.9921 19.2203C18.1135 19.2707 18.2436 19.2966 18.375 19.2966C18.5064 19.2966 18.6365 19.2707 18.7579 19.2203C18.8793 19.17 18.9896 19.0963 19.0825 19.0033L19.0833 19.0025C19.1763 18.9096 19.25 18.7993 19.3003 18.6779C19.3507 18.5565 19.3766 18.4264 19.3766 18.295C19.3766 18.1636 19.3507 18.0335 19.3003 17.9121C19.25 17.7907 19.1763 17.6804 19.0833 17.5875L19.0151 17.5193C18.6448 17.1408 18.3965 16.66 18.302 16.139C18.2079 15.6198 18.2709 15.0843 18.4829 14.6012C18.6867 14.1283 19.024 13.725 19.4534 13.4406C19.8843 13.1552 20.3892 13.0021 20.906 13L20.91 13L21 13C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5196 22 12.2652 22 12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1054 21.2652 11 21 11H20.83L20.826 11C20.3092 10.9979 19.8043 10.8448 19.3734 10.5594C18.9425 10.2741 18.6045 9.86896 18.4009 9.39393C18.3646 9.30938 18.3403 9.22042 18.3284 9.12961C18.1773 8.69798 18.14 8.23332 18.222 7.781C18.3165 7.26 18.5649 6.77925 18.9351 6.40073L18.9428 6.39285L19.0029 6.3329C19.0959 6.24002 19.17 6.12934 19.2203 6.00794C19.2707 5.88654 19.2966 5.75641 19.2966 5.625C19.2966 5.49359 19.2707 5.36346 19.2203 5.24206C19.17 5.12066 19.0963 5.01037 19.0033 4.9175L19.0025 4.91671C18.9096 4.82374 18.7993 4.74998 18.6779 4.69965C18.5565 4.64933 18.4264 4.62343 18.295 4.62343C18.1636 4.62343 18.0335 4.64933 17.9121 4.69965C17.7907 4.74998 17.6804 4.82374 17.5875 4.91671L17.5193 4.98491C17.1408 5.35516 16.66 5.60349 16.139 5.69796C15.6198 5.79211 15.0843 5.72908 14.6011 5.51701C14.1282 5.3132 13.7249 4.97601 13.4406 4.54661C13.1552 4.11572 13.0021 3.6108 13 3.09399L13 3.09V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2ZM19.4 15L20.3149 15.4038C20.2624 15.5226 20.2468 15.6544 20.27 15.7822C20.2929 15.9086 20.3527 16.0253 20.4419 16.1177L20.4967 16.1725C20.4966 16.1724 20.4968 16.1726 20.4967 16.1725C20.7755 16.451 20.997 16.7822 21.1479 17.1462C21.2989 17.5104 21.3766 17.9008 21.3766 18.295C21.3766 18.6892 21.2989 19.0796 21.1479 19.4438C20.9969 19.808 20.7756 20.1389 20.4967 20.4175L19.79 19.71L20.4975 20.4167C20.2189 20.6956 19.888 20.9169 19.5238 21.0679C19.1596 21.2189 18.7692 21.2966 18.375 21.2966C17.9808 21.2966 17.5904 21.2189 17.2262 21.0679C16.8622 20.917 16.5314 20.6959 16.2529 20.4171C16.253 20.4172 16.2528 20.417 16.2529 20.4171L16.1977 20.3619C16.1053 20.2727 15.9886 20.2129 15.8622 20.19C15.7344 20.1668 15.6026 20.1824 15.4838 20.2349L15.474 20.2392C15.3574 20.2891 15.258 20.372 15.1881 20.4777C15.1183 20.583 15.0808 20.7063 15.08 20.8325V21C15.08 21.7957 14.7639 22.5587 14.2013 23.1213C13.6387 23.6839 12.8757 24 12.08 24C11.2843 24 10.5213 23.6839 9.95868 23.1213C9.39607 22.5587 9.08 21.7957 9.08 21V20.9244C9.07526 20.7972 9.03327 20.6741 8.95914 20.5704C8.88326 20.4644 8.77723 20.3836 8.65482 20.3385C8.63505 20.3313 8.61551 20.3234 8.59624 20.3149C8.47742 20.2624 8.34561 20.2468 8.21782 20.27C8.09142 20.2929 7.97467 20.3527 7.8823 20.4419L7.8275 20.4967C7.82763 20.4966 7.82737 20.4968 7.8275 20.4967C7.54896 20.7755 7.21784 20.997 6.85382 21.1479C6.48963 21.2989 6.09925 21.3766 5.705 21.3766C5.31075 21.3766 4.92037 21.2989 4.55618 21.1479C4.19233 20.9971 3.86174 20.7761 3.58329 20.4975C3.30436 20.2189 3.08308 19.888 2.93211 19.5238C2.78113 19.1596 2.70343 18.7692 2.70343 18.375C2.70343 17.9808 2.78113 17.5904 2.93211 17.2262C3.08308 16.862 3.30436 16.5311 3.58329 16.2525L3.63811 16.1977C3.72728 16.1053 3.78713 15.9886 3.81005 15.8622C3.83322 15.7344 3.81758 15.6026 3.76514 15.4838L3.76081 15.474C3.71087 15.3574 3.62801 15.258 3.52232 15.1881C3.41704 15.1183 3.29374 15.0808 3.1675 15.08H3C2.20435 15.08 1.44129 14.7639 0.87868 14.2013C0.316071 13.6387 0 12.8756 0 12.08C0 11.2844 0.316071 10.5213 0.87868 9.95868C1.44129 9.39607 2.20435 9.08 3 9.08H3.07564C3.20283 9.07526 3.32591 9.03327 3.42955 8.95914C3.53564 8.88326 3.61644 8.77723 3.66146 8.65482C3.66874 8.63505 3.67663 8.61551 3.68514 8.59624C3.73758 8.47742 3.75322 8.34561 3.73005 8.21782C3.70713 8.09142 3.64728 7.97468 3.5581 7.88231L3.50329 7.8275C3.22436 7.54888 3.00308 7.21802 2.85211 6.85382C2.70113 6.48963 2.62343 6.09925 2.62343 5.705C2.62343 5.31075 2.70113 4.92037 2.85211 4.55618C3.00301 4.19216 3.22415 3.86143 3.50289 3.58289C3.78143 3.30415 4.11216 3.08301 4.47618 2.93211C4.84037 2.78113 5.23075 2.70343 5.625 2.70343C6.01925 2.70343 6.40963 2.78113 6.77382 2.93211C7.13802 3.08308 7.46888 3.30436 7.7475 3.58329L7.80231 3.6381C7.89468 3.72728 8.01142 3.78713 8.13782 3.81005C8.26561 3.83322 8.39742 3.81758 8.51624 3.76514C8.58027 3.73687 8.64693 3.71549 8.71507 3.70122C8.78479 3.6539 8.84498 3.59323 8.89195 3.52232C8.96167 3.41704 8.99921 3.29374 9 3.1675V3C9 2.20435 9.31607 1.44129 9.87868 0.87868C10.4413 0.316071 11.2044 0 12 0C12.7956 0 13.5587 0.316071 14.1213 0.87868C14.6839 1.44129 15 2.20435 15 3V3.0875C15.0008 3.21374 15.0383 3.33704 15.1081 3.44232C15.178 3.54801 15.2774 3.63092 15.3939 3.68086L15.4038 3.68508C15.5226 3.73752 15.6544 3.75322 15.7822 3.73005C15.9086 3.70713 16.0253 3.64728 16.1177 3.55811L16.1725 3.50329C16.4511 3.22436 16.782 3.00308 17.1462 2.85211C17.5104 2.70113 17.9008 2.62343 18.295 2.62343C18.6892 2.62343 19.0796 2.70113 19.4438 2.85211C19.808 3.00308 20.1389 3.22436 20.4175 3.50329C20.6961 3.78174 20.9171 4.11233 21.0679 4.47618C21.2189 4.84037 21.2966 5.23075 21.2966 5.625C21.2966 6.01925 21.2189 6.40963 21.0679 6.77382C20.917 7.13784 20.6959 7.46857 20.4171 7.7471C20.4172 7.74697 20.417 7.74724 20.4171 7.7471L20.3619 7.80231C20.2727 7.89468 20.2129 8.01142 20.19 8.13782C20.1668 8.26561 20.1824 8.39742 20.2349 8.51624C20.2631 8.58027 20.2845 8.64692 20.2988 8.71507C20.3461 8.78479 20.4068 8.84498 20.4777 8.89195C20.583 8.96167 20.7063 8.99921 20.8325 9H21C21.7957 9 22.5587 9.31607 23.1213 9.87868C23.6839 10.4413 24 11.2043 24 12C24 12.7957 23.6839 13.5587 23.1213 14.1213C22.5587 14.6839 21.7957 15 21 15H20.9125C20.7863 15.0008 20.663 15.0383 20.5577 15.1081C20.452 15.178 20.3691 15.2774 20.3191 15.3939L19.4 15Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"sidebar\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Sidebar\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2 12C2 11.4477 2.44772 11 3 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H3C2.44772 13 2 12.5523 2 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H3C2.44772 6 2 5.55228 2 5Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2 19C2 18.4477 2.44772 18 3 18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"square\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Square\\\">\\n<path id=\\\"Vector\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M15.6 7.8H8.4C8.06863 7.8 7.8 8.06863 7.8 8.4V15.6C7.8 15.9314 8.06863 16.2 8.4 16.2H15.6C15.9314 16.2 16.2 15.9314 16.2 15.6V8.4C16.2 8.06863 15.9314 7.8 15.6 7.8ZM8.4 6C7.07452 6 6 7.07452 6 8.4V15.6C6 16.9255 7.07452 18 8.4 18H15.6C16.9255 18 18 16.9255 18 15.6V8.4C18 7.07452 16.9255 6 15.6 6H8.4Z\\\" />\\n</g>\\n</svg>\\n\",\"star-filled\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Star - Filled\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 1C12.3806 1 12.7283 1.21607 12.8967 1.55738L15.7543 7.34647L22.1447 8.28051C22.5212 8.33555 22.8339 8.59956 22.9513 8.96157C23.0687 9.32358 22.9704 9.72083 22.6978 9.98636L18.0746 14.4894L19.1656 20.851C19.23 21.2261 19.0757 21.6053 18.7678 21.8291C18.4598 22.0528 18.0515 22.0823 17.7146 21.9051L12 18.8998L6.28548 21.9051C5.94856 22.0823 5.54027 22.0528 5.2323 21.8291C4.92432 21.6053 4.77007 21.2261 4.83442 20.851L5.92551 14.4894L1.3023 9.98636C1.02968 9.72083 0.931405 9.32358 1.04878 8.96157C1.16616 8.59956 1.47884 8.33555 1.8554 8.28051L8.24577 7.34647L11.1033 1.55738C11.2718 1.21607 11.6194 1 12 1Z\\\" />\\n</g>\\n</svg>\\n\",\"star-outlined\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Star - Outlined\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 1C12.3806 1 12.7283 1.21607 12.8967 1.55738L15.7543 7.34647L22.1447 8.28051C22.5212 8.33555 22.8339 8.59956 22.9513 8.96157C23.0687 9.32358 22.9704 9.72083 22.6978 9.98636L18.0746 14.4894L19.1656 20.851C19.23 21.2261 19.0757 21.6053 18.7678 21.8291C18.4598 22.0528 18.0515 22.0823 17.7146 21.9051L12 18.8998L6.28548 21.9051C5.94856 22.0823 5.54027 22.0528 5.2323 21.8291C4.92432 21.6053 4.77007 21.2261 4.83442 20.851L5.92551 14.4894L1.3023 9.98636C1.02968 9.72083 0.931405 9.32358 1.04878 8.96157C1.16616 8.59956 1.47884 8.33555 1.8554 8.28051L8.24577 7.34647L11.1033 1.55738C11.2718 1.21607 11.6194 1 12 1ZM12 4.25925L9.80674 8.70262C9.6612 8.99747 9.38001 9.20193 9.05466 9.24949L4.14844 9.9666L7.69776 13.4236C7.93364 13.6534 8.0413 13.9845 7.98564 14.309L7.14821 19.1917L11.5346 16.8849C11.826 16.7317 12.1741 16.7317 12.4655 16.8849L16.8518 19.1917L16.0144 14.309C15.9588 13.9845 16.0664 13.6534 16.3023 13.4236L19.8516 9.9666L14.9454 9.24949C14.62 9.20193 14.3389 8.99747 14.1933 8.70262L12 4.25925Z\\\" />\\n</g>\\n</svg>\\n\",\"stats\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M18 9C18.5523 9 19 9.44772 19 10V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20V10C17 9.44772 17.4477 9 18 9Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 3C12.5523 3 13 3.44772 13 4V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V4C11 3.44772 11.4477 3 12 3Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M6 13C6.55228 13 7 13.4477 7 14V20C7 20.5523 6.55228 21 6 21C5.44772 21 5 20.5523 5 20V14C5 13.4477 5.44772 13 6 13Z\\\" />\\n</svg>\\n\",\"tablebagde\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Table bagde\\\">\\n<path id=\\\"Vector\\\" d=\\\"M23.9842 16.3124L22.0196 6.52939C21.965 6.21296 21.6649 5.97563 21.3375 6.002H2.67401C2.34658 6.002 2.04643 6.21296 1.99186 6.52939L0.0272857 17.1826L0 17.2617C0 17.288 0 17.3408 0 17.3671C0 17.7099 0.300143 18 0.654858 18H19.3183C19.6458 18 19.9186 17.789 19.9732 17.4726L20.055 17.0771L21.3648 10.0101L22.538 15.785H21.8832C21.5012 15.785 21.201 16.075 21.201 16.4442C21.201 16.8134 21.5012 17.1034 21.8832 17.1034H23.3293C23.3839 17.1034 23.4112 17.1034 23.4658 17.1034C23.8205 17.0243 24.0661 16.6815 23.9842 16.3124ZM18.7726 16.7343H1.47343L3.21972 7.32046H20.5189L18.7726 16.7343ZM14.6797 12.0142C14.6252 12.3042 14.3796 12.4888 14.0795 12.5152H7.74916C7.53087 12.5152 7.33987 12.357 7.31259 12.1197C7.31259 12.0933 7.31259 12.0406 7.31259 12.0142C7.36716 11.7241 7.61273 11.5395 7.91288 11.5132H14.2432C14.4615 11.5132 14.6525 11.6714 14.6797 11.9087C14.6797 11.9351 14.6797 11.9878 14.6797 12.0142ZM13.179 10.0101C13.1245 10.3002 12.8789 10.4848 12.5787 10.5111H9.98659C9.76831 10.5111 9.57731 10.3529 9.55002 10.1156C9.55002 10.0892 9.55002 10.0365 9.55002 10.0101C9.60459 9.72006 9.85017 9.53548 10.1503 9.50911H12.7425C12.9607 9.50911 13.1517 9.66732 13.179 9.90465C13.2063 9.95739 13.2063 9.98376 13.179 10.0101ZM12.415 14.0182C12.3605 14.3083 12.1149 14.4929 11.8147 14.5193H9.22259C9.00431 14.5193 8.81331 14.361 8.78602 14.1237C8.78602 14.0974 8.78602 14.0446 8.78602 14.0182C8.84059 13.7282 9.08616 13.5436 9.38631 13.5172H12.0057C12.224 13.5172 12.415 13.6754 12.4423 13.9128C12.4423 13.9391 12.4423 13.9655 12.415 14.0182Z\\\" />\\n</g>\\n</svg>\\n\",\"telegram\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Telegram\\\">\\n<path id=\\\"Vector\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M19.822 2.35474C19.0347 2.71193 10.1595 6.85529 2.93047 10.2128C2.35787 10.4986 2 11.0701 2 11.6416C2 12.2131 2.42945 12.6417 2.93047 12.7131C3.35991 12.7846 7.65438 13.4275 7.65438 13.4275L8.87114 20.5713L9.51531 17.428L8.58484 12.7131L17.3169 6.28379L10.1595 14.1419L12.6646 16.9994C12.8077 17.1423 15.8854 20.7141 16.1002 20.9284C16.458 21.2856 17.0306 22 17.3169 22C17.8179 22 18.319 21.2856 18.5337 20.2141C18.7484 19.2139 20.1799 12.2845 21.9693 3.06911C22.184 2.06899 21.2535 1.64037 19.822 2.35474Z\\\" />\\n</g>\\n</svg>\\n\",\"thumbdown\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Thumb down\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M13.5965 22.4063C13.436 22.7674 13.0779 23.0001 12.6827 23.0001C11.6219 23.0001 10.6044 22.5787 9.8543 21.8285C9.10415 21.0784 8.68272 20.061 8.68272 19.0001V16.0001H4.02784C3.59509 16.0041 3.16656 15.9145 2.77169 15.7372C2.37493 15.5592 2.02163 15.297 1.73626 14.9688C1.4509 14.6406 1.24029 14.2543 1.11904 13.8367C0.997787 13.419 0.968788 12.98 1.03405 12.5501L2.41403 3.55019C2.41407 3.54992 2.41399 3.55045 2.41403 3.55019C2.52266 2.83514 2.88608 2.1826 3.43717 1.71418C3.98691 1.2469 4.68658 0.993439 5.40791 1.00012H19.6827C20.4784 1.00012 21.2414 1.31619 21.804 1.8788C22.3667 2.44141 22.6827 3.20447 22.6827 4.00012V11.0001C22.6827 11.7958 22.3667 12.5588 21.804 13.1214C21.2414 13.6841 20.4784 14.0001 19.6827 14.0001H17.3326L13.5965 22.4063ZM15.6827 12.7879L12.0749 20.9055C11.7735 20.8094 11.4964 20.6422 11.2685 20.4143C10.8934 20.0393 10.6827 19.5306 10.6827 19.0001V15.0001C10.6827 14.4478 10.235 14.0001 9.68272 14.0001H4.02273L4.0114 14.0002C3.86645 14.0018 3.72287 13.9719 3.59062 13.9126C3.45836 13.8532 3.3406 13.7658 3.24547 13.6564C3.15035 13.547 3.08015 13.4183 3.03973 13.2791C2.99935 13.14 2.98967 12.9938 3.01134 12.8506C3.01132 12.8507 3.01136 12.8505 3.01134 12.8506L4.39142 3.85006C4.42758 3.61161 4.5487 3.39425 4.73247 3.23806C4.91623 3.08186 5.15026 2.99733 5.39142 3.00006L15.6827 3.00012V12.7879ZM17.6827 3.00012V12.0001H19.6827C19.9479 12.0001 20.2023 11.8948 20.3898 11.7072C20.5774 11.5197 20.6827 11.2653 20.6827 11.0001V4.00012C20.6827 3.73491 20.5774 3.48055 20.3898 3.29302C20.2023 3.10548 19.9479 3.00012 19.6827 3.00012H17.6827Z\\\" />\\n</g>\\n</svg>\\n\",\"thumbup\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Thumb up\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M10.0862 1.59386C10.2467 1.23273 10.6048 1 11 1C12.0609 1 13.0783 1.42143 13.8284 2.17157C14.5786 2.92172 15 3.93913 15 5V8H19.6549C20.0876 7.996 20.5162 8.08567 20.911 8.26289C21.3078 8.44096 21.6611 8.70317 21.9465 9.03134C22.2318 9.35951 22.4424 9.7458 22.5637 10.1634C22.6849 10.5811 22.7139 11.0201 22.6487 11.4501L21.2687 20.4499C21.2687 20.4502 21.2687 20.4497 21.2687 20.4499C21.1601 21.165 20.7966 21.8175 20.2456 22.2859C19.6958 22.7532 18.9961 23.0067 18.2748 23H4C3.20435 23 2.44129 22.6839 1.87868 22.1213C1.31607 21.5587 1 20.7957 1 20V13C1 12.2044 1.31607 11.4413 1.87868 10.8787C2.44129 10.3161 3.20435 10 4 10H6.35013L10.0862 1.59386ZM8 11.2122L11.6078 3.0946C11.9092 3.19075 12.1864 3.35794 12.4142 3.58579C12.7893 3.96086 13 4.46957 13 5V9C13 9.55228 13.4477 10 14 10H19.66L19.6713 9.99994C19.8163 9.99829 19.9599 10.0282 20.0921 10.0875C20.2244 10.1469 20.3421 10.2343 20.4373 10.3437C20.5324 10.4531 20.6026 10.5818 20.643 10.7211C20.6834 10.8601 20.6931 11.0063 20.6714 11.1495C20.6714 11.1494 20.6714 11.1497 20.6714 11.1495L19.2913 20.1501C19.2551 20.3885 19.134 20.6059 18.9503 20.7621C18.7665 20.9183 18.5325 21.0028 18.2913 21.0001L8 21V11.2122ZM6 21V12H4C3.73478 12 3.48043 12.1054 3.29289 12.2929C3.10536 12.4804 3 12.7348 3 13V20C3 20.2652 3.10536 20.5196 3.29289 20.7071C3.48043 20.8946 3.73478 21 4 21H6Z\\\" />\\n</g>\\n</svg>\\n\",\"trash\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Trash\\\">\\n<g id=\\\"Vector\\\">\\n<path d=\\\"M20.9442 5.9174L20.4576 4.46133C20.2723 3.90677 19.7542 3.53415 19.1687 3.53415H15.079V2.20497C15.079 1.54063 14.5379 1 13.8726 1H10.1274C9.46223 1 8.92098 1.54063 8.92098 2.20497V3.53415H4.83143C4.24579 3.53415 3.72774 3.90677 3.54245 4.46133L3.05585 5.9174C2.94504 6.2489 3.0012 6.61598 3.20583 6.89948C3.41046 7.18297 3.74153 7.35233 4.0916 7.35233H4.60023L5.71972 21.1713C5.80295 22.1967 6.6746 23 7.70447 23H16.5227C17.5524 23 18.4242 22.1967 18.5073 21.1711L19.6268 7.35233H19.9084C20.2585 7.35233 20.5895 7.18297 20.7942 6.89964C20.9988 6.61615 21.055 6.2489 20.9442 5.9174ZM10.2123 2.28906H13.7877V3.53415H10.2123V2.28906ZM17.2201 21.0672C17.1909 21.4283 16.8845 21.7109 16.5227 21.7109H7.70447C7.34263 21.7109 7.03628 21.4283 7.00702 21.0672L5.89577 7.35233H18.3312L17.2201 21.0672ZM4.36853 6.06326L4.76753 4.8692C4.77661 4.84167 4.80234 4.82321 4.83143 4.82321H19.1687C19.1978 4.82321 19.2234 4.84167 19.2326 4.8692L19.6316 6.06326H4.36853Z\\\" />\\n<path d=\\\"M15.1607 21.0216C15.1722 21.0223 15.1834 21.0224 15.1949 21.0224C15.536 21.0224 15.8212 20.7556 15.839 20.4115L16.4453 8.79279C16.4638 8.43729 16.1901 8.13399 15.8342 8.11552C15.4772 8.09656 15.1744 8.37015 15.1557 8.72565L14.5495 20.3443C14.531 20.6998 14.8046 21.0031 15.1607 21.0216Z\\\" />\\n<path d=\\\"M8.18972 20.413C8.20855 20.7566 8.49338 21.0224 8.83387 21.0224C8.84564 21.0224 8.85775 21.0221 8.86968 21.0214C9.22564 21.0021 9.49853 20.6983 9.4792 20.3428L8.84413 8.72414C8.82479 8.36864 8.52045 8.09622 8.16433 8.11569C7.80837 8.13499 7.53548 8.4388 7.55482 8.7943L8.18972 20.413Z\\\" />\\n<path d=\\\"M12.0072 21.0224C12.3639 21.0224 12.6529 20.7339 12.6529 20.3779V8.75922C12.6529 8.40321 12.3639 8.11469 12.0072 8.11469C11.6506 8.11469 11.3616 8.40321 11.3616 8.75922V20.3779C11.3616 20.7339 11.6506 21.0224 12.0072 21.0224Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"upload\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Upload\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M3 15C3.55228 15 4 15.4477 4 16V19.3333C4 19.4452 4.05193 19.5986 4.22597 19.7436C4.40533 19.8931 4.6818 20 5 20H19C19.3182 20 19.5947 19.8931 19.774 19.7436C19.9481 19.5986 20 19.4452 20 19.3333V16C20 15.4477 20.4477 15 21 15C21.5523 15 22 15.4477 22 16V19.3333C22 20.1055 21.6305 20.8 21.0544 21.2801C20.4836 21.7557 19.7427 22 19 22H5C4.25734 22 3.51639 21.7557 2.9456 21.2801C2.3695 20.8 2 20.1055 2 19.3333V16C2 15.4477 2.44772 15 3 15Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.2929 2.29289C11.6834 1.90237 12.3166 1.90237 12.7071 2.29289L17.7071 7.29289C18.0976 7.68342 18.0976 8.31658 17.7071 8.70711C17.3166 9.09763 16.6834 9.09763 16.2929 8.70711L12 4.41421L7.70711 8.70711C7.31658 9.09763 6.68342 9.09763 6.29289 8.70711C5.90237 8.31658 5.90237 7.68342 6.29289 7.29289L11.2929 2.29289Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 2C12.5523 2 13 2.44772 13 3V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V3C11 2.44772 11.4477 2 12 2Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"user-check\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1.46447 15.4645C2.40215 14.5268 3.67392 14 5 14H12C13.3261 14 14.5979 14.5268 15.5355 15.4645C16.4732 16.4021 17 17.6739 17 19V21C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21V19C15 18.2044 14.6839 17.4413 14.1213 16.8787C13.5587 16.3161 12.7956 16 12 16H5C4.20435 16 3.44129 16.3161 2.87868 16.8787C2.31607 17.4413 2 18.2044 2 19V21C2 21.5523 1.55228 22 1 22C0.447715 22 0 21.5523 0 21V19C0 17.6739 0.526784 16.4021 1.46447 15.4645Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8.5 4C6.84315 4 5.5 5.34315 5.5 7C5.5 8.65685 6.84315 10 8.5 10C10.1569 10 11.5 8.65685 11.5 7C11.5 5.34315 10.1569 4 8.5 4ZM3.5 7C3.5 4.23858 5.73858 2 8.5 2C11.2614 2 13.5 4.23858 13.5 7C13.5 9.76142 11.2614 12 8.5 12C5.73858 12 3.5 9.76142 3.5 7Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M23.7071 8.29289C24.0976 8.68342 24.0976 9.31658 23.7071 9.70711L19.7071 13.7071C19.3166 14.0976 18.6834 14.0976 18.2929 13.7071L16.2929 11.7071C15.9024 11.3166 15.9024 10.6834 16.2929 10.2929C16.6834 9.90237 17.3166 9.90237 17.7071 10.2929L19 11.5858L22.2929 8.29289C22.6834 7.90237 23.3166 7.90237 23.7071 8.29289Z\\\" />\\n</svg>\\n\",\"user-minus\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1.46447 15.4645C2.40215 14.5268 3.67392 14 5 14H12C13.3261 14 14.5979 14.5268 15.5355 15.4645C16.4732 16.4021 17 17.6739 17 19V21C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21V19C15 18.2044 14.6839 17.4413 14.1213 16.8787C13.5587 16.3161 12.7956 16 12 16H5C4.20435 16 3.44129 16.3161 2.87868 16.8787C2.31607 17.4413 2 18.2044 2 19V21C2 21.5523 1.55228 22 1 22C0.447715 22 0 21.5523 0 21V19C0 17.6739 0.526784 16.4021 1.46447 15.4645Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8.5 4C6.84315 4 5.5 5.34315 5.5 7C5.5 8.65685 6.84315 10 8.5 10C10.1569 10 11.5 8.65685 11.5 7C11.5 5.34315 10.1569 4 8.5 4ZM3.5 7C3.5 4.23858 5.73858 2 8.5 2C11.2614 2 13.5 4.23858 13.5 7C13.5 9.76142 11.2614 12 8.5 12C5.73858 12 3.5 9.76142 3.5 7Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M16 11C16 10.4477 16.4477 10 17 10H23C23.5523 10 24 10.4477 24 11C24 11.5523 23.5523 12 23 12H17C16.4477 12 16 11.5523 16 11Z\\\" />\\n</svg>\\n\",\"user-plus\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1.46447 15.4645C2.40215 14.5268 3.67392 14 5 14H12C13.3261 14 14.5979 14.5268 15.5355 15.4645C16.4732 16.4021 17 17.6739 17 19V21C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21V19C15 18.2044 14.6839 17.4413 14.1213 16.8787C13.5587 16.3161 12.7956 16 12 16H5C4.20435 16 3.44129 16.3161 2.87868 16.8787C2.31607 17.4413 2 18.2044 2 19V21C2 21.5523 1.55228 22 1 22C0.447715 22 0 21.5523 0 21V19C0 17.6739 0.526784 16.4021 1.46447 15.4645Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8.5 4C6.84315 4 5.5 5.34315 5.5 7C5.5 8.65685 6.84315 10 8.5 10C10.1569 10 11.5 8.65685 11.5 7C11.5 5.34315 10.1569 4 8.5 4ZM3.5 7C3.5 4.23858 5.73858 2 8.5 2C11.2614 2 13.5 4.23858 13.5 7C13.5 9.76142 11.2614 12 8.5 12C5.73858 12 3.5 9.76142 3.5 7Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M20 7C20.5523 7 21 7.44772 21 8V14C21 14.5523 20.5523 15 20 15C19.4477 15 19 14.5523 19 14V8C19 7.44772 19.4477 7 20 7Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M16 11C16 10.4477 16.4477 10 17 10H23C23.5523 10 24 10.4477 24 11C24 11.5523 23.5523 12 23 12H17C16.4477 12 16 11.5523 16 11Z\\\" />\\n</svg>\\n\",\"user-x\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1.46447 15.4645C2.40215 14.5268 3.67392 14 5 14H12C13.3261 14 14.5979 14.5268 15.5355 15.4645C16.4732 16.4021 17 17.6739 17 19V21C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21V19C15 18.2044 14.6839 17.4413 14.1213 16.8787C13.5587 16.3161 12.7956 16 12 16H5C4.20435 16 3.44129 16.3161 2.87868 16.8787C2.31607 17.4413 2 18.2044 2 19V21C2 21.5523 1.55228 22 1 22C0.447715 22 0 21.5523 0 21V19C0 17.6739 0.526784 16.4021 1.46447 15.4645Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8.5 4C6.84315 4 5.5 5.34315 5.5 7C5.5 8.65685 6.84315 10 8.5 10C10.1569 10 11.5 8.65685 11.5 7C11.5 5.34315 10.1569 4 8.5 4ZM3.5 7C3.5 4.23858 5.73858 2 8.5 2C11.2614 2 13.5 4.23858 13.5 7C13.5 9.76142 11.2614 12 8.5 12C5.73858 12 3.5 9.76142 3.5 7Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289L23.7071 12.2929C24.0976 12.6834 24.0976 13.3166 23.7071 13.7071C23.3166 14.0976 22.6834 14.0976 22.2929 13.7071L17.2929 8.70711C16.9024 8.31658 16.9024 7.68342 17.2929 7.29289Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M23.7071 7.29289C24.0976 7.68342 24.0976 8.31658 23.7071 8.70711L18.7071 13.7071C18.3166 14.0976 17.6834 14.0976 17.2929 13.7071C16.9024 13.3166 16.9024 12.6834 17.2929 12.2929L22.2929 7.29289C22.6834 6.90237 23.3166 6.90237 23.7071 7.29289Z\\\" />\\n</svg>\\n\",\"user\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4.46447 15.4645C5.40215 14.5268 6.67392 14 8 14H16C17.3261 14 18.5979 14.5268 19.5355 15.4645C20.4732 16.4021 21 17.6739 21 19V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V19C19 18.2044 18.6839 17.4413 18.1213 16.8787C17.5587 16.3161 16.7956 16 16 16H8C7.20435 16 6.44129 16.3161 5.87868 16.8787C5.31607 17.4413 5 18.2044 5 19V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V19C3 17.6739 3.52678 16.4021 4.46447 15.4645Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4ZM7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7Z\\\" />\\n</svg>\\n\",\"users\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Users\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1.46447 15.4645C2.40215 14.5268 3.67392 14 5 14H13C14.3261 14 15.5979 14.5268 16.5355 15.4645C17.4732 16.4021 18 17.6739 18 19V21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21V19C16 18.2043 15.6839 17.4413 15.1213 16.8787C14.5587 16.3161 13.7956 16 13 16H5C4.20435 16 3.44129 16.3161 2.87868 16.8787C2.31607 17.4413 2 18.2043 2 19V21C2 21.5523 1.55228 22 1 22C0.447715 22 0 21.5523 0 21V19C0 17.6739 0.526784 16.4021 1.46447 15.4645Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M9 4C7.34315 4 6 5.34315 6 7C6 8.65685 7.34315 10 9 10C10.6569 10 12 8.65685 12 7C12 5.34315 10.6569 4 9 4ZM4 7C4 4.23858 6.23858 2 9 2C11.7614 2 14 4.23858 14 7C14 9.76142 11.7614 12 9 12C6.23858 12 4 9.76142 4 7Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M19.0318 14.88C19.1698 14.3453 19.7153 14.0237 20.25 14.1618C21.3227 14.4387 22.273 15.0641 22.9517 15.9396C23.6304 16.8152 23.9992 17.8914 24 18.9993V21C24 21.5523 23.5523 22 23 22C22.4477 22 22 21.5523 22 21V19.0007C22 19.0008 22 19.0006 22 19.0007C21.9994 18.3361 21.7782 17.6902 21.371 17.165C20.9638 16.6396 20.3936 16.2644 19.75 16.0982C19.2153 15.9602 18.8937 15.4147 19.0318 14.88Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M15.0312 2.88196C15.1682 2.34694 15.713 2.02426 16.248 2.16125C17.3236 2.43663 18.2768 3.06213 18.9576 3.93914C19.6383 4.81615 20.0078 5.89479 20.0078 7.005C20.0078 8.11521 19.6383 9.19385 18.9576 10.0709C18.2768 10.9479 17.3236 11.5734 16.248 11.8487C15.713 11.9857 15.1682 11.6631 15.0312 11.128C14.8943 10.593 15.2169 10.0482 15.752 9.91125C16.3973 9.74602 16.9692 9.37072 17.3777 8.84452C17.7861 8.31831 18.0078 7.67113 18.0078 7.005C18.0078 6.33887 17.7861 5.69169 17.3777 5.16548C16.9692 4.63928 16.3973 4.26398 15.752 4.09875C15.2169 3.96176 14.8943 3.41699 15.0312 2.88196Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"utensils\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\" Utensils\\\">\\n<g id=\\\"Vector\\\">\\n<path d=\\\"M11.2821 10.8584C11.2821 11.8231 10.8733 12.6631 10.1672 13.13L8.83097 14.0008C8.49667 14.2187 8.27434 14.6231 8.31112 15.2455L8.60521 22.9616C8.62682 23.5284 8.17316 23.9996 7.60594 23.9996H6.33787C5.77229 23.9996 5.31926 23.531 5.33845 22.9657L5.60054 15.2455C5.63733 14.6231 5.41467 14.2495 5.08069 14.0319L3.74347 13.1297C3.03872 12.6628 2.66666 11.8544 2.66666 10.8582C2.66666 6.50276 3.07518 3.79625 3.26105 1.08974C3.33527 0.405474 3.4837 0.09375 3.85479 0.09375C4.22653 0.09375 4.3753 0.405474 4.44886 1.08974L4.85139 6.48457C4.85538 6.53807 4.86254 6.59157 4.87961 6.64243C4.96988 6.91145 5.17331 7.09376 5.37756 7.09376C5.60054 7.09376 5.82352 6.87585 5.89741 6.56494L6.41759 1.08974C6.45405 0.373838 6.64024 0.09375 6.97422 0.09375C7.30853 0.09375 7.45729 0.373838 7.53118 1.08974L8.05169 6.56494C8.05169 6.87585 8.27466 7.09376 8.5341 7.09376C8.83097 7.09376 9.05395 6.87585 9.05395 6.56494L9.49926 1.08974C9.53669 0.405474 9.72289 0.09375 10.0937 0.09375C10.428 0.09375 10.6135 0.405474 10.6506 1.08974C10.8733 3.79652 11.2821 6.50303 11.2821 10.8584Z\\\" />\\n<path d=\\\"M21.0356 15.3387C21.0356 16.3798 21.1922 20.6943 21.2867 22.9516C21.3106 23.5229 20.8543 24 20.2825 24H18.6389C18.0651 24 17.609 23.5181 17.6404 22.9452L17.9914 16.5527C17.9914 16.0858 17.8055 15.7122 17.4715 15.5251C16.9517 15.2458 15.2437 14.7478 15.2437 13.6583C15.2437 6.87621 16.9881 1.49401 19.6248 0.187385C20.4422 -0.247883 21.0356 0.0632952 21.0356 1.24528V15.3387Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"verification\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path d=\\\"M8.07024 1.04123C8.19506 0.790872 8.50101 0.691638 8.74902 0.821059L11.7737 2.39944C11.9185 2.47499 12.091 2.47508 12.2359 2.39967L15.2621 0.824364C15.5103 0.695195 15.8161 0.794739 15.9407 1.04522L17.46 4.10001C17.5327 4.24623 17.6722 4.34773 17.8337 4.37187L21.208 4.87621C21.4847 4.91757 21.6736 5.17787 21.6271 5.45374L21.0607 8.81811C21.0336 8.97915 21.0868 9.14328 21.2033 9.25775L23.6367 11.6491C23.8362 11.8452 23.836 12.1668 23.6363 12.3627L21.2005 14.7516C21.0839 14.8659 21.0305 15.03 21.0574 15.1911L21.6205 18.556C21.6666 18.8319 21.4775 19.0921 21.2007 19.1331L17.826 19.634C17.6645 19.658 17.5248 19.7594 17.4519 19.9055L15.9296 22.9588C15.8047 23.2091 15.4988 23.3084 15.2508 23.1789L12.2261 21.6006C12.0813 21.525 11.9088 21.5249 11.7639 21.6003L8.73767 23.1756C8.48953 23.3048 8.18369 23.2053 8.05912 22.9548L6.53986 19.9C6.46714 19.7538 6.32759 19.6523 6.16608 19.6281L2.79183 19.1238C2.51516 19.0824 2.32624 18.8221 2.37268 18.5463L2.93914 15.1819C2.96625 15.0208 2.91302 14.8567 2.79654 14.7422L0.363162 12.3509C0.163635 12.1548 0.163798 11.8332 0.363524 11.6373L2.79933 9.24841C2.91592 9.13406 2.96932 8.96999 2.94237 8.80892L2.37933 5.44397C2.33317 5.16806 2.52235 4.90794 2.79907 4.86687L6.17382 4.36595C6.33536 4.34197 6.47501 4.24062 6.54788 4.09448L8.07024 1.04123Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M16.8536 8.15771C17.0488 8.36799 17.0488 8.70893 16.8536 8.91921L11.3536 14.8423C11.1583 15.0526 10.8417 15.0526 10.6464 14.8423L8.14645 12.15C7.95118 11.9397 7.95118 11.5988 8.14645 11.3885C8.34171 11.1782 8.65829 11.1782 8.85355 11.3885L11 13.7L16.1464 8.15771C16.3417 7.94743 16.6583 7.94743 16.8536 8.15771Z\\\" />\\n</svg>\\n\",\"windows\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Windows\\\">\\n<g id=\\\"Vector\\\">\\n<path d=\\\"M0 3.75V11.25H10.5V2.4375L0 3.75Z\\\" />\\n<path d=\\\"M12 2.25V11.25H24V0.75L12 2.25Z\\\" />\\n<path d=\\\"M12 12.75V21.75L24 23.25V12.75H12Z\\\" />\\n<path d=\\\"M0 12.75V20.25L10.5 21.5625V12.75H0Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"archive\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4.66667 9.3V19.2H19.3333V9.3H4.66667ZM9.25 12C9.25 11.5029 9.66041 11.1 10.1667 11.1H13.8333C14.3396 11.1 14.75 11.5029 14.75 12C14.75 12.4971 14.3396 12.9 13.8333 12.9H10.1667C9.66041 12.9 9.25 12.4971 9.25 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M2.83333 20.1V9.3H4.66667V19.2H19.3333V9.3H21.1667V20.1C21.1667 20.5971 20.7563 21 20.25 21H3.75C3.24374 21 2.83333 20.5971 2.83333 20.1Z\\\" />\\n<path d=\\\"M3.75 7.5C4.25626 7.5 4.66667 7.90294 4.66667 8.4V9.3H19.3333V8.4C19.3333 7.90294 19.7437 7.5 20.25 7.5H3.75Z\\\" />\\n<path d=\\\"M4.66667 8.4C4.66667 7.90294 4.25626 7.5 3.75 7.5C3.24374 7.5 2.83333 7.90294 2.83333 8.4V9.3H4.66667V8.4Z\\\" />\\n<path d=\\\"M20.25 7.5C20.7563 7.5 21.1667 7.90294 21.1667 8.4V9.3H22.0833C22.5896 9.3 23 8.89706 23 8.4V3.9C23 3.40294 22.5896 3 22.0833 3H1.91667C1.41041 3 1 3.40294 1 3.9V8.4C1 8.89706 1.41041 9.3 1.91667 9.3H2.83333V8.4C2.83333 7.90294 3.24374 7.5 3.75 7.5H2.83333V4.8H21.1667V7.5H20.25Z\\\" />\\n<path d=\\\"M20.25 7.5C19.7437 7.5 19.3333 7.90294 19.3333 8.4V9.3H21.1667V8.4C21.1667 7.90294 20.7563 7.5 20.25 7.5Z\\\" />\\n</svg>\\n\",\"cards\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Cards\\\">\\n<g id=\\\"Vector\\\">\\n<path d=\\\"M5.99984 4.22222C5.99984 2.99492 6.99476 2 8.22206 2H19.7776C21.0049 2 21.9998 2.99492 21.9998 4.22222V15.7778C21.9998 17.0051 21.0049 18 19.7776 18H8.22206C6.99476 18 5.99984 17.0051 5.99984 15.7778V4.22222Z\\\" />\\n<path d=\\\"M4.889 5.99996H4C2.89543 5.99996 2 6.89539 2 7.99996V20C2 21.1045 2.89543 22 4 22H16C17.1046 22 18 21.1045 18 20V19.1111H8.22233C6.38139 19.1111 4.889 17.6187 4.889 15.7778V5.99996Z\\\" />\\n<path d=\\\"M6.00011 5.99996H16C17.1046 5.99996 18 6.89539 18 7.99996V18L8.22206 18C6.99476 18 5.99984 17.0051 5.99984 15.7778L6.00011 5.99996Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"cart\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Cart\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4.74668 0.436364C4.94812 0.161666 5.26427 0 5.60001 0H18.4C18.7358 0 19.0519 0.161666 19.2533 0.436364L22.4533 4.8C22.5918 4.98883 22.6667 5.21851 22.6667 5.45455V20.7273C22.6667 21.5953 22.3295 22.4277 21.7294 23.0414C21.1293 23.6552 20.3154 24 19.4667 24H4.53334C3.68465 24 2.87072 23.6552 2.2706 23.0414C1.67049 22.4277 1.33334 21.5953 1.33334 20.7273V5.45455C1.33334 5.21851 1.4082 4.98883 1.54668 4.8L4.74668 0.436364ZM6.13334 2.18182L3.46668 5.81818V20.7273C3.46668 21.0166 3.57906 21.2941 3.7791 21.4987C3.97914 21.7032 4.25045 21.8182 4.53334 21.8182H19.4667C19.7496 21.8182 20.0209 21.7032 20.2209 21.4987C20.421 21.2941 20.5333 21.0166 20.5333 20.7273V5.81818L17.8667 2.18182H6.13334Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1.33334 6C1.33334 5.63181 1.81091 5.33333 2.40001 5.33333H21.6C22.1891 5.33333 22.6667 5.63181 22.6667 6C22.6667 6.36819 22.1891 6.66667 21.6 6.66667H2.40001C1.81091 6.66667 1.33334 6.36819 1.33334 6Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M7.73334 9.33333C8.32245 9.33333 8.80001 9.7313 8.80001 10.2222C8.80001 10.9295 9.13715 11.6077 9.73727 12.1078C10.3374 12.6079 11.1513 12.8889 12 12.8889C12.8487 12.8889 13.6626 12.6079 14.2628 12.1078C14.8629 11.6077 15.2 10.9295 15.2 10.2222C15.2 9.7313 15.6776 9.33333 16.2667 9.33333C16.8558 9.33333 17.3333 9.7313 17.3333 10.2222C17.3333 11.401 16.7714 12.5314 15.7712 13.3649C14.7711 14.1984 13.4145 14.6667 12 14.6667C10.5855 14.6667 9.22897 14.1984 8.22877 13.3649C7.22858 12.5314 6.66668 11.401 6.66668 10.2222C6.66668 9.7313 7.14424 9.33333 7.73334 9.33333Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"checker-toggle-active\":\"<svg width=\\\"16\\\" height=\\\"16\\\" viewBox=\\\"0 0 16 16\\\" fill=\\\"none\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\">\\n<circle cx=\\\"8\\\" cy=\\\"8\\\" r=\\\"8\\\" fill=\\\"#1F1F1F\\\"/>\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.2248 5.77932C11.3695 5.92952 11.3695 6.17304 11.2248 6.32324L7.15074 10.554C7.0061 10.7042 6.7716 10.7042 6.62696 10.554L4.7751 8.63094C4.63047 8.48073 4.63047 8.23721 4.7751 8.08701C4.91974 7.93681 5.15425 7.93681 5.29889 8.08701L6.88885 9.73812L10.701 5.77932C10.8457 5.62911 11.0802 5.62911 11.2248 5.77932Z\\\" fill=\\\"#EDEDED\\\"/>\\n</svg>\\n\",\"checker-toggle\":\"<svg width=\\\"16\\\" height=\\\"16\\\" viewBox=\\\"0 0 16 16\\\" fill=\\\"none\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\">\\n<circle cx=\\\"8\\\" cy=\\\"8\\\" r=\\\"7.5\\\" stroke=\\\"#1F1F1F\\\"/>\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.2248 5.77932C11.3695 5.92952 11.3695 6.17304 11.2248 6.32324L7.15074 10.554C7.0061 10.7042 6.7716 10.7042 6.62696 10.554L4.7751 8.63094C4.63047 8.48073 4.63047 8.23721 4.7751 8.08701C4.91974 7.93681 5.15425 7.93681 5.29889 8.08701L6.88885 9.73812L10.701 5.77932C10.8457 5.62911 11.0802 5.62911 11.2248 5.77932Z\\\" fill=\\\"#1F1F1F\\\"/>\\n</svg>\\n\",\"cloud-off\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g>\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M5.87512 4.51611C6.14237 4.99943 5.9672 5.60789 5.48388 5.87513C4.1172 6.63082 3.04246 7.82182 2.43064 9.25867C1.81883 10.6955 1.70506 12.2957 2.10745 13.8047C2.50984 15.3136 3.40527 16.6447 4.6513 17.5861C5.89733 18.5276 7.42239 19.0253 8.98388 19.0001L8.99999 19L17.9988 19C17.9991 19 17.9986 19 17.9988 19C18.4624 18.9994 18.9231 18.9182 19.3588 18.76C19.878 18.5716 20.4516 18.8397 20.64 19.3588C20.8284 19.878 20.5603 20.4516 20.0412 20.64C19.3872 20.8774 18.6969 20.9992 18.0012 21H9.00782C7.00308 21.0305 5.04548 20.3906 3.44565 19.1819C1.84361 17.9715 0.692341 16.2601 0.174983 14.32C-0.342375 12.3799 -0.196108 10.3225 0.590516 8.47514C1.37714 6.62775 2.75894 5.09647 4.5161 4.12487C4.99942 3.85763 5.60788 4.03279 5.87512 4.51611Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L23.7071 22.2929C24.0976 22.6834 24.0976 23.3166 23.7071 23.7071C23.3166 24.0976 22.6834 24.0976 22.2929 23.7071L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z\\\" />\\n<path d=\\\"M10.8085 3.14323C12.4575 3.48266 13.9783 4.27782 15.198 5.43836C16.2277 6.41817 17.008 7.62524 17.4793 8.95841H18C19.5913 8.95841 21.1174 9.59056 22.2426 10.7158C23.3679 11.841 24 13.3671 24 14.9584C24 15.8088 23.8195 16.6405 23.4797 17.4025C23.2378 17.9446 22.5477 18.0424 22.0859 17.6694C21.6832 17.344 21.603 16.7712 21.7744 16.2827C21.9224 15.8611 22 15.4138 22 14.9584C22 13.8975 21.5786 12.8801 20.8284 12.13C20.0783 11.3798 19.0609 10.9584 18 10.9584H16.74C16.284 10.9584 15.8857 10.6499 15.7717 10.2084C15.4444 8.94054 14.7679 7.78991 13.8193 6.88726C12.8707 5.98462 11.6879 5.36616 10.4053 5.10216C10.2714 5.07459 10.1369 5.05101 10.0022 5.03139C9.45266 4.95142 9.00041 4.50877 9 3.95348C8.99959 3.39063 9.46218 2.93326 10.02 3.00803C10.28 3.04287 10.5421 3.08839 10.8085 3.14323Z\\\" />\\n</g>\\n<defs>\\n<clipPath id=\\\"clip0\\\">\\n<rect width=\\\"1em\\\" height=\\\"1em\\\" />\\n</clipPath>\\n</defs>\\n</svg>\\n\",\"cloud\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g>\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M10.8085 3.18481C9.15953 2.84538 7.67405 2.8631 5.86949 3.55979C1.91101 5.08805 -0.00201416 9 -0.00201416 12.1716C-0.00201416 17.5047 4.4428 21 9.00076 21H18C19.5913 21 21.1174 20.3679 22.2427 19.2426C23.3679 18.1174 24 16.5913 24 15C24 13.4087 23.3679 11.8826 22.2427 10.7574C21.1174 9.63214 19.5913 9 18 9H17.4793C17.008 7.66682 16.2277 6.45975 15.198 5.47994C13.9783 4.3194 12.4576 3.52424 10.8085 3.18481ZM10.4053 5.14374C9.12275 4.87974 7.79185 4.98078 6.56384 5.43539C6.45131 5.47705 6.34006 5.52152 6.23019 5.56874C5.14096 6.03683 4.18651 6.77483 3.45846 7.71546C2.65697 8.75097 2.16201 9.99054 2.02981 11.2933C1.89761 12.5961 2.13348 13.9098 2.71062 15.0852C3.28776 16.2606 4.18302 17.2506 5.29467 17.9426C6.30447 18.5712 7.45603 18.9311 8.64007 18.991C8.75951 18.9971 8.87928 19.0001 8.99927 19H18C19.0609 19 20.0783 18.5786 20.8284 17.8284C21.5786 17.0783 22 16.0609 22 15C22 13.9391 21.5786 12.9217 20.8284 12.1716C20.0783 11.4214 19.0609 11 18 11H16.74C16.284 11 15.8858 10.6915 15.7718 10.25C15.4444 8.98212 14.768 7.83149 13.8193 6.92884C12.8707 6.0262 11.6879 5.40774 10.4053 5.14374Z\\\" />\\n</g>\\n<defs>\\n<clipPath id=\\\"clip0\\\">\\n<rect width=\\\"1em\\\" height=\\\"1em\\\" />\\n</clipPath>\\n</defs>\\n</svg>\\n\",\"cross\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Cross\\\">\\n<g id=\\\"Vector\\\">\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z\\\" />\\n</g>\\n</g>\\n</svg>\\n\",\"do-not-disturb\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path d=\\\"M16.7894 24H7.21052C5.99165 24 5 22.9907 5 21.7502V7.12613C5 5.2229 5.72809 3.43371 7.05012 2.08816C9.78541 -0.695842 14.2142 -0.696264 16.9499 2.08816C18.2581 3.41965 18.9861 5.18976 18.9998 7.07247C19.0089 8.33187 18.026 9.3652 16.8088 9.37584C15.5747 9.3839 14.579 8.37466 14.579 7.12609C14.579 5.66125 13.4023 4.49095 11.9911 4.50126C9.89427 4.50881 8.66435 6.98425 9.93881 8.87422C10.2776 9.37598 10.7517 9.75682 11.3098 9.97519L17.1107 12.2462C18.2407 12.6886 19 13.8137 19 15.046V21.7501C19 22.9907 18.0083 24 16.7894 24ZM12 1.50151C8.94536 1.50151 6.47368 4.01665 6.47368 7.12613V21.7502C6.47368 22.1637 6.80424 22.5001 7.21052 22.5001H16.7894C17.1957 22.5001 17.5263 22.1637 17.5263 21.7502V15.0461C17.5263 14.4299 17.1466 13.8674 16.5816 13.6462L10.7808 11.3753C8.99031 10.6746 7.90646 8.90492 7.94796 7.11109C7.98171 4.85805 9.76496 3.00952 11.9859 3.00146C14.2339 2.99082 16.0526 4.84858 16.0526 7.12618C16.0526 7.54798 16.3926 7.88129 16.7962 7.87608C17.195 7.87261 17.5293 7.50969 17.5262 7.08362C17.5038 4.00109 15.0472 1.50151 12 1.50151Z\\\" />\\n<path d=\\\"M15.2697 18.0004H8.68419C8.27727 18.0004 7.94735 17.6646 7.94735 17.2505C7.94735 16.8363 8.27727 16.5005 8.68419 16.5005H15.2697C15.6766 16.5005 16.0065 16.8363 16.0065 17.2505C16.0065 17.6646 15.6767 18.0004 15.2697 18.0004Z\\\" />\\n<path d=\\\"M15.2697 21.0002H8.68419C8.27727 21.0002 7.94735 20.6644 7.94735 20.2503C7.94735 19.8361 8.27727 19.5003 8.68419 19.5003H15.2697C15.6766 19.5003 16.0065 19.8361 16.0065 20.2503C16.0065 20.6644 15.6767 21.0002 15.2697 21.0002Z\\\" />\\n</svg>\\n\",\"gift\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4 11C4.55228 11 5 11.4477 5 12V21H19V12C19 11.4477 19.4477 11 20 11C20.5523 11 21 11.4477 21 12V22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22V12C3 11.4477 3.44772 11 4 11Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1 7C1 6.44772 1.44772 6 2 6H22C22.5523 6 23 6.44772 23 7V12C23 12.5523 22.5523 13 22 13H2C1.44772 13 1 12.5523 1 12V7ZM3 8V11H21V8H3Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 6C12.5523 6 13 6.44772 13 7V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V7C11 6.44772 11.4477 6 12 6Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M7.5 3C7.10218 3 6.72064 3.15804 6.43934 3.43934C6.15804 3.72064 6 4.10218 6 4.5C6 4.89782 6.15804 5.27936 6.43934 5.56066C6.72064 5.84196 7.10218 6 7.5 6H10.654C10.5319 5.68061 10.3774 5.32942 10.1863 4.98192C9.55732 3.83834 8.6939 3 7.5 3ZM12 7C12.9806 6.80388 12.9805 6.80354 12.9804 6.80318L12.9803 6.80236L12.9799 6.80038L12.9788 6.79503L12.9754 6.77893C12.9727 6.76583 12.9688 6.74805 12.9639 6.72588C12.954 6.68157 12.9396 6.61965 12.9203 6.54262C12.8819 6.38877 12.8237 6.17343 12.7424 5.91686C12.581 5.40732 12.3233 4.71734 11.9387 4.01808C11.1927 2.66166 9.8061 1 7.5 1C6.57174 1 5.6815 1.36875 5.02513 2.02513C4.36875 2.6815 4 3.57174 4 4.5C4 5.42826 4.36875 6.3185 5.02513 6.97487C5.6815 7.63125 6.57174 8 7.5 8H12C12.2996 8 12.5834 7.86568 12.7733 7.63399C12.9633 7.4023 13.0393 7.09766 12.9806 6.80388L12 7Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12.0613 4.01808C12.8073 2.66166 14.1939 1 16.5 1C17.4283 1 18.3185 1.36875 18.9749 2.02513C19.6313 2.6815 20 3.57174 20 4.5C20 5.42826 19.6313 6.3185 18.9749 6.97487C18.3185 7.63125 17.4283 8 16.5 8H12C11.7004 8 11.4166 7.86568 11.2267 7.63399C11.0367 7.4023 10.9607 7.09766 11.0194 6.80388L12 7C11.0194 6.80388 11.0195 6.80354 11.0196 6.80318L11.0197 6.80236L11.0201 6.80038L11.0212 6.79503L11.0246 6.77893C11.0274 6.76583 11.0312 6.74805 11.0361 6.72588C11.046 6.68157 11.0604 6.61965 11.0797 6.54262C11.1181 6.38877 11.1764 6.17343 11.2576 5.91686C11.419 5.40732 11.6767 4.71734 12.0613 4.01808ZM13.346 6H16.5C16.8978 6 17.2794 5.84196 17.5607 5.56066C17.842 5.27936 18 4.89782 18 4.5C18 4.10218 17.842 3.72064 17.5607 3.43934C17.2794 3.15804 16.8978 3 16.5 3C15.3061 3 14.4427 3.83834 13.8137 4.98192C13.6226 5.32942 13.4681 5.68061 13.346 6ZM12.9803 7.1978C12.9802 7.19807 12.9802 7.19804 12.9803 7.19772L12.9803 7.1978Z\\\" />\\n</svg>\\n\",\"globe\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1 12C1 11.4477 1.44772 11 2 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H2C1.44772 13 1 12.5523 1 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M9.00023 12C9.06877 15.0748 10.1263 18.0352 12 20.4492C13.8737 18.0352 14.9312 15.0748 14.9998 12C14.9312 8.92516 13.8737 5.96485 12 3.5508C10.1263 5.96485 9.06877 8.92516 9.00023 12ZM12 2L11.2617 1.32558C8.59689 4.24291 7.08251 8.02885 7.00022 11.9792C6.99993 11.9931 6.99993 12.0069 7.00022 12.0208C7.08251 15.9711 8.59689 19.7571 11.2617 22.6744C11.4511 22.8818 11.7191 23 12 23C12.2809 23 12.5489 22.8818 12.7383 22.6744C15.4031 19.7571 16.9175 15.9711 16.9998 12.0208C17.0001 12.0069 17.0001 11.9931 16.9998 11.9792C16.9175 8.02885 15.4031 4.24291 12.7383 1.32558L12 2Z\\\" />\\n</svg>\\n\",\"heart\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"heart\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M14.4619 2.49324C15.2507 2.1664 16.0961 1.99817 16.95 1.99817C17.8038 1.99817 18.6493 2.1664 19.4381 2.49324C20.2268 2.82003 20.9434 3.29897 21.5469 3.90272C22.1507 4.50627 22.63 5.22318 22.9567 6.01185C23.2836 6.80066 23.4518 7.64614 23.4518 8.49999C23.4518 9.35384 23.2836 10.1993 22.9567 10.9881C22.6299 11.7769 22.1509 12.4935 21.5471 13.0971C21.547 13.0972 21.5472 13.097 21.5471 13.0971L12.7071 21.9371C12.3166 22.3276 11.6834 22.3276 11.2929 21.9371L2.45289 13.0971C1.23366 11.8779 0.548706 10.2242 0.548706 8.49999C0.548706 6.77574 1.23366 5.12212 2.45289 3.90289C3.67212 2.68366 5.32575 1.9987 7.05 1.9987C8.77425 1.9987 10.4279 2.68366 11.6471 3.90289L12 4.25578L12.3527 3.90305C12.3528 3.903 12.3527 3.90311 12.3527 3.90305C12.9563 3.29923 13.6731 2.82006 14.4619 2.49324ZM16.95 3.99817C16.3589 3.99817 15.7735 4.11463 15.2274 4.34091C14.6813 4.56719 14.1852 4.89885 13.7673 5.31694L12.7071 6.3771C12.3166 6.76763 11.6834 6.76763 11.2929 6.3771L10.2329 5.3171C9.38873 4.47295 8.24381 3.9987 7.05 3.9987C5.85618 3.9987 4.71126 4.47295 3.8671 5.3171C3.02295 6.16126 2.54871 7.30618 2.54871 8.49999C2.54871 9.69381 3.02295 10.8387 3.8671 11.6829L12 19.8158L20.1329 11.6829C20.551 11.265 20.8828 10.7687 21.1091 10.2226C21.3354 9.67645 21.4518 9.09112 21.4518 8.49999C21.4518 7.90887 21.3354 7.32353 21.1091 6.77743C20.8828 6.23133 20.5511 5.73516 20.1331 5.31727C19.7152 4.89918 19.2187 4.56719 18.6726 4.34091C18.1265 4.11463 17.5411 3.99817 16.95 3.99817Z\\\" />\\n</g>\\n</svg>\\n\",\"home\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"home\\\">\\n<path id=\\\"Vector (Stroke)\\\" fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M11.3861 1.21065C11.7472 0.929784 12.2528 0.929784 12.6139 1.21065L21.6139 8.21065C21.8575 8.4001 22 8.69141 22 9V22C22 22.5523 21.5523 23 21 23H15C14.4477 23 14 22.5523 14 22V14H10V22C10 22.5523 9.55228 23 9 23H3C2.44772 23 2 22.5523 2 22V9C2 8.69141 2.14247 8.4001 2.38606 8.21065L11.3861 1.21065ZM4 9.48908V21H8V13C8 12.4477 8.44772 12 9 12H15C15.5523 12 16 12.4477 16 13V21H20V9.48908L12 3.26686L4 9.48908Z\\\" />\\n</g>\\n</svg>\\n\",\"image\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5ZM2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8.5 8C8.22386 8 8 8.22386 8 8.5C8 8.77614 8.22386 9 8.5 9C8.77614 9 9 8.77614 9 8.5C9 8.22386 8.77614 8 8.5 8ZM6 8.5C6 7.11929 7.11929 6 8.5 6C9.88071 6 11 7.11929 11 8.5C11 9.88071 9.88071 11 8.5 11C7.11929 11 6 9.88071 6 8.5Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M15.2929 9.29289C15.6834 8.90237 16.3166 8.90237 16.7071 9.29289L21.7071 14.2929C22.0976 14.6834 22.0976 15.3166 21.7071 15.7071C21.3166 16.0976 20.6834 16.0976 20.2929 15.7071L16 11.4142L5.70711 21.7071C5.31658 22.0976 4.68342 22.0976 4.29289 21.7071C3.90237 21.3166 3.90237 20.6834 4.29289 20.2929L15.2929 9.29289Z\\\" />\\n</svg>\\n\",\"loader\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 1C12.5523 1 13 1.44772 13 2V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V2C11 1.44772 11.4477 1 12 1Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M12 17C12.5523 17 13 17.4477 13 18V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V18C11 17.4477 11.4477 17 12 17Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4.22289 4.22289C4.61342 3.83237 5.24658 3.83237 5.63711 4.22289L8.46711 7.05289C8.85763 7.44342 8.85763 8.07658 8.46711 8.46711C8.07658 8.85763 7.44342 8.85763 7.05289 8.46711L4.22289 5.63711C3.83237 5.24658 3.83237 4.61342 4.22289 4.22289Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M15.5329 15.5329C15.9234 15.1424 16.5566 15.1424 16.9471 15.5329L19.7771 18.3629C20.1676 18.7534 20.1676 19.3866 19.7771 19.7771C19.3866 20.1676 18.7534 20.1676 18.3629 19.7771L15.5329 16.9471C15.1424 16.5566 15.1424 15.9234 15.5329 15.5329Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1 12C1 11.4477 1.44772 11 2 11H6C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13H2C1.44772 13 1 12.5523 1 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M17 12C17 11.4477 17.4477 11 18 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H18C17.4477 13 17 12.5523 17 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M8.46711 15.5329C8.85763 15.9234 8.85763 16.5566 8.46711 16.9471L5.63711 19.7771C5.24658 20.1676 4.61342 20.1676 4.22289 19.7771C3.83237 19.3866 3.83237 18.7534 4.22289 18.3629L7.05289 15.5329C7.44342 15.1424 8.07658 15.1424 8.46711 15.5329Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M19.7771 4.22289C20.1676 4.61342 20.1676 5.24658 19.7771 5.63711L16.9471 8.46711C16.5566 8.85763 15.9234 8.85763 15.5329 8.46711C15.1424 8.07658 15.1424 7.44342 15.5329 7.05289L18.3629 4.22289C18.7534 3.83237 19.3866 3.83237 19.7771 4.22289Z\\\" />\\n</svg>\\n\",\"mail\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4.00009 5C3.45237 5 3.00009 5.45228 3.00009 6V18C3.00009 18.5477 3.45237 19 4.00009 19H20.0001C20.5478 19 21.0001 18.5477 21.0001 18V6C21.0001 5.45228 20.5478 5 20.0001 5H4.00009ZM1.00009 6C1.00009 4.34772 2.3478 3 4.00009 3H20.0001C21.6524 3 23.0001 4.34772 23.0001 6V18C23.0001 19.6523 21.6524 21 20.0001 21H4.00009C2.3478 21 1.00009 19.6523 1.00009 18V6Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1.18085 5.42654C1.49757 4.97409 2.1211 4.86405 2.57355 5.18077L12.0001 11.7793L21.4266 5.18077C21.8791 4.86405 22.5026 4.97409 22.8193 5.42654C23.136 5.87899 23.026 6.50252 22.5735 6.81923L12.5735 13.8192C12.2292 14.0603 11.7709 14.0603 11.4266 13.8192L1.42662 6.81923C0.974174 6.50252 0.864139 5.87899 1.18085 5.42654Z\\\" />\\n</svg>\\n\",\"merge\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path d=\\\"M20.9655 19.931C16.5923 19.931 13.0345 16.3732 13.0345 12V5.53198L15.7513 8.24874C15.9453 8.44275 16.2084 8.55175 16.4827 8.55175C16.7571 8.55176 17.0202 8.44277 17.2142 8.24877C17.4083 8.05476 17.5173 7.79164 17.5173 7.51727C17.5173 7.24291 17.4083 6.97978 17.2143 6.78577L12.7315 2.30301C12.6354 2.20695 12.5214 2.13074 12.3959 2.07875C12.2704 2.02676 12.1359 2 12 2C11.8641 2 11.7296 2.02676 11.6041 2.07875C11.4786 2.13074 11.3646 2.20695 11.2685 2.30301L6.78573 6.78577C6.59173 6.97978 6.48274 7.24291 6.48275 7.51727C6.48275 7.79164 6.59175 8.05476 6.78575 8.24877C6.97976 8.44277 7.24289 8.55176 7.51726 8.55175C7.79162 8.55175 8.05475 8.44275 8.24875 8.24874L10.9655 5.53198V12C10.9655 16.3732 7.40767 19.931 3.03448 19.931C2.76012 19.931 2.497 20.04 2.30299 20.234C2.10899 20.428 2 20.6912 2 20.9655C2 21.2399 2.10899 21.503 2.30299 21.697C2.497 21.891 2.76012 22 3.03448 22C4.34823 22.0036 5.64965 21.7466 6.8634 21.2438C8.07715 20.7411 9.17913 20.0026 10.1056 19.0711C10.8757 18.3026 11.5156 17.4138 12 16.4397C12.8299 18.1082 14.1085 19.5124 15.6922 20.4946C17.2759 21.4768 19.102 21.9981 20.9655 22C21.2399 22 21.503 21.891 21.697 21.697C21.891 21.503 22 21.2399 22 20.9655C22 20.6912 21.891 20.428 21.697 20.234C21.503 20.04 21.2399 19.931 20.9655 19.931Z\\\" />\\n</svg>\\n\",\"message-square\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V18.5858L6.29289 16.2929C6.48043 16.1054 6.73478 16 7 16H19C19.2652 16 19.5196 15.8946 19.7071 15.7071C19.8946 15.5196 20 15.2652 20 15V5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4H5ZM2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.7957 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V15C22 15.7957 21.6839 16.5587 21.1213 17.1213C20.5587 17.6839 19.7957 18 19 18H7.41421L3.70711 21.7071C3.42111 21.9931 2.99099 22.0787 2.61732 21.9239C2.24364 21.7691 2 21.4045 2 21V5C2 4.20435 2.31607 3.44129 2.87868 2.87868Z\\\" />\\n</svg>\\n\",\"more-horizontal\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M17 12C17 10.8954 17.8954 10 19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12Z\\\" />\\n</svg>\\n\",\"more-vertical\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M10 19C10 17.8954 10.8954 17 12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19Z\\\" />\\n</svg>\\n\",\"note\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M1.87868 3.87869C2.44129 3.31608 3.20435 3.00001 4 3.00001H11C11.5523 3.00001 12 3.44773 12 4.00001C12 4.5523 11.5523 5.00001 11 5.00001H4C3.73478 5.00001 3.48043 5.10537 3.29289 5.29291C3.10536 5.48044 3 5.7348 3 6.00001V20C3 20.2652 3.10536 20.5196 3.29289 20.7071C3.48043 20.8947 3.73478 21 4 21H18C18.2652 21 18.5196 20.8947 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V13C19 12.4477 19.4477 12 20 12C20.5523 12 21 12.4477 21 13V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H4C3.20435 23 2.44129 22.6839 1.87868 22.1213C1.31607 21.5587 1 20.7957 1 20V6.00001C1 5.20436 1.31607 4.4413 1.87868 3.87869Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M20 2.87869C19.7026 2.87869 19.4174 2.99683 19.2071 3.20712L9.90296 12.5113L9.37437 14.6256L11.4888 14.097L20.7929 4.79291C21.0032 4.58262 21.1213 4.29741 21.1213 4.00001C21.1213 3.70262 21.0032 3.41741 20.7929 3.20712C20.5826 2.99683 20.2974 2.87869 20 2.87869ZM17.7929 1.79291C18.3783 1.20755 19.1722 0.878693 20 0.878693C20.8278 0.878693 21.6217 1.20755 22.2071 1.79291C22.7925 2.37827 23.1213 3.17219 23.1213 4.00001C23.1213 4.82784 22.7925 5.62176 22.2071 6.20712L12.7071 15.7071C12.5789 15.8353 12.4184 15.9262 12.2425 15.9702L8.24254 16.9702C7.90176 17.0553 7.54127 16.9555 7.29289 16.7071C7.04451 16.4587 6.94466 16.0983 7.02986 15.7575L8.02986 11.7575C8.07382 11.5816 8.16473 11.4211 8.29289 11.2929L17.7929 1.79291Z\\\" />\\n</svg>\\n\",\"puzzle\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M4 23C3.44772 23 3 22.5523 3 22L3 6C3 5.44772 3.44771 5 4 5L8 5C8 5 9 2 12 2C15 2 16 5 16 5L20 5C20.5523 5 21 5.44771 21 6L21 11.5C21 11.7761 20.7761 12 20.5 12L20 12C18.9 12 18 13.0435 18 14C18 15.0206 19.0571 16 20 16L20.5 16C20.7761 16 21 16.2239 21 16.5L21 22C21 22.5523 20.5523 23 20 23L4 23ZM5.5 7C5.22385 7 5 7.22386 5 7.5L5 20.5C5 20.7761 5.22386 21 5.5 21L18.5 21C18.7761 21 19 20.7761 19 20.5L19 18C19 18 16 17 16 14C16 11 19 10 19 10L19 7.5C19 7.22386 18.7761 7 18.5 7L14.5 7C14.2239 7 14 6.77614 14 6.5L14 6.04348C14 5.5 13.5 4 12 4C10.5 4 10 5.5 10 6C10 6.55229 9.55228 7 9 7L5.5 7Z\\\" />\\n</svg>\\n\",\"share-2\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M18 3C16.8954 3 16 3.89543 16 5C16 6.10457 16.8954 7 18 7C19.1046 7 20 6.10457 20 5C20 3.89543 19.1046 3 18 3ZM14 5C14 2.79086 15.7909 1 18 1C20.2091 1 22 2.79086 22 5C22 7.20914 20.2091 9 18 9C15.7909 9 14 7.20914 14 5Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10ZM2 12C2 9.79086 3.79086 8 6 8C8.20914 8 10 9.79086 10 12C10 14.2091 8.20914 16 6 16C3.79086 16 2 14.2091 2 12Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M18 17C16.8954 17 16 17.8954 16 19C16 20.1046 16.8954 21 18 21C19.1046 21 20 20.1046 20 19C20 17.8954 19.1046 17 18 17ZM14 19C14 16.7909 15.7909 15 18 15C20.2091 15 22 16.7909 22 19C22 21.2091 20.2091 23 18 23C15.7909 23 14 21.2091 14 19Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M7.72599 13.0065C8.00406 12.5293 8.6163 12.3679 9.09348 12.646L15.9235 16.626C16.4007 16.9041 16.5621 17.5163 16.284 17.9935C16.0059 18.4707 15.3937 18.6321 14.9165 18.354L8.08652 14.374C7.60934 14.0959 7.44793 13.4837 7.72599 13.0065Z\\\" />\\n<path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M16.2737 6.00597C16.5521 6.48297 16.391 7.09532 15.914 7.37369L9.09403 11.3537C8.61703 11.6321 8.00468 11.471 7.72631 10.994C7.44795 10.517 7.60897 9.90468 8.08597 9.62631L14.906 5.64631C15.383 5.36795 15.9953 5.52897 16.2737 6.00597Z\\\" />\\n</svg>\\n\",\"shop\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<g id=\\\"Shop\\\">\\n<path id=\\\"Vector\\\" d=\\\"M23.8812 8.87167L22.6208 3.77333C22.3568 2.72333 21.4205 2 20.3281 2H3.65474C2.57439 2 1.62609 2.735 1.374 3.77333L0.113599 8.87167C-0.174494 10.0617 0.0895916 11.275 0.857839 12.2317C0.95387 12.36 1.08591 12.4533 1.19395 12.57V20.6667C1.19395 21.95 2.27429 23 3.59472 23H20.4001C21.7206 23 22.8009 21.95 22.8009 20.6667V12.57C22.9089 12.465 23.041 12.36 23.137 12.2433C23.9053 11.2867 24.1813 10.0617 23.8812 8.87167ZM20.2921 4.32167L21.5525 9.42C21.6725 9.91 21.5645 10.4 21.2524 10.785C21.0843 10.995 20.7242 11.3333 20.124 11.3333C19.3918 11.3333 18.7556 10.7617 18.6716 10.0033L17.9753 4.33333L20.2921 4.32167ZM13.1978 4.33333H15.5506L16.1988 9.60667C16.2588 10.0617 16.1147 10.5167 15.8026 10.855C15.5386 11.1583 15.1544 11.3333 14.6623 11.3333C13.858 11.3333 13.1978 10.645 13.1978 9.805V4.33333ZM7.78407 9.60667L8.44428 4.33333H10.797V9.805C10.797 10.645 10.1368 11.3333 9.24854 11.3333C8.84041 11.3333 8.46829 11.1583 8.18019 10.855C7.8801 10.5167 7.73605 10.0617 7.78407 9.60667ZM2.44235 9.42L3.65474 4.33333H6.0195L5.32328 10.0033C5.22724 10.7617 4.60304 11.3333 3.87081 11.3333C3.28262 11.3333 2.9105 10.995 2.75445 10.785C2.43035 10.4117 2.32231 9.91 2.44235 9.42ZM3.59472 20.6667V13.6317C3.69075 13.6433 3.77478 13.6667 3.87081 13.6667C4.91514 13.6667 5.86345 13.2467 6.55967 12.5583C7.27991 13.2583 8.24021 13.6667 9.33257 13.6667C10.3769 13.6667 11.3132 13.2467 12.0094 12.5817C12.7177 13.2467 13.678 13.6667 14.7583 13.6667C15.7666 13.6667 16.7269 13.2583 17.4472 12.5583C18.1434 13.2467 19.0917 13.6667 20.136 13.6667C20.2321 13.6667 20.3161 13.6433 20.4121 13.6317V20.6667H3.59472Z\\\" />\\n</g>\\n</svg>\\n\",\"tap\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 24 24\\\" >\\n<path d=\\\"M22.5701 10.7341L18.8092 6.60324C18.0883 5.88027 16.8363 5.87526 16.1024 6.60924C15.8654 6.84623 15.7034 7.13122 15.6194 7.43519C14.8894 6.8752 13.7754 6.93623 13.1025 7.60919C12.8655 7.84618 12.7035 8.13116 12.6175 8.43415C11.8895 7.87416 10.7746 7.93819 10.1026 8.60913C9.86959 8.84213 9.70962 9.12112 9.62262 9.4161L7.85068 7.64415C7.10572 6.90018 5.89574 6.89817 5.14277 7.65015C4.39782 8.39412 4.39782 9.60607 5.14277 10.351L11.9505 17.1587L7.91466 17.7927C6.8227 17.9488 5.99975 18.8967 5.99975 19.9997C5.99975 20.8266 6.67271 21.4996 7.49969 21.4996H16.9283C18.3962 21.4996 19.7772 20.9276 20.8191 19.8877L22.3911 18.3148C23.429 17.2778 24 15.8978 24 14.4309C24 13.0609 23.492 11.748 22.5701 10.7341ZM21.6831 17.6088L20.1112 19.1817C19.2602 20.0316 18.1292 20.4996 16.9283 20.4996H7.49969C7.22469 20.4996 6.9997 20.2756 6.9997 19.9996C6.9997 19.3916 7.45366 18.8687 8.06165 18.7807L13.0765 17.9927C13.2625 17.9637 13.4154 17.8327 13.4745 17.6537C13.5324 17.4757 13.4855 17.2787 13.3525 17.1457L5.84976 9.6431C5.49577 9.28813 5.49577 8.71112 5.85576 8.35015C6.03374 8.17316 6.26674 8.08415 6.49975 8.08415C6.73275 8.08415 6.96571 8.17316 7.14374 8.35114L10.0796 11.287C10.0866 11.295 10.0956 11.303 10.1036 11.311L12.1475 13.3539C12.3425 13.5489 12.6595 13.5489 12.8545 13.3539C13.0495 13.159 13.0495 12.842 12.8545 12.647L10.7936 10.586C10.4566 10.23 10.4626 9.66508 10.8166 9.31012C11.1606 8.96813 11.7585 8.96611 12.1025 9.31012L13.0855 10.2941C13.0915 10.3001 13.0965 10.3061 13.1025 10.3111L14.1465 11.3541C14.3415 11.5491 14.6585 11.5491 14.8535 11.3541C15.0485 11.1591 15.0485 10.8421 14.8535 10.6471L13.7975 9.5921C13.4565 9.2361 13.4605 8.66716 13.8165 8.31017C14.1595 7.96819 14.7585 7.96617 15.1025 8.31017L16.1464 9.35811C16.1474 9.3591 16.1474 9.36013 16.1484 9.36013L16.1494 9.36111C16.1575 9.36519 16.1555 9.36416 16.1534 9.36313C16.1534 9.36313 16.1534 9.36411 16.1544 9.36411C16.1554 9.3651 16.1554 9.3651 16.1554 9.3651C16.1564 9.36608 16.1564 9.36608 16.1564 9.36608H16.1573C16.1583 9.36608 16.1583 9.36608 16.1583 9.36608C16.3563 9.55006 16.6643 9.54509 16.8543 9.3531C17.0483 9.15811 17.0483 8.84213 16.8533 8.64714L16.7933 8.58715C16.4553 8.23114 16.4603 7.6652 16.8153 7.31018C17.1593 6.9682 17.7732 6.9832 18.0852 7.29317L21.8291 11.408C22.5841 12.238 22.999 13.3109 22.999 14.4319C22.9991 15.6309 22.5311 16.7598 21.6831 17.6088Z\\\" />\\n<path d=\\\"M16.1523 9.36313H16.1533C16.1523 9.36261 16.1513 9.36214 16.1513 9.36214C16.1523 9.36313 16.1534 9.36313 16.1523 9.36313Z\\\" />\\n<path d=\\\"M10.5966 7.15419C9.86758 5.54227 8.26063 4.50028 6.4997 4.50028C4.0188 4.50028 1.99989 6.5192 1.99989 9.0001C1.99989 10.76 3.04183 12.368 4.65276 13.0969C4.71974 13.1269 4.78977 13.141 4.85877 13.141C5.04978 13.141 5.23075 13.0309 5.31475 12.847C5.42776 12.595 5.31677 12.299 5.06478 12.185C3.81083 11.618 2.99988 10.3681 2.99988 9.00015C2.99988 7.07024 4.5698 5.50027 6.49975 5.50027C7.86769 5.50027 9.11766 6.31123 9.68464 7.56517C9.79863 7.81716 10.0936 7.92914 10.3466 7.81515C10.5976 7.70218 10.7096 7.4052 10.5966 7.15419Z\\\" />\\n<path d=\\\"M12.7745 7.32921C12.0195 4.48632 9.4386 2.5004 6.49975 2.5004C2.91588 2.5004 0 5.41628 0 9.00015C0 11.939 1.98592 14.5199 4.8298 15.2749C4.87278 15.2869 4.91581 15.2919 4.95781 15.2919C5.1798 15.2919 5.38178 15.1449 5.44079 14.9209C5.51181 14.6539 5.3538 14.38 5.08582 14.3089C2.68091 13.67 0.99999 11.487 0.99999 9.00015C0.99999 5.96727 3.46791 3.50039 6.49975 3.50039C8.98566 3.50039 11.1696 5.18032 11.8085 7.58622C11.8785 7.85222 12.1435 8.0122 12.4205 7.94119C12.6865 7.87018 12.8445 7.5962 12.7745 7.32921Z\\\" />\\n</svg>\\n\",\"telegram-transparent\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 40 40\\\" >\\n<path d=\\\"M17.5894 22.7995L17.2188 27.7134C17.749 27.7134 17.9786 27.4987 18.2539 27.2409L20.7395 25.0013L25.8897 28.5573C26.8343 29.0537 27.4998 28.7923 27.7546 27.7381L31.1352 12.8028L31.1361 12.8019C31.4357 11.4854 30.6312 10.9706 29.7109 11.2936L9.83973 18.4664C8.48356 18.9627 8.5041 19.6755 9.60919 19.9985L14.6894 21.4883L26.4899 14.5267C27.0452 14.18 27.5501 14.3718 27.1348 14.7185L17.5894 22.7995Z\\\" />\\n</svg>\\n\",\"telegrambot-transparent\":\"<svg fill=\\\"currentColor\\\" width=\\\"1em\\\" height=\\\"1em\\\" viewBox=\\\"0 0 40 40\\\" >\\n<path d=\\\"M17.5894 22.7995L17.2188 27.7134C17.749 27.7134 17.9786 27.4987 18.2539 27.2409L20.7395 25.0013L25.8897 28.5573C26.8343 29.0537 27.4998 28.7923 27.7546 27.7381L31.1352 12.8028L31.1361 12.8019C31.4357 11.4854 30.6312 10.9706 29.7109 11.2936L9.83973 18.4664C8.48356 18.9627 8.5041 19.6755 9.60919 19.9985L14.6894 21.4883L26.4899 14.5267C27.0452 14.18 27.5501 14.3718 27.1348 14.7185L17.5894 22.7995Z\\\" />\\n<path d=\\\"M8.48085 12.9718C8.11477 12.9718 7.78137 12.8841 7.48066 12.7087C7.17342 12.5271 6.94789 12.289 6.80407 11.9946V12.8685H6V6H6.82368V8.96913C6.9675 8.68098 7.19303 8.45235 7.50028 8.28322C7.80752 8.11409 8.14092 8.02953 8.50046 8.02953C8.95152 8.02953 9.35029 8.13289 9.69676 8.3396C10.0367 8.55257 10.3047 8.84698 10.5008 9.22282C10.6904 9.60492 10.7852 10.034 10.7852 10.5101C10.7852 10.9861 10.6871 11.4121 10.491 11.7879C10.2949 12.1638 10.0269 12.455 9.68695 12.6617C9.34702 12.8747 8.94825 12.9812 8.49065 12.9812L8.48085 12.9718ZM8.3926 12.2389C8.83059 12.2389 9.1934 12.0823 9.48103 11.7691C9.76213 11.4622 9.90268 11.0425 9.90268 10.5101C9.90268 10.1718 9.83731 9.86801 9.70656 9.59866C9.57582 9.34183 9.39605 9.14452 9.16725 9.00671C8.92537 8.86264 8.66389 8.7906 8.38279 8.7906C8.06901 8.7906 7.79445 8.86577 7.55911 9.01611C7.3107 9.17897 7.12439 9.38881 7.00018 9.64564C6.86944 9.91499 6.80407 10.2063 6.80407 10.5195C6.80407 10.8389 6.86944 11.1333 7.00018 11.4027C7.12439 11.6658 7.30743 11.8725 7.5493 12.0228C7.78464 12.1732 8.0592 12.2483 8.37299 12.2483L8.3926 12.2389Z\\\" />\\n<path d=\\\"M14.5282 12.9906C14.0314 12.9843 13.5934 12.8685 13.2143 12.643C12.8351 12.4174 12.5377 12.1168 12.3219 11.7409C12.1062 11.3651 11.9983 10.9579 11.9983 10.5195C11.9983 10.0747 12.1062 9.66443 12.3219 9.28859C12.5246 8.91275 12.8188 8.61208 13.2044 8.38658C13.5901 8.16107 14.0314 8.04832 14.5282 8.04832C15.025 8.04832 15.4663 8.16107 15.852 8.38658C16.2311 8.61208 16.5286 8.91275 16.7443 9.28859C16.9535 9.67696 17.0581 10.0904 17.0581 10.5289C17.0581 10.9673 16.9502 11.3745 16.7345 11.7503C16.5188 12.1324 16.2213 12.4362 15.8422 12.6617C15.4761 12.8872 15.0577 13 14.5871 13C14.5674 13 14.5478 12.9969 14.5282 12.9906ZM14.5184 12.2671C14.8583 12.2671 15.1525 12.1888 15.4009 12.0322C15.6493 11.8694 15.8422 11.6564 15.9795 11.3933C16.1167 11.1302 16.1854 10.8421 16.1854 10.5289C16.1854 10.2219 16.1167 9.93691 15.9795 9.67383C15.8422 9.40447 15.6461 9.1915 15.3911 9.0349C15.1427 8.8783 14.8485 8.8 14.5086 8.8C14.1687 8.8 13.8745 8.8783 13.6261 9.0349C13.3711 9.1915 13.175 9.40447 13.0378 9.67383C12.9005 9.93691 12.8318 10.2219 12.8318 10.5289C12.8318 10.8421 12.9005 11.1302 13.0378 11.3933C13.175 11.6626 13.3711 11.8787 13.6261 12.0416C13.868 12.1982 14.1556 12.2765 14.489 12.2765C14.4955 12.2765 14.5053 12.2734 14.5184 12.2671Z\\\" />\\n<path d=\\\"M20.2057 12.8685C19.7677 12.8685 19.4376 12.762 19.2154 12.549C18.9866 12.3298 18.8722 12.0291 18.8722 11.647V8.82819H17.9798V8.14228H18.8722V6.77987H19.6958V8.14228H21V8.82819H19.6958V11.5812C19.6958 11.9633 19.9083 12.1544 20.3332 12.1544H21V12.8685H20.2057Z\\\" />\\n</svg>\\n\"}");

/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5135":
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__("7b0b");

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.13.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5e76":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseCheckbox_vue_vue_type_style_index_0_id_7906f9da_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e66e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseCheckbox_vue_vue_type_style_index_0_id_7906f9da_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseCheckbox_vue_vue_type_style_index_0_id_7906f9da_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5fc5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6467":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HorizontalScroll_vue_vue_type_style_index_0_id_a7651172_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c977");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HorizontalScroll_vue_vue_type_style_index_0_id_a7651172_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HorizontalScroll_vue_vue_type_style_index_0_id_a7651172_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6fab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseTabSwitcher_vue_vue_type_style_index_0_id_087cba2a_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5fc5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseTabSwitcher_vue_vue_type_style_index_0_id_087cba2a_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseTabSwitcher_vue_vue_type_style_index_0_id_087cba2a_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7251":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseDivider_vue_vue_type_style_index_0_id_8a33a628_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bf80");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseDivider_vue_vue_type_style_index_0_id_8a33a628_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseDivider_vue_vue_type_style_index_0_id_8a33a628_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "83bf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseIcon_vue_vue_type_style_index_0_id_c685c168_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("390a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseIcon_vue_vue_type_style_index_0_id_c685c168_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseIcon_vue_vue_type_style_index_0_id_c685c168_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "857a":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

var quot = /"/g;

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8888":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseButton_vue_vue_type_style_index_0_id_4cf2fb34_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dbab");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseButton_vue_vue_type_style_index_0_id_4cf2fb34_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseButton_vue_vue_type_style_index_0_id_4cf2fb34_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-assertion-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var shared = __webpack_require__("5692");

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9a60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseRadioButton_vue_vue_type_style_index_0_id_e0a71f22_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a5bb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseRadioButton_vue_vue_type_style_index_0_id_e0a71f22_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseRadioButton_vue_vue_type_style_index_0_id_e0a71f22_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "9f9f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a5bb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a758":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "aca2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseUnitInput_vue_vue_type_style_index_0_id_0768c780_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a758");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseUnitInput_vue_vue_type_style_index_0_id_0768c780_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseUnitInput_vue_vue_type_style_index_0_id_0768c780_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "af03":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "b2f7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseTab_vue_vue_type_style_index_0_id_7254e210_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fcdf");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseTab_vue_vue_type_style_index_0_id_7254e210_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseTab_vue_vue_type_style_index_0_id_7254e210_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "bf80":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c458":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c977":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cc71":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
  bold: function bold() {
    return createHTML(this, 'b', '', '');
  }
});


/***/ }),

/***/ "cdf3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d178":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d2e3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseRangeInput_vue_vue_type_style_index_0_id_a94c5cac_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dfbb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseRangeInput_vue_vue_type_style_index_0_id_a94c5cac_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseRangeInput_vue_vue_type_style_index_0_id_a94c5cac_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var redefine = __webpack_require__("6eeb");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExpPrototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d811":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d815":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LanguageSwitcher_vue_vue_type_style_index_0_id_6c19fffb_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3757");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LanguageSwitcher_vue_vue_type_style_index_0_id_6c19fffb_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LanguageSwitcher_vue_vue_type_style_index_0_id_6c19fffb_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d89b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseSelect_vue_vue_type_style_index_0_id_6679e92a_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("04e9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseSelect_vue_vue_type_style_index_0_id_6679e92a_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseSelect_vue_vue_type_style_index_0_id_6679e92a_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dbab":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "dfbb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e3e9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e66e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "f337":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PhoneInput_vue_vue_type_style_index_0_id_292d84c0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c458");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PhoneInput_vue_vue_type_style_index_0_id_292d84c0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PhoneInput_vue_vue_type_style_index_0_id_292d84c0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f405":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f709":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseInput_vue_vue_type_style_index_0_id_218973e2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("49b2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseInput_vue_vue_type_style_index_0_id_218973e2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseInput_vue_vue_type_style_index_0_id_218973e2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/css/breakpoints.scss
var breakpoints = __webpack_require__("e3e9");

// EXTERNAL MODULE: ./src/css/typography.css
var typography = __webpack_require__("9f9f");

// EXTERNAL MODULE: ./src/css/colors.css
var colors = __webpack_require__("3b15");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseButton.vue?vue&type=template&id=4cf2fb34&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.btnClass,style:(_vm.btnStyle),attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon && (_vm.iconPosition == 'left' || _vm.iconPosition == 'both'))?_c('BaseIcon',{class:_vm.leftIconClass,attrs:{"size":"xs","icon":_vm.icon}}):_vm._e(),_vm._t("default"),(_vm.icon && (_vm.iconPosition == 'right' || _vm.iconPosition == 'both'))?_c('BaseIcon',{class:_vm.rightIconClass,attrs:{"icon":_vm.icon,"size":"xs"}}):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseButton.vue?vue&type=template&id=4cf2fb34&scoped=true&

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.bold.js
var es_string_bold = __webpack_require__("cc71");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseButton.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseButtonvue_type_script_lang_js_ = ({
  props: {
    variant: String,
    size: {
      type: String,
      default: 'xs'
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    icon: String,
    color: {
      type: String,
      default: "black-1"
    },
    iconPosition: {
      type: String,
      default: "left"
    },
    align: {
      type: String,
      default: 'center'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    bold: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    matchTextColor: function matchTextColor(bgcolor) {
      var light_const = 'white-3';
      var dark_const = 'black-4';
      var specific_rules = {
        'green-4': dark_const,
        'green-3': dark_const,
        'green-2': dark_const,
        'green-1': dark_const,
        'yellow-10': light_const,
        'yellow-9': light_const,
        'yellow-8': light_const,
        'yellow-7': light_const,
        'blue-1': dark_const,
        'blue-2': dark_const,
        'blue-3': dark_const
      };
      var general_rules = {
        'white': dark_const,
        'brown': dark_const,
        'black': light_const,
        'grey': light_const,
        'green': light_const,
        'red': light_const,
        'yellow': dark_const,
        'orange': light_const,
        'blue': light_const
      };
      if (specific_rules[bgcolor]) return specific_rules[bgcolor];
      var color_name = bgcolor.split('-')[0];
      return general_rules[color_name] || light_const;
    }
  },
  computed: {
    btnClass: function btnClass() {
      var _ref;

      return _ref = {
        "qrw-button-text": true
      }, _defineProperty(_ref, this.size, true), _defineProperty(_ref, this.variant, true), _defineProperty(_ref, "with-icon", !!this.icon), _defineProperty(_ref, "fullwidth", this.fullWidth), _defineProperty(_ref, "loader", this.icon == 'loader'), _defineProperty(_ref, "tertiary", this.variant == 'tertiary'), _defineProperty(_ref, 'bold', this.bold), _ref;
    },
    btnStyle: function btnStyle() {
      var borderWidth = 1;
      var iconPaddings = {
        sm: 6,
        md: 14,
        lg: 22
      };
      var noIconPaddings = {
        sm: 4,
        md: 8,
        lg: 12
      };
      var base = {
        //only primary buttons have color
        "background-color": this.variant == 'primary' ? "var(--".concat(this.color, "-color)") : 'transparent',
        'color': this.variant == 'primary' ? "var(--".concat(this.matchTextColor(this.color), "-color)") : "var(--".concat(this.color, "-color)"),
        //only secondary buttons have border
        'border': this.variant == 'secondary' ? "1px solid var(--".concat(this.color, "-color)") : '0',
        'text-align': this.align,
        'justify-content': this.align
      };
      var iconPadding = iconPaddings[this.size];

      if (!this.hasButtonContent && this.icon) {
        var paddingSize = noIconPaddings[this.size];
        if (this.variant == 'secondary') paddingSize -= borderWidth;
        base['padding'] = paddingSize + 'px';
      } //if we have an icon, additional paddings apply based on size


      if (this.hasButtonContent && this.icon && this.iconPosition == 'left' || this.iconPosition == 'both') {
        base['padding-left'] = "".concat(iconPadding - 1, "px");
      }

      if (this.hasButtonContent && this.icon && this.iconPosition == 'right' || this.iconPosition == 'both') {
        base['padding-right'] = "".concat(iconPadding - 1, "px");
      }

      return base;
    },
    leftIconClass: function leftIconClass() {
      return {
        "btn-icon": true,
        "btn-icon-left-sm": this.size == 'sm' && this.hasButtonContent,
        "btn-icon-left-md": this.size == 'md' && this.hasButtonContent,
        "btn-icon-left-lg": this.size == 'lg' && this.hasButtonContent
      };
    },
    rightIconClass: function rightIconClass() {
      return {
        'btn-icon': true,
        "btn-icon-right-sm": this.size == 'sm' && this.hasButtonContent,
        "btn-icon-right-md": this.size == 'md' && this.hasButtonContent,
        "btn-icon-right-lg": this.size == 'lg' && this.hasButtonContent
      };
    },
    hasButtonContent: function hasButtonContent() {
      return !!this.$slots.default;
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseButtonvue_type_script_lang_js_ = (BaseButtonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseButton.vue?vue&type=style&index=0&id=4cf2fb34&scoped=true&lang=css&
var BaseButtonvue_type_style_index_0_id_4cf2fb34_scoped_true_lang_css_ = __webpack_require__("8888");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/BaseButton.vue






/* normalize component */

var component = normalizeComponent(
  components_BaseButtonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "4cf2fb34",
  null
  
)

/* harmony default export */ var BaseButton = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseRadioButton.vue?vue&type=template&id=e0a71f22&scoped=true&
var BaseRadioButtonvue_type_template_id_e0a71f22_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-toggle",on:{"click":_vm.emitValue}},[_c('div',{staticClass:"radio-item",class:{'disabled':_vm.readonly},style:(!!_vm.value ? ("background-color:" + _vm.bgColor + ";border:1px solid transparent"):'')}),_c('h3',{staticClass:"qrw-container-title-sm circle-label"},[_vm._t("default")],2)])}
var BaseRadioButtonvue_type_template_id_e0a71f22_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseRadioButton.vue?vue&type=template&id=e0a71f22&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseRadioButton.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseRadioButtonvue_type_script_lang_js_ = ({
  props: {
    value: Boolean,
    readonly: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: 'var(--green-7-color)'
    }
  },
  methods: {
    emitValue: function emitValue() {
      this.$emit("input", !this.value);
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseRadioButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseRadioButtonvue_type_script_lang_js_ = (BaseRadioButtonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseRadioButton.vue?vue&type=style&index=0&id=e0a71f22&scoped=true&lang=css&
var BaseRadioButtonvue_type_style_index_0_id_e0a71f22_scoped_true_lang_css_ = __webpack_require__("9a60");

// CONCATENATED MODULE: ./src/components/BaseRadioButton.vue






/* normalize component */

var BaseRadioButton_component = normalizeComponent(
  components_BaseRadioButtonvue_type_script_lang_js_,
  BaseRadioButtonvue_type_template_id_e0a71f22_scoped_true_render,
  BaseRadioButtonvue_type_template_id_e0a71f22_scoped_true_staticRenderFns,
  false,
  null,
  "e0a71f22",
  null
  
)

/* harmony default export */ var BaseRadioButton = (BaseRadioButton_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseDatepicker.vue?vue&type=template&id=1f477ffb&
var BaseDatepickervue_type_template_id_1f477ffb_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-date-picker',{attrs:{"locale":"uk","timezone":"Europe/Kiev","value":_vm.value,"placeholder":"10$","is24hr":"","mode":_vm.withTime ? 'dateTime' : 'date'},on:{"input":function (v) { return _vm.$emit('input', v); }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var inputValue = ref.inputValue;
var inputEvents = ref.inputEvents;
return [_c('BaseInput',_vm._g({staticClass:"w-100",attrs:{"value":inputValue,"placeholder":_vm.placeholder}},inputEvents))]}}])})}
var BaseDatepickervue_type_template_id_1f477ffb_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseDatepicker.vue?vue&type=template&id=1f477ffb&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseDatepicker.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseDatepickervue_type_script_lang_js_ = ({
  props: {
    placeholder: String,
    fullwidth: {
      type: Boolean,
      default: false
    },
    value: [String, Number, Date, Object],
    withTime: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseDatepicker.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseDatepickervue_type_script_lang_js_ = (BaseDatepickervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/BaseDatepicker.vue





/* normalize component */

var BaseDatepicker_component = normalizeComponent(
  components_BaseDatepickervue_type_script_lang_js_,
  BaseDatepickervue_type_template_id_1f477ffb_render,
  BaseDatepickervue_type_template_id_1f477ffb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var BaseDatepicker = (BaseDatepicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseCheckbox.vue?vue&type=template&id=7906f9da&scoped=true&
var BaseCheckboxvue_type_template_id_7906f9da_scoped_true_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-toggle",on:{"click":_vm.emitValue}},[(!_vm.checker)?_c('div',{staticClass:"checkbox-item",class:{'disabled':_vm.readonly},style:(!!_vm.value ? ("background-color:" + _vm.bgColor + ";border:1px solid transparent"):'')}):_vm._e(),(_vm.checker)?_c('BaseIcon',{attrs:{"icon":_vm.toggleImg}}):_vm._e(),_c('h3',{staticClass:"qrw-container-title-sm circle-label",class:( _obj = {}, _obj[(_vm.defaultTextColor + "-color")] = !_vm.value, _obj[(_vm.checkedTextColor + "-color")] = !!_vm.value, _obj )},[_vm._t("default")],2)],1)}
var BaseCheckboxvue_type_template_id_7906f9da_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseCheckbox.vue?vue&type=template&id=7906f9da&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseCheckbox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseCheckboxvue_type_script_lang_js_ = ({
  props: {
    value: Boolean,
    readonly: {
      type: Boolean,
      default: false
    },
    checker: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: 'var(--green-7-color)'
    },
    checkedTextColor: {
      type: String,
      default: 'black-4'
    },
    defaultTextColor: {
      type: String,
      default: 'grey-4'
    }
  },
  methods: {
    emitValue: function emitValue() {
      this.$emit("input", !this.value);
    }
  },
  computed: {
    toggleImg: function toggleImg() {
      return !this.value ? "checker-toggle-active" : "checker-toggle";
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseCheckbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseCheckboxvue_type_script_lang_js_ = (BaseCheckboxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseCheckbox.vue?vue&type=style&index=0&id=7906f9da&scoped=true&lang=css&
var BaseCheckboxvue_type_style_index_0_id_7906f9da_scoped_true_lang_css_ = __webpack_require__("5e76");

// CONCATENATED MODULE: ./src/components/BaseCheckbox.vue






/* normalize component */

var BaseCheckbox_component = normalizeComponent(
  components_BaseCheckboxvue_type_script_lang_js_,
  BaseCheckboxvue_type_template_id_7906f9da_scoped_true_render,
  BaseCheckboxvue_type_template_id_7906f9da_scoped_true_staticRenderFns,
  false,
  null,
  "7906f9da",
  null
  
)

/* harmony default export */ var BaseCheckbox = (BaseCheckbox_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseHeader.vue?vue&type=template&id=7517c275&scoped=true&
var BaseHeadervue_type_template_id_7517c275_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrw-header-wrapper"},[_c('div',{staticClass:"qrw-header-title"},[_c('h5',{staticClass:"qrw-container-title-sm w-100"},[_vm._t("title")],2),(_vm.$slots.actions)?_c('div',{staticClass:"qrw-header-actions w-100"},[_vm._t("actions")],2):_vm._e()]),_c('hr',{class:{ 'no-line': _vm.noline },style:({
      'border-top': ("1px solid var(--" + _vm.color + "-color)"),
    })})])}
var BaseHeadervue_type_template_id_7517c275_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseHeader.vue?vue&type=template&id=7517c275&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseHeader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseHeadervue_type_script_lang_js_ = ({
  props: {
    noline: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "black-4"
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseHeadervue_type_script_lang_js_ = (BaseHeadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseHeader.vue?vue&type=style&index=0&id=7517c275&scoped=true&lang=css&
var BaseHeadervue_type_style_index_0_id_7517c275_scoped_true_lang_css_ = __webpack_require__("1f4a");

// CONCATENATED MODULE: ./src/components/BaseHeader.vue






/* normalize component */

var BaseHeader_component = normalizeComponent(
  components_BaseHeadervue_type_script_lang_js_,
  BaseHeadervue_type_template_id_7517c275_scoped_true_render,
  BaseHeadervue_type_template_id_7517c275_scoped_true_staticRenderFns,
  false,
  null,
  "7517c275",
  null
  
)

/* harmony default export */ var BaseHeader = (BaseHeader_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseTab.vue?vue&type=template&id=7254e210&scoped=true&
var BaseTabvue_type_template_id_7254e210_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-switcher"},_vm._l((_vm.tabs),function(tab){
var _obj;
return _c('div',{key:tab.value,class:( _obj = {
        'tab': true
      }, _obj[("tab-" + _vm.size)] = true, _obj['tab-active'] =  tab.value == _vm.value, _obj ),on:{"click":function($event){return _vm.$emit('input', tab.value)}}},[(tab.icon)?_c('BaseIcon',{class:tab.text ? 'mr-3':'',attrs:{"icon":tab.icon}}):_vm._e(),_c('span',{staticClass:"qrw-button-text"},[_vm._v(_vm._s(tab.text))])],1)}),0)}
var BaseTabvue_type_template_id_7254e210_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseTab.vue?vue&type=template&id=7254e210&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseTab.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseTabvue_type_script_lang_js_ = ({
  props: {
    tabs: Array,
    value: String,
    size: String
  }
});
// CONCATENATED MODULE: ./src/components/BaseTab.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseTabvue_type_script_lang_js_ = (BaseTabvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseTab.vue?vue&type=style&index=0&id=7254e210&scoped=true&lang=css&
var BaseTabvue_type_style_index_0_id_7254e210_scoped_true_lang_css_ = __webpack_require__("b2f7");

// CONCATENATED MODULE: ./src/components/BaseTab.vue






/* normalize component */

var BaseTab_component = normalizeComponent(
  components_BaseTabvue_type_script_lang_js_,
  BaseTabvue_type_template_id_7254e210_scoped_true_render,
  BaseTabvue_type_template_id_7254e210_scoped_true_staticRenderFns,
  false,
  null,
  "7254e210",
  null
  
)

/* harmony default export */ var BaseTab = (BaseTab_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseTabSwitcher.vue?vue&type=template&id=087cba2a&scoped=true&
var BaseTabSwitchervue_type_template_id_087cba2a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-switcher",class:[_vm.themeBg, _vm.noCorners ? 'no-corners' : '', _vm.disabled ? 'disabled' : null ],style:({
    'width': _vm.cssWidth,
  })},_vm._l((_vm.tabs),function(tab){
  var _obj;
return _c('div',{key:tab.value,class:( _obj = {
      tab: true,
      'qrw-button-text': true
    }, _obj[("tab-" + _vm.size)] = true, _obj['tab-active'] =  (tab.value == _vm.value || (tab.hidden_values && tab.hidden_values.includes(_vm.value))) && _vm.themeBg !== 'dark', _obj['tab-active-dark'] =  _vm.themeBg == 'dark' && tab.value == _vm.value, _obj['tab-no-corners'] =  _vm.noCorners, _obj['tab-min-width'] = _vm.minWidth, _obj ),on:{"click":function($event){return _vm.onTabClicked(tab)}}},[(tab.icon)?_c('BaseIcon',{class:{'mr-3':tab.text},attrs:{"icon":tab.icon}}):_vm._e(),_c('span',{staticClass:"qrw-button-text"},[_vm._v(_vm._s(tab.text))])],1)}),0)}
var BaseTabSwitchervue_type_template_id_087cba2a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseTabSwitcher.vue?vue&type=template&id=087cba2a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseTabSwitcher.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseTabSwitchervue_type_script_lang_js_ = ({
  props: {
    tabs: Array,
    value: [Object, String, Date, Number, Array, Boolean],
    size: String,
    theme: String,
    noCorners: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: Boolean,
      default: false
    },
    cssWidth: {
      type: String,
      default: 'fit-content'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onTabClicked: function onTabClicked(tab) {
      if (!this.disabled) this.$emit('input', tab.value);
    }
  },
  computed: {
    themeBg: function themeBg() {
      return this.theme == "dark" ? "dark" : "";
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseTabSwitcher.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseTabSwitchervue_type_script_lang_js_ = (BaseTabSwitchervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseTabSwitcher.vue?vue&type=style&index=0&id=087cba2a&scoped=true&lang=css&
var BaseTabSwitchervue_type_style_index_0_id_087cba2a_scoped_true_lang_css_ = __webpack_require__("6fab");

// CONCATENATED MODULE: ./src/components/BaseTabSwitcher.vue






/* normalize component */

var BaseTabSwitcher_component = normalizeComponent(
  components_BaseTabSwitchervue_type_script_lang_js_,
  BaseTabSwitchervue_type_template_id_087cba2a_scoped_true_render,
  BaseTabSwitchervue_type_template_id_087cba2a_scoped_true_staticRenderFns,
  false,
  null,
  "087cba2a",
  null
  
)

/* harmony default export */ var BaseTabSwitcher = (BaseTabSwitcher_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseTextDivider.vue?vue&type=template&id=22b9d50b&scoped=true&
var BaseTextDividervue_type_template_id_22b9d50b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-divider"},[_c('BaseDivider',{attrs:{"color":"grey-20-color"}}),_c('h4',{staticClass:"qrw-container-title-sm"},[_vm._v(_vm._s(_vm.info))]),_c('BaseDivider',{attrs:{"color":"grey-20-color"}})],1)}
var BaseTextDividervue_type_template_id_22b9d50b_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseTextDivider.vue?vue&type=template&id=22b9d50b&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseTextDivider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseTextDividervue_type_script_lang_js_ = ({
  props: {
    info: String
  }
});
// CONCATENATED MODULE: ./src/components/BaseTextDivider.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseTextDividervue_type_script_lang_js_ = (BaseTextDividervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseTextDivider.vue?vue&type=style&index=0&id=22b9d50b&scoped=true&lang=css&
var BaseTextDividervue_type_style_index_0_id_22b9d50b_scoped_true_lang_css_ = __webpack_require__("4e53");

// CONCATENATED MODULE: ./src/components/BaseTextDivider.vue






/* normalize component */

var BaseTextDivider_component = normalizeComponent(
  components_BaseTextDividervue_type_script_lang_js_,
  BaseTextDividervue_type_template_id_22b9d50b_scoped_true_render,
  BaseTextDividervue_type_template_id_22b9d50b_scoped_true_staticRenderFns,
  false,
  null,
  "22b9d50b",
  null
  
)

/* harmony default export */ var BaseTextDivider = (BaseTextDivider_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseInput.vue?vue&type=template&id=218973e2&scoped=true&
var BaseInputvue_type_template_id_218973e2_scoped_true_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-wrapper",class:( _obj = {
    disabled: _vm.disabled,
    'full-width': _vm.fullWidth,
    invalid: !_vm.valid
  }, _obj[("input-wrapper-" + _vm.size)] = true, _obj )},[((_vm.leftIcon || _vm.icon) && (_vm.iconPosition == 'left' || _vm.iconPosition == 'both'))?_c('BaseIcon',{class:_vm.leftIconClass,attrs:{"icon":_vm.leftIcon || _vm.icon},on:{"click":function($event){return _vm.$emit('iconClicked', 'left')}}}):_vm._e(),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],ref:"baseInputElement",staticClass:"qrw-input-text",class:_vm.inputClass,attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"id":_vm.inputId,"required":_vm.required,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function (ev) { return _vm.$emit('input', ev.target.value); },"keyup":function (ev) { return _vm.$emit('keyup', ev); },"keydown":function (ev) { return _vm.$emit('keydown', ev); },"keypress":function($event){return _vm.isNumber($event)},"blur":function($event){return _vm.$emit('blur')}}}),((_vm.rightIcon || _vm.icon) && (_vm.iconPosition == 'right' || _vm.iconPosition == 'both'))?_c('BaseIcon',{class:_vm.rightIconClass,attrs:{"icon":_vm.rightIcon || _vm.icon},on:{"click":function($event){return _vm.$emit('iconClicked', 'right')}}}):_vm._e()],1)}
var BaseInputvue_type_template_id_218973e2_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseInput.vue?vue&type=template&id=218973e2&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseInput.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseInputvue_type_script_lang_js_ = ({
  props: {
    type: {
      type: String,
      default: "text"
    },
    position: String,
    placeholder: {
      type: [String, Number, Object, Boolean]
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    },
    leftIcon: {
      type: String
    },
    rightIcon: {
      type: String
    },
    iconPosition: {
      type: String,
      default: "left"
    },
    size: {
      type: String,
      default: "sm"
    },
    hasUnit: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    value: [String, Number, Object],
    valid: {
      type: Boolean,
      default: true
    },
    inputId: {
      type: String,
      default: null
    },
    mask: {
      type: String,
      default: null
    },
    leftIconColor: {
      type: String,
      default: null
    },
    rightIconColor: {
      type: String,
      default: null
    }
  },
  methods: {
    getInputElement: function getInputElement() {
      return this.$refs.baseInputElement;
    },
    isNumber: function isNumber(evt) {
      this.$emit('keypress', evt);

      if (this.type != 'number') {
        return true;
      }

      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
  computed: {
    inputClass: function inputClass() {
      return [this.position == "center" ? "text-center" : "", this.position == "right" ? "text-right" : "", this.hasUnit ? "unit-input" : "", !this.valid ? "invalid" : "", this.size == "lg" ? "qrw-input-text-lg" : ""];
    },
    leftIconClass: function leftIconClass() {
      return _defineProperty({
        "input-icon": true,
        "size-sm": this.size === "lg",
        opacity: !this.value || this.disabled,
        "input-icon-left": this.icon
      }, "".concat(this.leftIconColor || this.iconColorBasedOnState, "-color"), true);
    },
    rightIconClass: function rightIconClass() {
      return _defineProperty({
        "input-icon": true,
        "size-sm": this.size === "lg",
        opacity: !this.value || this.disabled,
        "input-icon-right": this.icon
      }, "".concat(this.rightIconColor || this.iconColorBasedOnState, "-color"), true);
    },
    iconColorBasedOnState: function iconColorBasedOnState() {
      if (this.disabled) return 'black-1';
      if (this.invalid) return 'red-4';
      if (!this.value) return 'grey-1';
      return 'black-1';
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseInputvue_type_script_lang_js_ = (BaseInputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseInput.vue?vue&type=style&index=0&id=218973e2&scoped=true&lang=css&
var BaseInputvue_type_style_index_0_id_218973e2_scoped_true_lang_css_ = __webpack_require__("f709");

// CONCATENATED MODULE: ./src/components/BaseInput.vue






/* normalize component */

var BaseInput_component = normalizeComponent(
  components_BaseInputvue_type_script_lang_js_,
  BaseInputvue_type_template_id_218973e2_scoped_true_render,
  BaseInputvue_type_template_id_218973e2_scoped_true_staticRenderFns,
  false,
  null,
  "218973e2",
  null
  
)

/* harmony default export */ var BaseInput = (BaseInput_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseIcon.vue?vue&type=template&id=c685c168&scoped=true&
var BaseIconvue_type_template_id_c685c168_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.outline)?_c('img',{staticClass:"icon",attrs:{"src":_vm.iconSvg,"alt":"icon"}}):_c('span',{class:_vm.iconSize,style:({
    'vertical-align': _vm.verticalAlign
  }),domProps:{"innerHTML":_vm._s(_vm.iconSvg)},on:{"click":function($event){return _vm.$emit('click')}}})}
var BaseIconvue_type_template_id_c685c168_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseIcon.vue?vue&type=template&id=c685c168&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./src/assets/icons.json
var icons = __webpack_require__("5056");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseIcon.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var BaseIconvue_type_script_lang_js_ = ({
  props: {
    outline: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "xs"
    },
    type: {
      type: String,
      default: "buttons"
    },
    verticalAlign: {
      type: String,
      default: 'middle'
    },
    icon: String
  },
  computed: {
    iconSvg: function iconSvg() {
      var capitalizedIcon = this.icon.substring(0, 1).toUpperCase() + this.icon.substring(1);
      if (this.outline) return "/icons/".concat(this.type, "/").concat(capitalizedIcon, "-outlined.svg");
      return icons[this.icon.toLowerCase()];
    },
    iconSize: function iconSize() {
      return "qrw-base-icon size-".concat(this.size);
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseIconvue_type_script_lang_js_ = (BaseIconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseIcon.vue?vue&type=style&index=0&id=c685c168&scoped=true&lang=css&
var BaseIconvue_type_style_index_0_id_c685c168_scoped_true_lang_css_ = __webpack_require__("83bf");

// CONCATENATED MODULE: ./src/components/BaseIcon.vue






/* normalize component */

var BaseIcon_component = normalizeComponent(
  components_BaseIconvue_type_script_lang_js_,
  BaseIconvue_type_template_id_c685c168_scoped_true_render,
  BaseIconvue_type_template_id_c685c168_scoped_true_staticRenderFns,
  false,
  null,
  "c685c168",
  null
  
)

/* harmony default export */ var BaseIcon = (BaseIcon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseToggleSwitcher.vue?vue&type=template&id=5bdbcfe0&scoped=true&
var BaseToggleSwitchervue_type_template_id_5bdbcfe0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-switcher-container"},[_c('div',{class:{
      'circle-switcher-box': true,
      large: _vm.size === 'lg',
      'circle-switcher-box-active': !!this.value,
      disabled: this.disabled,
    },style:(_vm.customizedStyle),on:{"click":_vm.onToggle}},[_c('div',{class:[
        _vm.value ? 'circle-switcher active' : 'circle-switcher',
        _vm.size == 'lg' ? 'large' : '' ],style:(!_vm.value ? ("background-color: var(--" + _vm.fillCircle + "-color)") : ("background-color: var(--" + _vm.enabledCircle + "-color)"))})])])}
var BaseToggleSwitchervue_type_template_id_5bdbcfe0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseToggleSwitcher.vue?vue&type=template&id=5bdbcfe0&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseToggleSwitcher.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseToggleSwitchervue_type_script_lang_js_ = ({
  props: {
    value: [String, Number, Boolean],
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md"
    },
    disabledBg: {
      type: String,
      default: 'black-4'
    },
    fillBg: {
      type: String,
      default: 'black-4'
    },
    fillCircle: {
      type: String,
      default: 'black-4'
    },
    enabledCircle: {
      type: String,
      default: 'white-10'
    }
  },
  methods: {
    onToggle: function onToggle() {
      if (this.disabled) return;
      this.$emit("input", !this.value);
    }
  },
  computed: {
    customizedStyle: function customizedStyle() {
      // if (!this.fillBg) return "";
      return this.value ? "background-color: var(--".concat(this.fillBg, "-color); border:1px solid var(--").concat(this.fillBg, "-color)") : "border:1px solid var(--".concat(this.disabledBg, "-color)");
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseToggleSwitcher.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseToggleSwitchervue_type_script_lang_js_ = (BaseToggleSwitchervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseToggleSwitcher.vue?vue&type=style&index=0&id=5bdbcfe0&scoped=true&lang=css&
var BaseToggleSwitchervue_type_style_index_0_id_5bdbcfe0_scoped_true_lang_css_ = __webpack_require__("43a3");

// CONCATENATED MODULE: ./src/components/BaseToggleSwitcher.vue






/* normalize component */

var BaseToggleSwitcher_component = normalizeComponent(
  components_BaseToggleSwitchervue_type_script_lang_js_,
  BaseToggleSwitchervue_type_template_id_5bdbcfe0_scoped_true_render,
  BaseToggleSwitchervue_type_template_id_5bdbcfe0_scoped_true_staticRenderFns,
  false,
  null,
  "5bdbcfe0",
  null
  
)

/* harmony default export */ var BaseToggleSwitcher = (BaseToggleSwitcher_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/HorizontalScroll.vue?vue&type=template&id=a7651172&scoped=true&
var HorizontalScrollvue_type_template_id_a7651172_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"scroll",attrs:{"min":"0","max":"10000","step":"5000","type":"range"}})}
var HorizontalScrollvue_type_template_id_a7651172_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/HorizontalScroll.vue?vue&type=template&id=a7651172&scoped=true&

// EXTERNAL MODULE: ./src/components/HorizontalScroll.vue?vue&type=style&index=0&id=a7651172&scoped=true&lang=css&
var HorizontalScrollvue_type_style_index_0_id_a7651172_scoped_true_lang_css_ = __webpack_require__("6467");

// CONCATENATED MODULE: ./src/components/HorizontalScroll.vue

var script = {}



/* normalize component */

var HorizontalScroll_component = normalizeComponent(
  script,
  HorizontalScrollvue_type_template_id_a7651172_scoped_true_render,
  HorizontalScrollvue_type_template_id_a7651172_scoped_true_staticRenderFns,
  false,
  null,
  "a7651172",
  null
  
)

/* harmony default export */ var HorizontalScroll = (HorizontalScroll_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseDivider.vue?vue&type=template&id=8a33a628&scoped=true&
var BaseDividervue_type_template_id_8a33a628_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{staticClass:"divider",class:{ dashed: _vm.dashed, vertical: _vm.vertical },style:(("border-color: var(--" + _vm.color + "-color)"))})}
var BaseDividervue_type_template_id_8a33a628_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseDivider.vue?vue&type=template&id=8a33a628&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseDivider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseDividervue_type_script_lang_js_ = ({
  props: {
    vertical: {
      type: Boolean,
      default: false
    },
    color: String,
    dashed: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseDivider.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseDividervue_type_script_lang_js_ = (BaseDividervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseDivider.vue?vue&type=style&index=0&id=8a33a628&scoped=true&lang=css&
var BaseDividervue_type_style_index_0_id_8a33a628_scoped_true_lang_css_ = __webpack_require__("7251");

// CONCATENATED MODULE: ./src/components/BaseDivider.vue






/* normalize component */

var BaseDivider_component = normalizeComponent(
  components_BaseDividervue_type_script_lang_js_,
  BaseDividervue_type_template_id_8a33a628_scoped_true_render,
  BaseDividervue_type_template_id_8a33a628_scoped_true_staticRenderFns,
  false,
  null,
  "8a33a628",
  null
  
)

/* harmony default export */ var BaseDivider = (BaseDivider_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseTextarea.vue?vue&type=template&id=addd61d2&scoped=true&
var BaseTextareavue_type_template_id_addd61d2_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"qrw-input-text",attrs:{"rows":_vm.rows,"disabled":_vm.disabled,"required":_vm.required,"placeholder":_vm.placeholder,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":function (ev) { return _vm.$emit('input', ev.target.value); },"blur":function($event){return _vm.$emit('blur')}}})}
var BaseTextareavue_type_template_id_addd61d2_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseTextarea.vue?vue&type=template&id=addd61d2&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseTextarea.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseTextareavue_type_script_lang_js_ = ({
  props: {
    value: [String, Number],
    readonly: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseTextarea.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseTextareavue_type_script_lang_js_ = (BaseTextareavue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseTextarea.vue?vue&type=style&index=0&id=addd61d2&scoped=true&lang=css&
var BaseTextareavue_type_style_index_0_id_addd61d2_scoped_true_lang_css_ = __webpack_require__("022e");

// CONCATENATED MODULE: ./src/components/BaseTextarea.vue






/* normalize component */

var BaseTextarea_component = normalizeComponent(
  components_BaseTextareavue_type_script_lang_js_,
  BaseTextareavue_type_template_id_addd61d2_scoped_true_render,
  BaseTextareavue_type_template_id_addd61d2_scoped_true_staticRenderFns,
  false,
  null,
  "addd61d2",
  null
  
)

/* harmony default export */ var BaseTextarea = (BaseTextarea_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseUnitInput.vue?vue&type=template&id=0768c780&scoped=true&
var BaseUnitInputvue_type_template_id_0768c780_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unit-input-wrapper",style:({
    width: _vm.fullWidth ? '100%' : 'fit-content',
  })},[_c('BaseInput',{attrs:{"valid":_vm.valid,"value":_vm.value,"position":_vm.position,"required":_vm.required,"placeholder":_vm.placeholder,"iconPosition":_vm.iconPosition,"fullWidth":_vm.fullWidth,"leftIcon":_vm.leftIcon,"righIcon":_vm.rightIcon,"type":_vm.type,"inputId":_vm.inputId,"icon":_vm.icon,"mask":_vm.mask,"disabled":_vm.disabled},on:{"input":function (v) { return _vm.$emit('input', v); },"blur":function($event){return _vm.$emit('blur')}}}),_c('BaseInput',{staticClass:"unit-box",attrs:{"hasUnit":"","disabled":"","placeholder":_vm.unitPlaceholder}})],1)}
var BaseUnitInputvue_type_template_id_0768c780_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseUnitInput.vue?vue&type=template&id=0768c780&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseUnitInput.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseUnitInputvue_type_script_lang_js_ = ({
  props: {
    type: {
      type: String,
      default: "text"
    },
    position: String,
    placeholder: {
      type: [String, Number, Object, Boolean]
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    },
    leftIcon: {
      type: String
    },
    rightIcon: {
      type: String
    },
    iconPosition: {
      type: String,
      default: "left"
    },
    size: {
      type: String,
      default: "sm"
    },
    hasUnit: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    value: [String, Number, Object],
    valid: {
      type: Boolean,
      default: true
    },
    inputId: {
      type: String,
      default: null
    },
    mask: {
      type: String,
      default: null
    },
    unitPlaceholder: {
      type: String,
      default: "units"
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseUnitInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseUnitInputvue_type_script_lang_js_ = (BaseUnitInputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseUnitInput.vue?vue&type=style&index=0&id=0768c780&scoped=true&lang=css&
var BaseUnitInputvue_type_style_index_0_id_0768c780_scoped_true_lang_css_ = __webpack_require__("aca2");

// CONCATENATED MODULE: ./src/components/BaseUnitInput.vue






/* normalize component */

var BaseUnitInput_component = normalizeComponent(
  components_BaseUnitInputvue_type_script_lang_js_,
  BaseUnitInputvue_type_template_id_0768c780_scoped_true_render,
  BaseUnitInputvue_type_template_id_0768c780_scoped_true_staticRenderFns,
  false,
  null,
  "0768c780",
  null
  
)

/* harmony default export */ var BaseUnitInput = (BaseUnitInput_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseSelect.vue?vue&type=template&id=6679e92a&scoped=true&
var BaseSelectvue_type_template_id_6679e92a_scoped_true_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-container",class:( _obj = {
    disabled: _vm.disabled
  }, _obj[("size-" + _vm.size)] = true, _obj['select-invalid'] =  _vm.invalid, _obj )},[_c('select',{staticClass:"qrw-input-text",class:_vm.dynamicClass,attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"blur":function($event){return _vm.$emit('blur')}}},[_vm._t("default")],2),_c('BaseIcon',{staticClass:"select-arrow",class:{ active: _vm.isSelected },attrs:{"icon":"arrow-down","size":"xs"}})],1)}
var BaseSelectvue_type_template_id_6679e92a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseSelect.vue?vue&type=template&id=6679e92a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseSelect.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseSelectvue_type_script_lang_js_ = ({
  props: {
    value: [String, Number, Object, Array, Boolean],
    size: {
      type: String,
      default: "sm"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput: function onInput(ev) {
      this.$emit("input", ev.target.value);
    }
  },
  computed: {
    isSelected: function isSelected() {
      return this.value !== null && this.value !== undefined;
    },
    dynamicClass: function dynamicClass() {
      return {
        select: true,
        "select-active": this.isSelected,
        "select disabled": this.disabled,
        "qrw-input-text-lg": this.size == "lg"
      };
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseSelect.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseSelectvue_type_script_lang_js_ = (BaseSelectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseSelect.vue?vue&type=style&index=0&id=6679e92a&scoped=true&lang=css&
var BaseSelectvue_type_style_index_0_id_6679e92a_scoped_true_lang_css_ = __webpack_require__("d89b");

// CONCATENATED MODULE: ./src/components/BaseSelect.vue






/* normalize component */

var BaseSelect_component = normalizeComponent(
  components_BaseSelectvue_type_script_lang_js_,
  BaseSelectvue_type_template_id_6679e92a_scoped_true_render,
  BaseSelectvue_type_template_id_6679e92a_scoped_true_staticRenderFns,
  false,
  null,
  "6679e92a",
  null
  
)

/* harmony default export */ var BaseSelect = (BaseSelect_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LanguageSwitcher.vue?vue&type=template&id=6c19fffb&scoped=true&
var LanguageSwitchervue_type_template_id_6c19fffb_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-switcher"},[_vm._l((_vm.languageList),function(lang,index){return _c('div',{key:index},[_c('div',{staticClass:"available-lang",class:{ filled: lang.isFilled, selected: _vm.value === lang.name },on:{"click":function($event){return _vm.$emit('input', lang.name)}}},[_c('img',{attrs:{"src":("https://cdn.qrwaiter.com.ua/assets/flags/" + (lang.name) + "." + _vm.extension)}})])])}),_c('BaseDivider',{attrs:{"vertical":""}}),_c('img',{staticClass:"default-lang",class:{ selected: _vm.value === _vm.defaultLang },attrs:{"src":("https://cdn.qrwaiter.com.ua/assets/flags/" + _vm.defaultLang + "." + _vm.extension)},on:{"click":function($event){return _vm.$emit('input', _vm.defaultLang)}}})],2)}
var LanguageSwitchervue_type_template_id_6c19fffb_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/LanguageSwitcher.vue?vue&type=template&id=6c19fffb&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LanguageSwitcher.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var LanguageSwitchervue_type_script_lang_js_ = ({
  props: {
    languageList: [],
    value: String,
    defaultLang: String,
    extension: {
      type: String,
      default: "png"
    }
  }
});
// CONCATENATED MODULE: ./src/components/LanguageSwitcher.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_LanguageSwitchervue_type_script_lang_js_ = (LanguageSwitchervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/LanguageSwitcher.vue?vue&type=style&index=0&id=6c19fffb&scoped=true&lang=css&
var LanguageSwitchervue_type_style_index_0_id_6c19fffb_scoped_true_lang_css_ = __webpack_require__("d815");

// CONCATENATED MODULE: ./src/components/LanguageSwitcher.vue






/* normalize component */

var LanguageSwitcher_component = normalizeComponent(
  components_LanguageSwitchervue_type_script_lang_js_,
  LanguageSwitchervue_type_template_id_6c19fffb_scoped_true_render,
  LanguageSwitchervue_type_template_id_6c19fffb_scoped_true_staticRenderFns,
  false,
  null,
  "6c19fffb",
  null
  
)

/* harmony default export */ var LanguageSwitcher = (LanguageSwitcher_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseRangeInput.vue?vue&type=template&id=a94c5cac&scoped=true&
var BaseRangeInputvue_type_template_id_a94c5cac_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"range"}})}
var BaseRangeInputvue_type_template_id_a94c5cac_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseRangeInput.vue?vue&type=template&id=a94c5cac&scoped=true&

// EXTERNAL MODULE: ./src/components/BaseRangeInput.vue?vue&type=style&index=0&id=a94c5cac&scoped=true&lang=css&
var BaseRangeInputvue_type_style_index_0_id_a94c5cac_scoped_true_lang_css_ = __webpack_require__("d2e3");

// CONCATENATED MODULE: ./src/components/BaseRangeInput.vue

var BaseRangeInput_script = {}



/* normalize component */

var BaseRangeInput_component = normalizeComponent(
  BaseRangeInput_script,
  BaseRangeInputvue_type_template_id_a94c5cac_scoped_true_render,
  BaseRangeInputvue_type_template_id_a94c5cac_scoped_true_staticRenderFns,
  false,
  null,
  "a94c5cac",
  null
  
)

/* harmony default export */ var BaseRangeInput = (BaseRangeInput_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PhoneInput.vue?vue&type=template&id=292d84c0&scoped=true&
var PhoneInputvue_type_template_id_292d84c0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phone-input-wrapper"},[_c('BaseSelect',{staticClass:"phone-select",attrs:{"placeholder":"+380"},model:{value:(_vm.phoneSelect),callback:function ($$v) {_vm.phoneSelect=$$v},expression:"phoneSelect"}},[_c('option',{attrs:{"selected":""},domProps:{"value":_vm.phoneSelect}},[_vm._v("+380")]),_c('option',{attrs:{"value":"+123"}},[_vm._v("+123")]),_c('option',{attrs:{"value":"+228"}},[_vm._v("+228")])]),_c('BaseInput',{attrs:{"placeholder":"__ ___ __ __"}})],1)}
var PhoneInputvue_type_template_id_292d84c0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/PhoneInput.vue?vue&type=template&id=292d84c0&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PhoneInput.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PhoneInputvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      phoneSelect: '123'
    };
  }
});
// CONCATENATED MODULE: ./src/components/PhoneInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_PhoneInputvue_type_script_lang_js_ = (PhoneInputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/PhoneInput.vue?vue&type=style&index=0&id=292d84c0&scoped=true&lang=css&
var PhoneInputvue_type_style_index_0_id_292d84c0_scoped_true_lang_css_ = __webpack_require__("f337");

// CONCATENATED MODULE: ./src/components/PhoneInput.vue






/* normalize component */

var PhoneInput_component = normalizeComponent(
  components_PhoneInputvue_type_script_lang_js_,
  PhoneInputvue_type_template_id_292d84c0_scoped_true_render,
  PhoneInputvue_type_template_id_292d84c0_scoped_true_staticRenderFns,
  false,
  null,
  "292d84c0",
  null
  
)

/* harmony default export */ var PhoneInput = (PhoneInput_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseUnitSelect.vue?vue&type=template&id=68f230e8&scoped=true&
var BaseUnitSelectvue_type_template_id_68f230e8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unit-input-wrapper"},[_c('BaseSelect',{attrs:{"disabled":_vm.disabled,"valid":_vm.valid,"value":_vm.value},on:{"input":_vm.onSelect}},[_vm._t("default")],2),_c('BaseInput',{staticClass:"unit-box",attrs:{"hasUnit":"","disabled":"","placeholder":_vm.unitPlaceholder}})],1)}
var BaseUnitSelectvue_type_template_id_68f230e8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseUnitSelect.vue?vue&type=template&id=68f230e8&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseUnitSelect.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseUnitSelectvue_type_script_lang_js_ = ({
  props: {
    type: {
      type: String,
      default: "text"
    },
    unitPlaceholder: String,
    placeholder: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: [String, Number, Object],
    valid: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onSelect: function onSelect(ev) {
      this.$emit("input", ev);
    }
  }
});
// CONCATENATED MODULE: ./src/components/BaseUnitSelect.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseUnitSelectvue_type_script_lang_js_ = (BaseUnitSelectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseUnitSelect.vue?vue&type=style&index=0&id=68f230e8&scoped=true&lang=css&
var BaseUnitSelectvue_type_style_index_0_id_68f230e8_scoped_true_lang_css_ = __webpack_require__("4d49");

// CONCATENATED MODULE: ./src/components/BaseUnitSelect.vue






/* normalize component */

var BaseUnitSelect_component = normalizeComponent(
  components_BaseUnitSelectvue_type_script_lang_js_,
  BaseUnitSelectvue_type_template_id_68f230e8_scoped_true_render,
  BaseUnitSelectvue_type_template_id_68f230e8_scoped_true_staticRenderFns,
  false,
  null,
  "68f230e8",
  null
  
)

/* harmony default export */ var BaseUnitSelect = (BaseUnitSelect_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2dafcee5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseSmartScroller.vue?vue&type=template&id=33e67953&
var BaseSmartScrollervue_type_template_id_33e67953_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canShow)?_c('div',{ref:"wrapper",staticClass:"smart-scroller-wrapper"},[_c('div',{ref:"control",staticClass:"smart-scroller-control",on:{"mousedown":_vm.onControlMouseDown,"mouseup":_vm.onControlMouseUp,"mouseleave":_vm.onControlMouseLeave}})]):_vm._e()}
var BaseSmartScrollervue_type_template_id_33e67953_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseSmartScroller.vue?vue&type=template&id=33e67953&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseSmartScroller.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var BaseSmartScrollervue_type_script_lang_js_ = ({
  props: {
    selector: String,
    element: Object,
    speed: {
      type: Number,
      default: 2
    }
  },
  data: function data() {
    return {
      el: null,
      canShow: false,
      grabbing: false
    };
  },
  watch: {
    'canShow': function canShow() {
      this.$emit('checked', this.canShow);
    }
  },
  methods: {
    fetchElement: function fetchElement() {
      this.el = this.element || document.querySelector(this.selector) || null;

      if (this.el) {
        this.check();
        this.el.addEventListener('scroll', this.onTargetScrolled);

        if (this.canShow) {
          this.$nextTick(this.onTargetScrolled);
        }
      }
    },
    check: function check() {
      this.canShow = this.el.scrollWidth > this.el.getBoundingClientRect().width;
    },
    onControlMouseDown: function onControlMouseDown() {
      this.grabbing = true;
    },
    onControlMouseUp: function onControlMouseUp() {
      this.grabbing = false;
    },
    onTargetScrolled: function onTargetScrolled() {
      this.check();
      if (!this.canShow) return;
      var controlEl = this.$refs.control;
      var currentControlWidth = controlEl.getBoundingClientRect().width;
      var ratio = this.el.scrollLeft / (this.el.scrollWidth - this.el.getBoundingClientRect().width);
      var fullScrollerWidth = this.$refs.wrapper.getBoundingClientRect().width;
      var newPosition = Math.round(ratio * (fullScrollerWidth - currentControlWidth));
      controlEl.style.left = "".concat(newPosition, "px");
      var newControlWidth = this.el.getBoundingClientRect().width / this.el.scrollWidth * fullScrollerWidth;
      controlEl.style.width = "".concat(newControlWidth, "px");
    },
    onControlMouseLeave: function onControlMouseLeave() {},
    onControlMouseMove: function onControlMouseMove(ev) {
      if (!this.grabbing || !this.canShow) return;
      var xDelta = ev.movementX;
      if (!xDelta) return;
      var xMovement = xDelta * this.speed;

      if (xDelta > 0) {
        this.el.scrollLeft = Math.min(this.el.scrollWidth, this.el.scrollLeft + xMovement);
      } else {
        this.el.scrollLeft = Math.max(0, this.el.scrollLeft + xMovement);
      }

      this.onTargetScrolled();
      ev.preventDefault();
    }
  },
  mounted: function mounted() {
    this.$nextTick(this.fetchElement);
    window.addEventListener('mouseup', this.onControlMouseUp);
    window.addEventListener('mousemove', this.onControlMouseMove);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('mouseup', this.onControlMouseUp);
    window.removeEventListener('mousemove', this.onControlMouseMove);
    if (this.el) this.el.removeEventListener('scroll', this.onTargetScrolled);
  }
});
// CONCATENATED MODULE: ./src/components/BaseSmartScroller.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseSmartScrollervue_type_script_lang_js_ = (BaseSmartScrollervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseSmartScroller.vue?vue&type=style&index=0&lang=css&
var BaseSmartScrollervue_type_style_index_0_lang_css_ = __webpack_require__("0bec");

// CONCATENATED MODULE: ./src/components/BaseSmartScroller.vue






/* normalize component */

var BaseSmartScroller_component = normalizeComponent(
  components_BaseSmartScrollervue_type_script_lang_js_,
  BaseSmartScrollervue_type_template_id_33e67953_render,
  BaseSmartScrollervue_type_template_id_33e67953_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var BaseSmartScroller = (BaseSmartScroller_component.exports);
// CONCATENATED MODULE: ./node_modules/v-mask/dist/v-mask.esm.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function v_mask_esm_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        v_mask_esm_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var placeholderChar = '_';
var strFunction = 'function';

var emptyArray = [];
function convertMaskToPlaceholder() {
  var mask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyArray;
  var placeholderChar$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : placeholderChar;

  if (!isArray(mask)) {
    throw new Error('Text-mask:convertMaskToPlaceholder; The mask property must be an array.');
  }

  if (mask.indexOf(placeholderChar$1) !== -1) {
    throw new Error('Placeholder character must not be used as part of the mask. Please specify a character ' + 'that is not present in your mask as your placeholder character.\n\n' + "The placeholder character that was received is: ".concat(JSON.stringify(placeholderChar$1), "\n\n") + "The mask that was received is: ".concat(JSON.stringify(mask)));
  }

  return mask.map(function (char) {
    return char instanceof RegExp ? placeholderChar$1 : char;
  }).join('');
}
function isArray(value) {
  return Array.isArray && Array.isArray(value) || value instanceof Array;
}
var strCaretTrap = '[]';
function processCaretTraps(mask) {
  var indexes = [];
  var indexOfCaretTrap;

  while (indexOfCaretTrap = mask.indexOf(strCaretTrap), indexOfCaretTrap !== -1) {
    indexes.push(indexOfCaretTrap);
    mask.splice(indexOfCaretTrap, 1);
  }

  return {
    maskWithoutCaretTraps: mask,
    indexes: indexes
  };
}

var emptyArray$1 = [];
var emptyString = '';
function conformToMask() {
  var rawValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyString;
  var mask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyArray$1;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!isArray(mask)) {
    if (_typeof(mask) === strFunction) {
      mask = mask(rawValue, config);
      mask = processCaretTraps(mask).maskWithoutCaretTraps;
    } else {
      throw new Error('Text-mask:conformToMask; The mask property must be an array.');
    }
  }

  var _config$guide = config.guide,
      guide = _config$guide === void 0 ? true : _config$guide,
      _config$previousConfo = config.previousConformedValue,
      previousConformedValue = _config$previousConfo === void 0 ? emptyString : _config$previousConfo,
      _config$placeholderCh = config.placeholderChar,
      placeholderChar$1 = _config$placeholderCh === void 0 ? placeholderChar : _config$placeholderCh,
      _config$placeholder = config.placeholder,
      placeholder = _config$placeholder === void 0 ? convertMaskToPlaceholder(mask, placeholderChar$1) : _config$placeholder,
      currentCaretPosition = config.currentCaretPosition,
      keepCharPositions = config.keepCharPositions;
  var suppressGuide = guide === false && previousConformedValue !== undefined;
  var rawValueLength = rawValue.length;
  var previousConformedValueLength = previousConformedValue.length;
  var placeholderLength = placeholder.length;
  var maskLength = mask.length;
  var editDistance = rawValueLength - previousConformedValueLength;
  var isAddition = editDistance > 0;
  var indexOfFirstChange = currentCaretPosition + (isAddition ? -editDistance : 0);
  var indexOfLastChange = indexOfFirstChange + Math.abs(editDistance);

  if (keepCharPositions === true && !isAddition) {
    var compensatingPlaceholderChars = emptyString;

    for (var i = indexOfFirstChange; i < indexOfLastChange; i++) {
      if (placeholder[i] === placeholderChar$1) {
        compensatingPlaceholderChars += placeholderChar$1;
      }
    }

    rawValue = rawValue.slice(0, indexOfFirstChange) + compensatingPlaceholderChars + rawValue.slice(indexOfFirstChange, rawValueLength);
  }

  var rawValueArr = rawValue.split(emptyString).map(function (char, i) {
    return {
      char: char,
      isNew: i >= indexOfFirstChange && i < indexOfLastChange
    };
  });

  for (var _i = rawValueLength - 1; _i >= 0; _i--) {
    var char = rawValueArr[_i].char;

    if (char !== placeholderChar$1) {
      var shouldOffset = _i >= indexOfFirstChange && previousConformedValueLength === maskLength;

      if (char === placeholder[shouldOffset ? _i - editDistance : _i]) {
        rawValueArr.splice(_i, 1);
      }
    }
  }

  var conformedValue = emptyString;
  var someCharsRejected = false;

  placeholderLoop: for (var _i2 = 0; _i2 < placeholderLength; _i2++) {
    var charInPlaceholder = placeholder[_i2];

    if (charInPlaceholder === placeholderChar$1) {
      if (rawValueArr.length > 0) {
        while (rawValueArr.length > 0) {
          var _rawValueArr$shift = rawValueArr.shift(),
              rawValueChar = _rawValueArr$shift.char,
              isNew = _rawValueArr$shift.isNew;

          if (rawValueChar === placeholderChar$1 && suppressGuide !== true) {
            conformedValue += placeholderChar$1;
            continue placeholderLoop;
          } else if (mask[_i2].test(rawValueChar)) {
            if (keepCharPositions !== true || isNew === false || previousConformedValue === emptyString || guide === false || !isAddition) {
              conformedValue += rawValueChar;
            } else {
              var rawValueArrLength = rawValueArr.length;
              var indexOfNextAvailablePlaceholderChar = null;

              for (var _i3 = 0; _i3 < rawValueArrLength; _i3++) {
                var charData = rawValueArr[_i3];

                if (charData.char !== placeholderChar$1 && charData.isNew === false) {
                  break;
                }

                if (charData.char === placeholderChar$1) {
                  indexOfNextAvailablePlaceholderChar = _i3;
                  break;
                }
              }

              if (indexOfNextAvailablePlaceholderChar !== null) {
                conformedValue += rawValueChar;
                rawValueArr.splice(indexOfNextAvailablePlaceholderChar, 1);
              } else {
                _i2--;
              }
            }

            continue placeholderLoop;
          } else {
            someCharsRejected = true;
          }
        }
      }

      if (suppressGuide === false) {
        conformedValue += placeholder.substr(_i2, placeholderLength);
      }

      break;
    } else {
      conformedValue += charInPlaceholder;
    }
  }

  if (suppressGuide && isAddition === false) {
    var indexOfLastFilledPlaceholderChar = null;

    for (var _i4 = 0; _i4 < conformedValue.length; _i4++) {
      if (placeholder[_i4] === placeholderChar$1) {
        indexOfLastFilledPlaceholderChar = _i4;
      }
    }

    if (indexOfLastFilledPlaceholderChar !== null) {
      conformedValue = conformedValue.substr(0, indexOfLastFilledPlaceholderChar + 1);
    } else {
      conformedValue = emptyString;
    }
  }

  return {
    conformedValue: conformedValue,
    meta: {
      someCharsRejected: someCharsRejected
    }
  };
}

var NEXT_CHAR_OPTIONAL = {
  __nextCharOptional__: true
};
var defaultMaskReplacers = {
  '#': /\d/,
  A: /[a-z]/i,
  N: /[a-z0-9]/i,
  '?': NEXT_CHAR_OPTIONAL,
  X: /./
};

var stringToRegexp = function stringToRegexp(str) {
  var lastSlash = str.lastIndexOf('/');
  return new RegExp(str.slice(1, lastSlash), str.slice(lastSlash + 1));
};

var makeRegexpOptional = function makeRegexpOptional(charRegexp) {
  return stringToRegexp(charRegexp.toString().replace(/.(\/)[gmiyus]{0,6}$/, function (match) {
    return match.replace('/', '?/');
  }));
};

var escapeIfNeeded = function escapeIfNeeded(char) {
  return '[\\^$.|?*+()'.indexOf(char) > -1 ? "\\".concat(char) : char;
};

var charRegexp = function charRegexp(char) {
  return new RegExp("/[".concat(escapeIfNeeded(char), "]/"));
};

var isRegexp = function isRegexp(entity) {
  return entity instanceof RegExp;
};

var castToRegexp = function castToRegexp(char) {
  return isRegexp(char) ? char : charRegexp(char);
};

function maskToRegExpMask(mask) {
  var maskReplacers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskReplacers;
  return mask.map(function (char, index, array) {
    var maskChar = maskReplacers[char] || char;
    var previousChar = array[index - 1];
    var previousMaskChar = maskReplacers[previousChar] || previousChar;

    if (maskChar === NEXT_CHAR_OPTIONAL) {
      return null;
    }

    if (previousMaskChar === NEXT_CHAR_OPTIONAL) {
      return makeRegexpOptional(castToRegexp(maskChar));
    }

    return maskChar;
  }).filter(Boolean);
}

function stringMaskToRegExpMask(stringMask) {
  var maskReplacers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskReplacers;
  return maskToRegExpMask(stringMask.split(''), maskReplacers);
}
function arrayMaskToRegExpMask(arrayMask) {
  var maskReplacers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskReplacers;
  var flattenedMask = arrayMask.map(function (part) {
    if (part instanceof RegExp) {
      return part;
    }

    if (typeof part === 'string') {
      return part.split('');
    }

    return null;
  }).filter(Boolean).reduce(function (mask, part) {
    return mask.concat(part);
  }, []);
  return maskToRegExpMask(flattenedMask, maskReplacers);
}

var trigger = function trigger(el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};
var queryInputElementInside = function queryInputElementInside(el) {
  return el instanceof HTMLInputElement ? el : el.querySelector('input') || el;
};
var isFunction = function isFunction(val) {
  return typeof val === 'function';
};
var isString = function isString(val) {
  return typeof val === 'string';
};
var isRegexp$1 = function isRegexp(val) {
  return val instanceof RegExp;
};

function createOptions() {
  var elementOptions = new Map();
  var defaultOptions = {
    previousValue: '',
    mask: []
  };

  function get(el) {
    return elementOptions.get(el) || _objectSpread2({}, defaultOptions);
  }

  function partiallyUpdate(el, newOptions) {
    elementOptions.set(el, _objectSpread2(_objectSpread2({}, get(el)), newOptions));
  }

  function remove(el) {
    elementOptions.delete(el);
  }

  return {
    partiallyUpdate: partiallyUpdate,
    remove: remove,
    get: get
  };
}

var v_mask_esm_options = createOptions();

function triggerInputUpdate(el) {
  trigger(el, 'input');
}

function updateValue(el) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var value = el.value;

  var _options$get = v_mask_esm_options.get(el),
      previousValue = _options$get.previousValue,
      mask = _options$get.mask;

  var isValueChanged = value !== previousValue;
  var isLengthIncreased = value.length > previousValue.length;
  var isUpdateNeeded = value && isValueChanged && isLengthIncreased;

  if ((force || isUpdateNeeded) && mask) {
    var _conformToMask = conformToMask(value, mask, {
      guide: false
    }),
        conformedValue = _conformToMask.conformedValue;

    el.value = conformedValue;
    triggerInputUpdate(el);
  }

  v_mask_esm_options.partiallyUpdate(el, {
    previousValue: value
  });
}

function updateMask(el, inputMask, maskReplacers) {
  var mask;

  if (Array.isArray(inputMask)) {
    mask = arrayMaskToRegExpMask(inputMask, maskReplacers);
  } else if (isFunction(inputMask)) {
    mask = inputMask;
  } else if (isString(inputMask) && inputMask.length > 0) {
    mask = stringMaskToRegExpMask(inputMask, maskReplacers);
  } else {
    mask = inputMask;
  }

  v_mask_esm_options.partiallyUpdate(el, {
    mask: mask
  });
}

function extendMaskReplacers(maskReplacers) {
  var baseMaskReplacers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskReplacers;

  if (maskReplacers === null || Array.isArray(maskReplacers) || _typeof(maskReplacers) !== 'object') {
    return baseMaskReplacers;
  }

  return Object.keys(maskReplacers).reduce(function (extendedMaskReplacers, key) {
    var value = maskReplacers[key];

    if (value !== null && !(value instanceof RegExp)) {
      return extendedMaskReplacers;
    }

    return _objectSpread2(_objectSpread2({}, extendedMaskReplacers), {}, v_mask_esm_defineProperty({}, key, value));
  }, baseMaskReplacers);
}

function maskToString(mask) {
  var maskArray = Array.isArray(mask) ? mask : [mask];
  var filteredMaskArray = maskArray.filter(function (part) {
    return isString(part) || isRegexp$1(part);
  });
  return filteredMaskArray.toString();
}

function createDirective() {
  var directiveOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var instanceMaskReplacers = extendMaskReplacers(directiveOptions && directiveOptions.placeholders);
  return {
    bind: function bind(el, _ref) {
      var value = _ref.value;
      el = queryInputElementInside(el);
      updateMask(el, value, instanceMaskReplacers);
      updateValue(el);
    },
    componentUpdated: function componentUpdated(el, _ref2) {
      var value = _ref2.value,
          oldValue = _ref2.oldValue;
      el = queryInputElementInside(el);
      var isMaskChanged = isFunction(value) || maskToString(oldValue) !== maskToString(value);

      if (isMaskChanged) {
        updateMask(el, value, instanceMaskReplacers);
      }

      updateValue(el, isMaskChanged);
    },
    unbind: function unbind(el) {
      el = queryInputElementInside(el);
      v_mask_esm_options.remove(el);
    }
  };
}
var directive = createDirective();

var filter = (function (value, stringMask) {
  var mask = stringMaskToRegExpMask(stringMask);
  if (!isString(value) && !Number.isFinite(value)) return value;

  var _conformToMask = conformToMask("".concat(value), mask, {
    guide: false
  }),
      conformedValue = _conformToMask.conformedValue;

  return conformedValue;
});

var v_mask_esm_plugin = (function (Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Vue.directive('mask', createDirective(options));
  Vue.filter('VMask', filter);
});

/* harmony default export */ var v_mask_esm = (v_mask_esm_plugin);


// CONCATENATED MODULE: ./src/index.js

























var QRWaiterUIKit = {
  install: function install(Vue, _options) {
    var options = _options || {};
    Vue.use(v_mask_esm);
    if (options.disableGlobalComponents) return;
    Vue.component('BaseButton', BaseButton);
    Vue.component('BaseCheckbox', BaseCheckbox);
    Vue.component('BaseDatepicker', BaseDatepicker);
    Vue.component('BaseRadioButton', BaseRadioButton);
    Vue.component('BaseHeader', BaseHeader);
    Vue.component('BaseTab', BaseTab);
    Vue.component('BaseInput', BaseInput);
    Vue.component('BaseTabSwitcher', BaseTabSwitcher);
    Vue.component('BaseInput', BaseInput);
    Vue.component('BaseTextDivider', BaseTextDivider);
    Vue.component('BaseIcon', BaseIcon);
    Vue.component('BaseToggleSwitcher', BaseToggleSwitcher);
    Vue.component('HorizontalScroll', HorizontalScroll);
    Vue.component('BaseDivider', BaseDivider);
    Vue.component('BaseTextarea', BaseTextarea);
    Vue.component('BaseUnitInput', BaseUnitInput);
    Vue.component('BaseSelect', BaseSelect);
    Vue.component('LanguageSwitcher', LanguageSwitcher);
    Vue.component('BaseRangeInput', BaseRangeInput);
    Vue.component('PhoneInput', PhoneInput);
    Vue.component('BaseUnitSelect', BaseUnitSelect);
    Vue.component('BaseSmartScroller', BaseSmartScroller);
  }
};
/* harmony default export */ var src_0 = (QRWaiterUIKit);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_0);



/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fcdf":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ })

/******/ });
//# sourceMappingURL=qrwaiter-ui-kit.common.js.map